var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessWelcomeBannerMobileOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 260.229,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y1: 0.16,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M42 0h126.372v174.415H42z",
    "data-name": "Rectangle 9435"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57484"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    "data-name": "Group 57474"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 182.732h54.42M0 178.617h51.036",
    "data-name": "Path 71987",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    "data-name": "Group 57486"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.188 182.732h-18.623M173.113 178.617h-19.151",
    "data-name": "Path 71987",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57481",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57322"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m226.854 63.223 20.2 3.574.012.007 13.235 2.332.009-.002.885.16h0l2.971.53h0l.525.095 1.94.343.352.063 1.334.238.268.043.59.105-.155-.33-14.632-31.555-5.12-.302-8.97-.526-.03-.005-9.6-.562-.025-.008-6.607-.385.584 5.411h0l.012.172.878 8.118.002.027.963 8.945Z",
    "data-name": "Path 2072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m240.298 37.997 28.288 32.608.59.106-.155-.33-19.751-31.857Z",
    "data-name": "Path 2073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m230.668 37.429 36.315 32.896 1.334.238-28.05-32.572Z",
    "data-name": "Path 2074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m224.62 42.445 14.697 10.175.18.124 24.67 17.08h0l.527.089 1.939.348-35.991-32.84-6.608-.385Z",
    "data-name": "Path 2075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M225.51 50.737 261.195 69.3h0l2.97.523h0l.53.094-25.198-17.175-.18-.124-14.686-10.002Z",
    "data-name": "Path 2076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m226.475 59.706 20.577 7.092.014-.004 13.236 2.344-34.793-18.376Z",
    "data-name": "Path 2077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m254.389 38.826-27.534 24.397",
    "data-name": "Line 256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m224.035 37.034 45.14 33.677",
    "data-name": "Line 257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M230.096 41.996s5.62 14.584 20.24 14.655",
    "data-name": "Path 2078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.914 69.725a60.27 60.27 0 0 0 7.75 5.64 23.014 23.014 0 0 0 5.805 2.623 8.961 8.961 0 0 1 4.243 2.295c1.174 1.234 2.25 4.279 1.203 5.986-1.15 1.879-3.578 2.662-5.373 3.217a50.462 50.462 0 0 1-6.866 1.485c-2.211.369-4.437.677-6.629 1.204a10.445 10.445 0 0 0-4.68 1.988 3.54 3.54 0 0 0-1.017 1.461 4.789 4.789 0 0 0-.186 1.103 4.161 4.161 0 0 0 .024.47c-.011.389-.566-1.33.042.155a11.479 11.479 0 0 0 2.319 3.734c2.688 2.789 6.502 3.75 9.984 4.268 5.06.747 10.74 1.154 15.67-.626a20.157 20.157 0 0 0 11.26-10.475 17.95 17.95 0 0 0 1.647-7.762 16.081 16.081 0 0 0-.154-1.952q-.08-.603-.209-1.185c.243 1.042-.122-.265-.312-.73a18.531 18.531 0 0 0-2.263-3.984c-.36-.49-.172-1.495-.523-1.975 3.926 5.396 5.24 13.184 2.316 19.57a20.28 20.28 0 0 1-7.684 8.728c-4.001 2.508-8.255 2.955-12.734 2.847-5.824-.142-14.06-.388-17.834-6.488a15.74 15.74 0 0 1-2.05-5.95c-.372-3.095 2.596-4.215 4.67-4.849 4.057-1.191 8.286-1.431 12.387-2.385 2.31-.536 8.811-1.857 8.069-5.978l.393 1.483-.065-.247.133.503a6.164 6.164 0 0 0-3.416-3.268c-2.036-.93-4.158-1.324-6.19-2.421a55.363 55.363 0 0 1-9.212-6.49c-.392-.334-.14-1.65-.522-1.971Z",
    "data-name": "Path 2080"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M269.272 70.819a41.674 41.674 0 0 0 7.594 8.456c1.292 1.105 3.584 2.033 4.253 3.824a4.29 4.29 0 0 1 .427 2.047c-.28.83-1.864 1.154-2.492 1.37-4.542 1.56-9.231 2.447-13.705 4.295-2.574 1.063-7.284 3.045-6.5 7.177l-.266-1.006a20.158 20.158 0 0 0 3.099 5.47 18.605 18.605 0 0 0 5.534 5.356 11.758 11.758 0 0 0 7.835 1.538c3.527-.537 6.611-2.66 9.812-4.279 2.821-1.425 5.718-2.69 8.452-4.332a12.387 12.387 0 0 0 4.987-4.737 10.891 10.891 0 0 0 .45-7.504c-1.181-4.25-3.086-8.283-4.613-12.383s-3.116-8.488-.642-12.5c-.203.33.742 1.617.522 1.97a8.571 8.571 0 0 0-1.378 3.785 9.876 9.876 0 0 0 .093 1.968q.047.341.126.676c-.172-.775-.051-.194 0 0 .194.59.402 1.177.614 1.762 1.731 4.743 3.848 9.344 5.198 14.266.832 3.064 1.715 6.481.356 9.544-1.448 3.304-4.803 4.995-7.567 6.455-2.01 1.04-4.054 1.982-6.065 3.016a77.033 77.033 0 0 1-6.953 3.556 12.246 12.246 0 0 1-11.297-1.172 21.687 21.687 0 0 1-6.643-7.73c-1.028-1.875-2.438-4.555-2.298-6.886.516-7.74 23.41-8.785 22.8-11.961l.522 1.976a3.779 3.779 0 0 0-1.469-1.447c-1.103-.826-2.207-1.634-3.248-2.569a42.159 42.159 0 0 1-7.04-7.958c-.341-.512-.188-1.462-.523-1.97Z",
    "data-name": "Path 2081"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M241.846 50.265c-40.075 72.051 29.935 57.79 23.775 128.38",
    "data-name": "Path 2079"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57482",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 587",
    transform: "translate(137.629 4.163)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "slider illustration",
    transform: "translate(-69.95 36.715)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.755 75.47a.122.122 0 0 0 .134-.105v-45.2h12.233v22.416h5.379v-15h8.634v22.886h5.194V46.862h3.709v14.226h2.73V47.605h3.33v13.482h5.573v-2.011h8.491v-17.43h13.588v17.279h21.482V30.006h15.259V42.84h9.352V27.971h14.322V61.86h3.677V44.398h12.991v8.8h6.993v18.867h8.1a.125.125 0 0 0 .135-.105.123.123 0 0 0-.135-.105h-7.821V52.99h-7.004v-8.809h-13.53v17.462h-3.139V27.761h-14.861v14.87h-8.822V29.798h-15.8v28.915h-20.94V41.434h-14.117v17.433h-8.491v2.014h-5.035V47.394h-3.868v13.481h-2.192V46.652h-4.247V60.26h-4.655V37.374h-9.169v15h-4.841V29.951H83.621v45.424a.127.127 0 0 0 .134.095Z",
    "data-name": "Path 1702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.239 57.84h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 57.84h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.315 57.84h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.854 57.84h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39 57.84h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.929 57.84h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.377 46.397h1.783V44.64h-1.783Zm1.514-.21h-1.245V44.85h1.245Z",
    "data-name": "Path 1709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.911 46.397h1.786V44.64h-1.786Zm1.517-.21h-1.248V44.85h1.248Z",
    "data-name": "Path 1710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 46.397h1.783V44.64h-1.783Zm1.514-.21h-1.245V44.85h1.245Z",
    "data-name": "Path 1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.989 46.397h1.786V44.64h-1.786Zm1.517-.21h-1.248V44.85h1.248Z",
    "data-name": "Path 1712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.377 43.607h1.783V41.85h-1.783Zm1.514-.21h-1.245V42.06h1.245Z",
    "data-name": "Path 1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.911 43.607h1.786V41.85h-1.786Zm1.517-.21h-1.248V42.06h1.248Z",
    "data-name": "Path 1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 43.607h1.783V41.85h-1.783Zm1.514-.21h-1.245V42.06h1.245Z",
    "data-name": "Path 1715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.989 43.607h1.786V41.85h-1.786Zm1.517-.21h-1.248V42.06h1.248Z",
    "data-name": "Path 1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.377 40.83h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.911 40.83h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 40.83h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.989 40.83h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.377 38.047h1.783V36.29h-1.783Zm1.514-.21h-1.245V36.5h1.245Z",
    "data-name": "Path 1721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.911 38.047h1.786V36.29h-1.786Zm1.517-.21h-1.248V36.5h1.248Z",
    "data-name": "Path 1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 38.047h1.783V36.29h-1.783Zm1.514-.21h-1.245V36.5h1.245Z",
    "data-name": "Path 1723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.989 38.047h1.786V36.29h-1.786Zm1.517-.21h-1.248V36.5h1.248Z",
    "data-name": "Path 1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.377 35.264h1.783v-1.755h-1.783Zm1.514-.21h-1.245v-1.335h1.245Z",
    "data-name": "Path 1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.911 35.264h1.786v-1.755h-1.786Zm1.517-.21h-1.248v-1.335h1.248Z",
    "data-name": "Path 1726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 35.264h1.783v-1.755h-1.783Zm1.514-.21h-1.245v-1.335h1.245Z",
    "data-name": "Path 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.989 35.264h1.786v-1.755h-1.786Zm1.517-.21h-1.248v-1.335h1.248Z",
    "data-name": "Path 1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.528 46.397h1.78V44.64h-1.78Zm1.514-.21h-1.245V44.85h1.245Z",
    "data-name": "Path 1729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.067 46.397h1.775V44.64h-1.783Zm1.514-.21h-1.245V44.85h1.237Z",
    "data-name": "Path 1730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.377 49.498h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.911 49.498h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 49.498h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.989 49.498h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.528 49.498h1.78v-1.757h-1.78Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.067 49.498h1.775v-1.757h-1.783Zm1.506-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.239 61.091h1.783v-1.76h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 61.091h1.783v-1.76h-1.783Zm1.514-.21h-1.244v-1.34h1.245Z",
    "data-name": "Path 1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.315 61.091h1.786v-1.76h-1.786Zm1.517-.21h-1.248v-1.34h1.251Z",
    "data-name": "Path 1739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.854 61.091h1.783v-1.76h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39 61.091h1.786v-1.76h-1.786Zm1.517-.21h-1.248v-1.34h1.248Z",
    "data-name": "Path 1741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.929 61.091h1.783v-1.76h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.239 64.337h1.783V62.58h-1.783Zm1.514-.21h-1.245V62.79h1.245Z",
    "data-name": "Path 1743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 64.337h1.783V62.58h-1.783Zm1.514-.21h-1.244V62.79h1.245Z",
    "data-name": "Path 1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.315 64.337h1.786V62.58h-1.786Zm1.517-.21h-1.248V62.79h1.251Z",
    "data-name": "Path 1745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.854 64.337h1.783V62.58h-1.783Zm1.514-.21h-1.245V62.79h1.245Z",
    "data-name": "Path 1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39 64.337h1.786V62.58h-1.786Zm1.517-.21h-1.248V62.79h1.248Z",
    "data-name": "Path 1747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.929 64.337h1.783V62.58h-1.783Zm1.514-.21h-1.245V62.79h1.245Z",
    "data-name": "Path 1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.239 67.591h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 67.591h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.315 67.591h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.854 67.591h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39 67.591h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.929 67.591h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.239 70.831h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 70.831h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.315 70.831h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.854 70.831h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39 70.831h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.929 70.831h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 34.954h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 34.954h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 34.954h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 38.821h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 38.821h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 38.821h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 42.686h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 42.686h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 42.686h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 46.553h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.244v-1.34h1.245Z",
    "data-name": "Path 1773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 50.417h1.786v-1.761h-1.786Zm1.517-.21h-1.248v-1.34h1.251Z",
    "data-name": "Path 1774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 54.285h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 58.149h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 62.016h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.872 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.244v-1.337h1.245Z",
    "data-name": "Path 1785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.408 65.883h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.251Z",
    "data-name": "Path 1786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 42.686h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 42.686h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.529 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.384 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92 46.553h1.79v-1.757h-1.79Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.384 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92 50.417h1.79v-1.761h-1.79Zm1.517-.21h-1.248v-1.34h1.248Z",
    "data-name": "Path 1804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.384 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92 54.285h1.79v-1.757h-1.79Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.384 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92 58.149h1.79v-1.757h-1.79Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.384 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92 62.016h1.79v-1.757h-1.79Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.384 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92 65.883h1.79v-1.757h-1.79Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 46.553h1.781v-1.757h-1.781Zm1.512-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 46.553h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 50.417h1.781v-1.761h-1.781Zm1.514-.21h-1.245v-1.34h1.242Z",
    "data-name": "Path 1815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 50.417h1.786v-1.761h-1.786Zm1.517-.21h-1.248v-1.34h1.248Z",
    "data-name": "Path 1816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 54.285h1.781v-1.757h-1.781Zm1.514-.21h-1.245v-1.337h1.242Z",
    "data-name": "Path 1817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 54.285h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 58.149h1.781v-1.757h-1.781Zm1.514-.21h-1.245v-1.337h1.242Z",
    "data-name": "Path 1819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 58.149h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 62.016h1.781v-1.757h-1.781Zm1.514-.21h-1.245v-1.337h1.242Z",
    "data-name": "Path 1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 62.016h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 65.883h1.781v-1.757h-1.781Zm1.514-.21h-1.245v-1.337h1.242Z",
    "data-name": "Path 1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 65.883h1.786v-1.757h-1.786Zm1.517-.21h-1.248v-1.337h1.248Z",
    "data-name": "Path 1824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 34.954h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 34.954h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 38.821h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 38.821h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 42.686h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 42.686h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 46.553h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 50.417h1.783v-1.761h-1.783Zm1.514-.21h-1.245v-1.34h1.245Z",
    "data-name": "Path 1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 54.285h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 58.149h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 62.016h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.509 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.048 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.947 65.883h1.783v-1.757h-1.783Zm1.514-.21h-1.245v-1.337h1.245Z",
    "data-name": "Path 1843"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.164,
    cy: 3.108,
    fill: "#ecf0f1",
    "data-name": "Ellipse 32",
    rx: 31.164,
    ry: 3.108,
    transform: "translate(121.332 165.112)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m302.856 141.77-2.081 1.268-2.081-1.268-2.081 1.268-2.081-1.268-2.078 1.268v1.681h10.4Z",
    "data-name": "Path 62423",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    "data-name": "freepik--City--inject-351",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.562 84.054a.123.123 0 0 1-.134-.105v-45.2h-12.232v22.416h-5.379v-15h-8.633v22.886h-5.194V55.446h-3.709v14.226h-2.73V56.189h-3.33v13.482h-5.573V67.66h-8.491V50.23h-13.588v17.279h-21.481V38.59h-15.261v12.834h-9.352V36.555h-14.322v33.889h-3.677V52.982h-12.99v8.8h-6.993v18.867h-8.1a.125.125 0 0 1-.135-.105.123.123 0 0 1 .135-.105h7.821V61.574h7.006v-8.809h13.529v17.462h3.139V36.345h14.86v14.87h8.822V38.382h15.8v28.915h20.935V50.018h14.118v17.433h8.491v2.014h5.035V55.978h3.868v13.481h2.192V55.236h4.247v13.608h4.656V45.958h9.169v15h4.841V38.535h12.773v45.424a.127.127 0 0 1-.133.095Z",
    "data-name": "Path 1702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.078 66.424h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.539 66.424h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.003 66.424h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.464 66.424h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 66.424h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.388 66.424h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94 54.981h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.407 54.981h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.865 54.981h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.329 54.981h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94 52.191h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.407 52.191h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.865 52.191h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.329 52.191h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94 49.414h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.407 49.414h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.865 49.414h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.329 49.414h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94 46.631h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.407 46.631h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.865 46.631h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.329 46.631h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94 43.848h-1.783v-1.755h1.783Zm-1.514-.21h1.245v-1.335h-1.245Z",
    "data-name": "Path 1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.407 43.848h-1.786v-1.755h1.786Zm-1.517-.21h1.248v-1.335h-1.248Z",
    "data-name": "Path 1726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.865 43.848h-1.783v-1.755h1.783Zm-1.514-.21h1.245v-1.335h-1.245Z",
    "data-name": "Path 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.329 43.848h-1.786v-1.755h1.786Zm-1.517-.21h1.248v-1.335h-1.248Z",
    "data-name": "Path 1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.786 54.981h-1.78v-1.757h1.78Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25 54.981h-1.775v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.237Z",
    "data-name": "Path 1730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94 58.082h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.407 58.082h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.865 58.082h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.329 58.082h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.786 58.082h-1.78v-1.757h1.78Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25 58.082h-1.775v-1.757h1.783Zm-1.506-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.078 69.675h-1.783v-1.76h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.539 69.675h-1.783v-1.76h1.783Zm-1.514-.21h1.245v-1.34h-1.244Z",
    "data-name": "Path 1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.003 69.675h-1.786v-1.76h1.786Zm-1.517-.21h1.251v-1.34h-1.248Z",
    "data-name": "Path 1739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.464 69.675h-1.783v-1.76h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 69.675h-1.786v-1.76h1.786Zm-1.517-.21h1.248v-1.34h-1.248Z",
    "data-name": "Path 1741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.388 69.675h-1.783v-1.76h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.078 72.921h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.539 72.921h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.003 72.921h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.464 72.921h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 72.921h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.388 72.921h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.078 76.175h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.539 76.175h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.003 76.175h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.464 76.175h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 76.175h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.388 76.175h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.078 79.415h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.539 79.415h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.003 79.415h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.464 79.415h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 79.415h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.388 79.415h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 43.538h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 43.538h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 43.538h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 47.405h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 47.405h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 47.405h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 51.27h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 51.27h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 51.27h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.244Z",
    "data-name": "Path 1770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 55.137h-1.786V53.38h1.786Zm-1.517-.21h1.251V53.59h-1.248Z",
    "data-name": "Path 1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.244Z",
    "data-name": "Path 1773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 59.001h-1.786V57.24h1.786Zm-1.517-.21h1.251v-1.34h-1.248Z",
    "data-name": "Path 1774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 62.869h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 66.733h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.244Z",
    "data-name": "Path 1782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 70.6h-1.786v-1.757h1.786Zm-1.517-.21h1.251v-1.337h-1.248Z",
    "data-name": "Path 1783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.446 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.244Z",
    "data-name": "Path 1785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91 74.467h-1.786V72.71h1.786Zm-1.517-.21h1.251V72.92h-1.248Z",
    "data-name": "Path 1786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 51.27h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 51.27h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.328 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.245Z",
    "data-name": "Path 1799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.788 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.245Z",
    "data-name": "Path 1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.934 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.402 55.137h-1.79V53.38h1.79Zm-1.517-.21h1.248V53.59h-1.248Z",
    "data-name": "Path 1802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.934 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.402 59.001h-1.79V57.24h1.79Zm-1.517-.21h1.248v-1.34h-1.248Z",
    "data-name": "Path 1804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.934 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.402 62.869h-1.79v-1.757h1.79Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.934 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.402 66.733h-1.79v-1.757h1.79Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.934 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.402 70.6h-1.79v-1.757h1.79Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.934 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.245Z",
    "data-name": "Path 1811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.402 74.467h-1.79V72.71h1.79Zm-1.517-.21h1.248V72.92h-1.248Z",
    "data-name": "Path 1812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.509 55.137h-1.78V53.38h1.783Zm-1.511-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.973 55.137h-1.786V53.38h1.786Zm-1.517-.21h1.248V53.59h-1.248Z",
    "data-name": "Path 1814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.509 59.001h-1.78V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.242Z",
    "data-name": "Path 1815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.973 59.001h-1.786V57.24h1.786Zm-1.517-.21h1.248v-1.34h-1.248Z",
    "data-name": "Path 1816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.509 62.869h-1.78v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.242Z",
    "data-name": "Path 1817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.973 62.869h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.509 66.733h-1.78v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.242Z",
    "data-name": "Path 1819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.973 66.733h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.509 70.6h-1.78v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.242Z",
    "data-name": "Path 1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.973 70.6h-1.786v-1.757h1.786Zm-1.517-.21h1.248v-1.337h-1.248Z",
    "data-name": "Path 1822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.509 74.467h-1.78V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.242Z",
    "data-name": "Path 1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.973 74.467h-1.786V72.71h1.786Zm-1.517-.21h1.248V72.92h-1.248Z",
    "data-name": "Path 1824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 43.538h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 43.538h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 47.405h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 47.405h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 51.27h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 51.27h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 55.137h-1.783V53.38h1.783Zm-1.514-.21h1.245V53.59h-1.245Z",
    "data-name": "Path 1832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 59.001h-1.783V57.24h1.783Zm-1.514-.21h1.245v-1.34h-1.245Z",
    "data-name": "Path 1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 62.869h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 66.733h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 70.6h-1.783v-1.757h1.783Zm-1.514-.21h1.245v-1.337h-1.245Z",
    "data-name": "Path 1840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.809 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.245Z",
    "data-name": "Path 1841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.245Z",
    "data-name": "Path 1842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.371 74.467h-1.783V72.71h1.783Zm-1.514-.21h1.245V72.92h-1.245Z",
    "data-name": "Path 1843"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 90",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.723 52.105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M130.619 71.797c-.287-1.927-4.271.965-4.271.965a8.953 8.953 0 0 0 .854-3.615c0-1.927-2.835.48-2.835.48a11.909 11.909 0 0 0 1.71-6.5c-.283-3.372-4.558.482-4.558.482s1.71-5.065 1.994-6.507-7.972 1.687-7.972 1.687a40.079 40.079 0 0 0 .854-4.337c.148-1.109-1.26-.648-2.684.069-.315-.965-1.156-1.032-2.092-.73.06-.24.126-.5.2-.781.315-1.3-1.871.165-3.689 1.549a6.984 6.984 0 0 0-2.551-4.444c-1.376-1.165-2.86.133-4.095 1.957l-2.044.533a11.399 11.399 0 0 0-.126-1.04c-.369-2.18-2.52.171-4 2.106l-1.575.411a9.618 9.618 0 0 0-2.388-4.926c-2.561-2.65-8.543 4.82-8.543 4.82s-3.7-5.065-5.125-2.4.57 8.194.57 8.194-.854-1.93-1.991-2.4-4.271 1.685-4.271 1.685 1.707-3.372 0-4.577c-1.547-1.09-3.553 2.743-3.925 3.489a10.238 10.238 0 0 0 .507-6.381c-.854-3.855-4.271 1.2-4.271 1.2s.57-4.819-2.561-5.542 1.424 0-1.71 4.82-1.991-3.372-6.549-2.892-3.414 14.941-3.414 14.941l-17.964-8.7s-.854-1.447-3.745-1.885-1.093 3.335-1.093 3.335-3.988-3.132-5.7-3.132c-.444 0-1.808 1.671-3.585 4.145-.129-.253-.261-.512-.4-.773-1.08-2.007-1.994 2.482-2.375 4.777l-.315.461c-.23-1.133-.9-3.079-2.721-3.079-2.2 0-1.036 6.43-.668 8.215v.021c-.284-1.016-1.1-3.465-2.451-3.66-1.707-.24-.287 5.3-.287 5.3a4.784 4.784 0 0 0-1.991-.722c-.63 0 .243 3.361.772 5.251-1.8 2.826-3.014 4.785-3.014 4.785l11.34-5.217h59.593l-2.882 3.375h56.881s1.44-2.881 1.156-4.813Z",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M70.143 79.124c-.742-2.474-1.957-5.544-3.651-6.691-3.007-2.037-7.9 1.165-10.53-.291s3.007-15.709-6.026-16.58-12.414 13.673-16.553 15.125-5.643-3.78-11.285-4.07c-4.932-.267-14.466 9.938-16.785 12.507Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M70.143 79.124c-.742-2.474-1.957-5.544-3.651-6.691-3.007-2.037-7.9 1.165-10.53-.291s3.007-15.709-6.026-16.58-12.414 13.673-16.553 15.125-5.643-3.78-11.285-4.07c-4.932-.267-14.466 9.938-16.785 12.507Z",
    "data-name": "Path 2175",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M49.759 76.563h2.084l1.269-38.652 2.674-6.773-2.813 4.454.415-4.35 4.5-7.7-4.326 4.809-.374-11.532-.577 7.1-2.128-1.066 1.865 2.372-.508 8.4-1.684-2.237 1.449 3.98Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M21.904 76.563h2.084l1.269-38.652 2.671-6.76-2.814 4.454.419-4.35 4.51-7.706-4.339 4.8-.371-11.532-.59 7.1-2.128-1.066 1.865 2.372-.507 8.4-1.687-2.237 1.453 3.98Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M81.291 76.563h2.084l1.269-29.709 2.683-5.179-2.816 3.42.415-3.343 4.5-5.944-4.339 3.705-.374-8.861-.6 5.457-2.125-.816 1.865 1.821-.511 6.454-1.684-1.719 1.449 3.058Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M57.113 76.563h2.084l1.269-29.709 2.68-5.179-2.813 3.423.415-3.343 4.5-5.944-4.339 3.705-.374-8.861-.59 5.457-2.128-.816 1.868 1.821-.511 6.454-1.684-1.719 1.449 3.058Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M72.945 76.563h2.081l1.269-29.709 2.683-5.179-2.817 3.423.419-3.343 4.5-5.944-4.339 3.705-.374-8.861-.587 5.457-2.125-.817 1.865 1.821-.508 6.454-1.687-1.719 1.453 3.058Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M118.7 76.568h2.084l1.269-38.652 2.671-6.76-2.813 4.454.416-4.35 4.5-7.7-4.339 4.8-.374-11.532-.584 7.1-2.128-1.066 1.865 2.372-.507 8.4-1.684-2.236 1.449 3.98Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M106.258 76.563h2.08l1.269-38.652 2.674-6.76-2.817 4.454.419-4.35 4.52-7.706-4.339 4.8-.374-11.532-.587 7.1-2.128-1.066 1.865 2.372-.508 8.4-1.687-2.237 1.453 3.98Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M84.785 76.563h2.081l1.269-38.652 2.671-6.76-2.816 4.454.419-4.35 4.513-7.706-4.339 4.8-.362-11.532-.587 7.1-2.128-1.066 1.865 2.372-.508 8.4-1.687-2.237 1.453 3.98Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M116.107 79.124c-.634-2.474-1.694-5.544-3.156-6.691-2.6-2.037-6.838 1.165-9.116-.291s2.6-15.709-5.208-16.58-10.743 13.672-14.324 15.125-4.884-3.78-9.766-4.07c-4.269-.267-12.519 9.938-14.527 12.507Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.107 79.124c-.634-2.474-1.694-5.544-3.156-6.691-2.6-2.037-6.838 1.165-9.116-.291s2.6-15.709-5.208-16.58-10.743 13.672-14.324 15.125-4.884-3.78-9.766-4.07c-4.269-.267-12.519 9.938-14.527 12.507Z",
    "data-name": "Path 2185",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M80.469 18.068s-4.507 0-5.82 6.155 2.065 7.73-2.068 10.892-4.694 5.369-2.629 6.789 3.194 3 .565 5.366-3.007 5.84 6.385 8.05 16.528-3.156 16.905-6.787-2.82-6-3.007-9 6.388-5.84 5.636-9.943-7.514-2.527-9.392-5.683-2.068-5.839-6.575-5.839Z",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M80.469 18.068s-4.507 0-5.82 6.155 2.065 7.73-2.068 10.892-4.694 5.369-2.629 6.789 3.194 3 .565 5.366-3.007 5.84 6.385 8.05 16.528-3.156 16.905-6.787-2.82-6-3.007-9 6.388-5.84 5.636-9.943-7.514-2.527-9.392-5.683-2.068-5.839-6.575-5.839Z",
    "data-name": "Path 2187",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M77.172 77.893h1.646l2.328-38.513 2.112-5.331-2.22 3.521.317-3.439 3.559-6.094-3.429 3.8-.3-9.116-.463 5.6-1.684-.837 1.475 1.866-.4 6.637-1.332-1.767 1.148 3.145Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M52.334 79.124c.482-2.282 1.269-5.118 2.376-6.174 1.96-1.879 5.141 1.066 6.857-.267s-1.96-14.5 3.917-15.3S73.566 70 76.268 71.343s3.673-3.492 7.346-3.759c3.213-.235 9.417 9.173 10.927 11.542Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M52.334 79.124c.482-2.282 1.269-5.118 2.376-6.174 1.96-1.879 5.141 1.066 6.857-.267s-1.96-14.5 3.917-15.3S73.566 70 76.268 71.343s3.673-3.492 7.346-3.759c3.213-.235 9.417 9.173 10.927 11.542Z",
    "data-name": "Path 2190",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M74.88 79.124c-.435-1.573-1.148-3.529-2.138-4.265-1.764-1.3-4.628.741-6.169-.184s1.76-10-3.527-10.556-7.273 8.7-9.7 9.628-3.3-2.4-6.61-2.591c-2.889-.163-8.475 6.328-9.832 7.962Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M14.73 56.639s-4.326.384-10.467-4.59 5.922-22.581 10.7-26.409 14.588 20.663 10.928 25.263a13.99 13.99 0 0 1-11.161 5.736Z",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M14.73 56.639s-4.326.384-10.467-4.59 5.922-22.581 10.7-26.409 14.588 20.663 10.928 25.263a13.99 13.99 0 0 1-11.161 5.736Z",
    "data-name": "Path 2193",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m12.903 76.734.685-25.641-2.962-2.679 3.188 1.53v-4.593l-4.1-4.017 3.873 2.487-.457-3.252 1.139 1.53.682-9.186.457 13.968 7.514-3.444-7.514 5.358v28.7",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M119.096 35.232s-4.326.381-10.467-4.593 5.925-22.581 10.682-26.409 14.59 20.667 10.93 25.26a13.977 13.977 0 0 1-11.145 5.742Z",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "m115.607 75.638 2.35-45.956-2.959-2.679 3.188 1.53V23.94l-4.1-4.017 3.873 2.487-.457-3.252 1.139 1.53.685-9.186.454 13.971 7.514-3.447-7.514 5.358v2.49l-1.665 46.529",
    "data-name": "Path 2196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24.438 78.46a1.644 1.644 0 0 0-.86-1.04c-.85-.389-.85 0-1.855-.267-.666-.173-.533-1.434-.587-1.866a3.2 3.2 0 0 0-2.639-2.8 5.528 5.528 0 0 0-4.564.976c-1.932 1.559-1.7 2.932-2.937 2.988s-1.932-1.234-4.095-.456a4.179 4.179 0 0 0-2.35 2.468Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.438 78.46a1.644 1.644 0 0 0-.86-1.04c-.85-.389-.85 0-1.855-.267-.666-.173-.533-1.434-.587-1.866a3.2 3.2 0 0 0-2.639-2.8 5.528 5.528 0 0 0-4.564.976c-1.932 1.559-1.7 2.932-2.937 2.988s-1.932-1.234-4.095-.456a4.179 4.179 0 0 0-2.35 2.468Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.55 78.368a1.848 1.848 0 0 1 1.5-1.293c1.154-.107 1.966 1.474 3.679.144s2.737-4.71 5.392-4.6 2.61 2.8 2.309 3.918 1.456 1.066 2.22.933 1.668.576 1.668 1.008",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.944 78.439-.939-.717",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m14.676 78.477 2.525-4.313",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.916 74.486.3 1.4 2.011-.936",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m14.292 75.923 1.028 1.583 2.008-.541",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M66.597 78.019a1.821 1.821 0 0 0-.952-1.149c-.952-.432-.952 0-2.052-.288-.736-.189-.59-1.583-.65-2.06a3.531 3.531 0 0 0-2.918-3.1 6.143 6.143 0 0 0-5.075 1.066c-2.138 1.725-1.881 3.233-3.248 3.305s-2.138-1.365-4.532-.5a4.654 4.654 0 0 0-2.6 2.73Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.597 78.019a1.821 1.821 0 0 0-.952-1.149c-.952-.432-.952 0-2.052-.288-.736-.189-.59-1.583-.65-2.06a3.531 3.531 0 0 0-2.918-3.1 6.143 6.143 0 0 0-5.075 1.066c-2.138 1.725-1.881 3.233-3.248 3.305s-2.138-1.365-4.532-.5a4.654 4.654 0 0 0-2.6 2.73Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49.483 77.991-1.04-.794",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m55.773 78.032 2.791-4.772",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m57.138 73.617.33 1.551 2.223-1.034",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m55.349 75.208 1.135 1.751 2.223-.6",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M31.597 0s-6.493 0-8.386 8.866 2.975 11.14-2.975 15.685-6.762 7.73-3.784 9.775 4.6 4.318.809 7.73-4.326 8.413 9.2 11.6 23.788-4.548 24.343-9.775-4.06-8.639-4.329-12.958 9.2-8.41 8.113-14.32-10.819-3.639-13.521-8.184S38.09 0 31.597 0Z",
    "data-name": "Path 2206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M92.439 5.222s-6.486.189-8.012 9.106 3.432 11.044-2.325 15.762-6.439 7.922-3.381 9.879 4.773 4.182 1.129 7.7-3.974 8.53 9.671 11.316 23.6-5.238 23.924-10.479-4.412-8.514-4.862-12.822 8.843-8.671 7.517-14.536-10.962-3.319-13.854-7.784-3.321-8.332-9.807-8.142Z",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.44 5.222s-6.486.189-8.012 9.106 3.432 11.044-2.325 15.762-6.439 7.922-3.381 9.879 4.773 4.182 1.129 7.7-3.974 8.53 9.671 11.316 23.6-5.238 23.924-10.479-4.412-8.514-4.862-12.822 8.843-8.671 7.517-14.536-10.962-3.319-13.854-7.784-3.321-8.332-9.807-8.142Z",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m90.602 80.897 1.453-.043 1.054-27.574 1.669-4.777-1.836 3.165.165-3.044 2.918-5.469-2.889 3.446-.6-8.042-.206 4.967-1.515-.7 1.371 1.617-.113 5.871-1.241-1.527 1.13 2.75Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M132.189 79.124c-.565-2.052-1.494-4.6-2.788-5.555-2.3-1.69-6.026.968-8.044-.24s2.3-13.043-4.6-13.768-9.484 11.353-12.646 12.561-4.31-3.14-8.621-3.383c-3.768-.211-11.05 8.263-12.823 10.4Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M55.207 79.652c.216-1.407.333-4-1.354-5.411-2.395-2.013-5.985 1.255-6.883 1.255s-1.2-2.01-3.892-3.772-5.985.5-7.78 0 1.5-8.3-3.59-8.549-6.883 10.562-10.467 10.562-4.19-2.013-7.78-.251c-2.813 1.378-4.339 4.761-4.869 6.166Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M55.207 79.652c.216-1.407.333-4-1.354-5.411-2.395-2.013-5.985 1.255-6.883 1.255s-1.2-2.01-3.892-3.772-5.985.5-7.78 0 1.5-8.3-3.59-8.549-6.883 10.562-10.467 10.562-4.19-2.013-7.78-.251c-2.813 1.378-4.339 4.761-4.869 6.166Z",
    "data-name": "Path 2214",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.25 79.314-3.213-4.385",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m29.569 78.975 1.605-12.707",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m38.744 79.201 1.605-4.947",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50.043 79.426 1.608-3.487",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.517 75.041-1.6 2.362-3.746-1.237",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.768 67.281 1.871 2.812 2.544-2.588",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.702 71.78 2.41 2.474 2.407-1.575",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m39.671 76.39 3.21-1.573",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m39.419 77.291-1.608-3.487",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50.85 77.626-.806-2.25",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50.574 78.076 2.274-.786",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M66.557 16.783a19.128 19.128 0 0 0-3.933-4.561 11.887 11.887 0 0 0-8.732-2.6c-6.432.613-8.193 7.5-10.013 11.694-4.352 10.009-9.75 24.854 6.521 29.226 7.013 1.885 16.645 0 19.465-6.318 2.439-5.465 2.4-11.481.923-17.127a37.293 37.293 0 0 0-4.231-10.314Z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.222 86.079h2.692l1.627-49.955 3.452-8.733-3.639 5.748.547-5.618 5.817-9.955-5.6 6.223-.482-14.9-.763 9.172-2.75-1.37 2.412 3.064-.659 10.848-2.16-2.889 1.872 5.143Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m56.498 58.546.044-1.3c-.377 0-.913.109-.913.589 0 .4.454.6.869.711Z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M56.017 43.634c0 .424.511.629.951.73l.044-1.333c-.377.016-.995.091-.995.603Z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M55.727 49.629c0 .453.587.658 1.04.749l.044-1.333c-.351-.018-1.084.022-1.084.584Z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M56.606 35.515c.124-.421-.469-.437-.913-.395l-.079 1.333a1.91 1.91 0 0 0 .992-.938Z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M54.658 78.432c0 .5.7.7 1.164.773l.044-1.351c-.253-.025-1.208-.062-1.208.578Z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m55.951 30.847-.079 1.306a1.845 1.845 0 0 0 .929-.906c.118-.4-.403-.435-.85-.4Z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M56.395 27.062c0 .445.571.65 1.021.744l-.044-1.333c-.365.008-.977.08-.977.589Z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M55.774 69.725c.238-.8-1-.778-1.792-.685l-.108 2.423c.571-.274 1.646-.89 1.9-1.738Z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M56.024 72.276s-1.269-.163-1.269.576c0 .533.793.72 1.25.8l.041-1.264Z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M55.045 62.123c0 .637.634 1.016 1.3 1.234l.076-2.317c-.653.07-1.376.318-1.376 1.083Z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m54.391 59.815-.057 1.3a1.819 1.819 0 0 0 .913-.9c.121-.414-.425-.435-.856-.4Z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m54.991 46.265-.051 1.114a1.434 1.434 0 0 0 .6-.706c.088-.309-.21-.397-.549-.408Z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M55.249 67.19c.152-.509-.755-.427-1.167-.363l-.063 1.413c.189-.08 1.055-.466 1.23-1.05Z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M105.723 26.995c.121-.4-.241-.533-.672-.549l-.073 1.458a1.9 1.9 0 0 0 .745-.909Z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m103.942 49.711-.079 1.751a2.463 2.463 0 0 0 1.234-1.213c.165-.548-.568-.578-1.155-.538Z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m106.069 10.668-.1 1.749a2.436 2.436 0 0 0 1.221-1.208c.158-.546-.537-.586-1.121-.541Z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M105.482 31.999a.38.38 0 0 0 0-.267 2.911 2.911 0 0 0 .952-1.333c.241-.8-.634-.994-1.529-.984l-.174 3.492a1.913 1.913 0 0 0 .751-.908Z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m107.504 6.426-.054-1.6a.8.8 0 0 0-.793.749c0 .425.396.689.847.851Z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M105.159 18.356a1.972 1.972 0 0 0 .453-.533l-.025.395a2.588 2.588 0 0 0 1.338-1.269c.174-.594-.606-.589-1.2-.533l-.038.653-.025-.035v.184a1.39 1.39 0 0 0-.952-.179Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M106.239 14.387c0 .533.584.8 1.135.949l.054-.565.041-1.176c-.507.013-1.23.14-1.23.792Z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M103.438 61.067c.257-.107 1.424-.629 1.659-1.415.2-.688-1.018-.576-1.586-.491Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M105.616 47.043a.813.813 0 0 0 .473.685l.057-1.365a.7.7 0 0 0-.53.68Z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M106.667 33.843c-.371-.029-1.6-.064-1.6.784 0 .445.419.712.885.872a.634.634 0 0 0-.2.485c0 .416.368.677.8.84Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M106.138 27.91a.968.968 0 0 0 .739.816l.067-1.567a.809.809 0 0 0-.806.751Z",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m106.996 19.323.054-.581c-.8.131-1.586.493-1.586 1.423 0 .861.841 1.367 1.748 1.666l.1-2.985Z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M104.828 52.826a1.6 1.6 0 0 0 .993 1.349l.111-2.666a1.342 1.342 0 0 0-1.104 1.317Z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m105.425 63.8.064-1.5a4.179 4.179 0 0 0-2.1-.139l-.146 3.242a6.187 6.187 0 0 0 2.182-1.603Z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M104.998 74.076a.756.756 0 0 0-.688.728.9.9 0 0 0 .634.768Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M104.435 67.283c0 .419.374.68.809.842l.067-1.6c-.435.06-.876.252-.876.758Z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M31.889 24.439a13.006 13.006 0 0 0-7.806 6.28c-2.715 5.094 1.665 9.1-.45 14.171s-8.113 7.626-2.753 11.59 12.164-2.276 15.76-1.743 3.879 6.016 13.661 3.657 6.661-9.4 2.912-12.6-.837-8.461-3.384-15.527c-1.958-5.418-10.924-8.086-17.94-5.828Z",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.889 24.439a13.006 13.006 0 0 0-7.806 6.28c-2.715 5.094 1.665 9.1-.45 14.171s-8.113 7.626-2.753 11.59 12.164-2.276 15.76-1.743 3.879 6.016 13.661 3.657 6.661-9.4 2.912-12.6-.837-8.461-3.384-15.527c-1.958-5.418-10.924-8.086-17.94-5.828Z",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m33.726 89.398 1.938-47.065-13.349-7.859 13.5 6.3.107-6.8-2.978-3.967 3.37 2.593.917-8.965.706 13.566 9.476-4.427-9.354 6.752-.255 8.362 7.727-2.422-7.856 4.368-1.18 39.461Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m36.28 73.833-.041 1v.216a6.258 6.258 0 0 0 1.132-.7c.349-.303-.412-.447-1.091-.516Z",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m36.724 62.933-.044 1.125a5.813 5.813 0 0 0 .98-.626c.333-.28-.301-.432-.936-.499Z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M36.504 68.4a6.192 6.192 0 0 0 1.158-.717c.365-.307-.425-.451-1.107-.517l-.022.515Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M37.465 44.874v.533a5.324 5.324 0 0 0 .875-.57c.317-.267-.251-.413-.86-.49Z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M38.031 65.717a1.921 1.921 0 0 0 .672.155l.032-1.066c-.523.276-1.202.703-.704.911Z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M37.773 61.651a4.615 4.615 0 0 0 1.05.307l.063-2.132c-1.085.615-2.106 1.409-1.113 1.825Z",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M37.57 70.309a2.583 2.583 0 0 0 1 .216l.044-1.493c-.727.365-1.745.977-1.044 1.277Z",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m38.468 73.796.035-1.194c-.482.224-1.586.8-1 1.048a1.848 1.848 0 0 0 .965.146Z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m36.943 57.668-.048 1.178a5.837 5.837 0 0 0 1.066-.672c.349-.306-.359-.45-1.018-.506Z",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M66.314 86.154a1.809 1.809 0 0 0-.952-1.149c-.952-.432-.952 0-2.052-.288-.736-.189-.59-1.6-.65-2.063a3.531 3.531 0 0 0-2.918-3.1 6.116 6.116 0 0 0-5.075 1.066c-2.138 1.725-1.881 3.233-3.248 3.3s-2.138-1.365-4.532-.5a4.655 4.655 0 0 0-2.6 2.73Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.314 86.154a1.809 1.809 0 0 0-.952-1.149c-.952-.432-.952 0-2.052-.288-.736-.189-.59-1.6-.65-2.063a3.531 3.531 0 0 0-2.918-3.1 6.116 6.116 0 0 0-5.075 1.066c-2.138 1.725-1.881 3.233-3.248 3.3s-2.138-1.365-4.532-.5a4.655 4.655 0 0 0-2.6 2.73Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49.199 86.127-1.04-.794",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m55.489 86.168 2.794-4.772",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m56.854 81.753.33 1.551 2.227-1.034",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m55.065 83.344 1.136 1.749 2.223-.6",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M48.823 89.553a3.992 3.992 0 0 0-2.109-2.548c-2.087-.957-2.087 0-4.551-.637-1.633-.424-1.31-3.516-1.443-4.574a7.822 7.822 0 0 0-6.477-6.872 13.561 13.561 0 0 0-11.234 2.362c-4.739 3.825-4.171 7.17-7.206 7.33s-4.723-3.028-10.042-1.117a10.284 10.284 0 0 0-5.76 6.057Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.812 89.494-2.309-1.762",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.713 89.584 6.194-10.588",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m40.782 89.318 1.992-1.058",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.739 79.791.736 3.441 4.932-2.3",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23.773 83.32 2.522 3.881 4.932-1.322",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.708 87.289-.422 1.941-2.309-.352",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m41.411 88.878-.314-.97",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(27.393 79.383)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31.213 78.993a.282.282 0 0 1-.192.276.39.39 0 0 1-.376-.047.255.255 0 0 1-.088-.311.341.341 0 0 1 .31-.184.319.319 0 0 1 .346.266Z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(33.343 80.529)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31.712 85.829a.288.288 0 0 1-.208.266.387.387 0 0 1-.371-.061.253.253 0 0 1-.073-.312.347.347 0 0 1 .316-.175.316.316 0 0 1 .336.282Z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(23.56 82.984)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(40.759 87.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M43.09 88.198a.289.289 0 0 1-.207.265.388.388 0 0 1-.371-.06.253.253 0 0 1-.075-.311.345.345 0 0 1 .314-.177.316.316 0 0 1 .339.283Z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(10.368 87.004)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.732 87.582a.345.345 0 1 1-.339-.285.316.316 0 0 1 .339.285Z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(7.488 88.577)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M111.865 56.829s-5.141.456-12.443-5.454 7.032-26.824 12.712-31.369 17.327 24.548 12.982 30a16.61 16.61 0 0 1-13.251 6.823Z",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m109.698 80.697.812-30.46-3.514-3.18 3.787 1.818v-5.457l-4.869-4.774 4.6 2.956-.539-3.865 1.351 1.818.812-10.911.539 16.594 8.929-4.092-8.929 6.366v34.1",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M111.854 67.532c.228-.48-1.227-.533-1.614-.552l-.038 1.455c.507-.17 1.462-.511 1.652-.903Z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M112.841 55.224c-.739.155-2.252.533-1.811.9a3.863 3.863 0 0 0 1.811.453Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M111.961 59.326c.232-.485-1.5-.485-1.5-.485v.024l-.035 1.28c.406-.123 1.355-.44 1.535-.819Z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M111.848 53.012c.171-.363-.745-.456-1.224-.48l-.032 1.207c.46-.157 1.11-.423 1.256-.727Z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m110.145 74.158-.114.674-.022.837c.4-.112 1.627-.5 1.846-.96.263-.551-1.71-.551-1.71-.551Z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M110.796 63.872a4.371 4.371 0 0 0 2.046.517v-1.533c-.847.179-2.544.597-2.046 1.016Z",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M110.916 49.805a4.1 4.1 0 0 0 1.925.461v-1.381c-.682.136-2.391.52-1.925.92Z",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M109.454 41.141c-.758.187-1.687.485-1.329.8a2.988 2.988 0 0 0 1.37.413Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M112.841 70.045c-.847.179-2.538.6-2.046 1.016a4.339 4.339 0 0 0 2.046.517Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M110.954 44.658v1.245c.46-.149 1.2-.435 1.351-.762.2-.398-.939-.473-1.351-.483Z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M129.461 81.031c.235-1.8-1.507-3.732-3.711-3.825-1.979-.08-4.155 1.037-5.8.115-1.348-.754-1.376-2.365-1.529-3.732a5.912 5.912 0 0 0-1.649-3.732 4.626 4.626 0 0 0-4.333-1.136c-3.042.941-3.229 5.134-6.344 5.907-2.15.533-4.393-.968-6.6-.634-2.7.405-3.923 2.919-6 4.148-.216.128-1.116.677-2.15 1.312-.866.533-1.824 1.122-2.537 1.578Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.461 81.031c.235-1.8-1.507-3.732-3.711-3.825-1.979-.08-4.155 1.037-5.8.115-1.348-.754-1.376-2.365-1.529-3.732a5.912 5.912 0 0 0-1.649-3.732 4.626 4.626 0 0 0-4.333-1.136c-3.042.941-3.229 5.134-6.344 5.907-2.15.533-4.393-.968-6.6-.634-2.7.405-3.923 2.919-6 4.148-.216.128-1.116.677-2.15 1.312-.866.533-1.824 1.122-2.537 1.578Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m104.457 80.881-1.706-4.19",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m110.435 80.993 3.543-8.05",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m123.13 80.993 2.1-1.655",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m103.983 79.889 1.126-2.535",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m103.777 79.271-3.904-.816",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m110.533 75.368-1.05-1.434",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m109.671 77.573 3.803-1.762",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m110.741 80.372 3.495-1.034",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m111.238 79.228-2.23-3.308",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M112.042 72.942a.29.29 0 0 1-.21.264.388.388 0 0 1-.37-.063.253.253 0 0 1-.072-.312.347.347 0 0 1 .316-.174.371.371 0 0 1 .239.084.261.261 0 0 1 .097.201Z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M111.941 73.91a.344.344 0 1 1-.339-.285.372.372 0 0 1 .241.083.261.261 0 0 1 .098.202Z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(115.179 75.526)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(108.678 75.635)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(113.913 79.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(124.757 79.122)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M103.099 76.691a.288.288 0 0 1-.207.265.388.388 0 0 1-.371-.06.253.253 0 0 1-.075-.311.345.345 0 0 1 .314-.177.317.317 0 0 1 .339.283Z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(104.707 77.077)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.339,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.339,
    ry: 0.285,
    transform: "translate(99.551 78.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M139.218 85.003a2.2 2.2 0 0 0-1.158-1.4c-1.148-.533-1.148 0-2.5-.349-.9-.232-.72-1.933-.793-2.516a4.309 4.309 0 0 0-3.562-3.777 7.457 7.457 0 0 0-6.182 1.3c-2.607 2.1-2.293 3.942-3.962 4.03s-2.607-1.663-5.525-.613a5.643 5.643 0 0 0-3.172 3.33Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m118.316 84.97-1.269-.97",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m126.048 85.018 3.406-5.819",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m127.723 79.636.4 1.89 2.712-1.261",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m125.531 81.577 1.383 2.132 2.712-.728",
    "data-name": "Path 2299"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(0 41.556)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M9.105 82.345c.278-1.927 4.139.965 4.139.965a9.19 9.19 0 0 1-.827-3.615c0-1.927 2.747.48 2.747.48a12.185 12.185 0 0 1-1.657-6.5c.275-3.372 4.417.482 4.417.482s-1.657-5.065-1.932-6.507 7.725 1.687 7.725 1.687A41.214 41.214 0 0 1 22.89 65c-.143-1.109 1.221-.648 2.6.069.305-.965 1.12-1.032 2.027-.73l-.192-.781c-.305-1.3 1.813.165 3.574 1.549a7.038 7.038 0 0 1 2.472-4.444c1.334-1.165 2.771.133 3.968 1.957l1.981.533c.024-.336.064-.682.122-1.04.357-2.18 2.442.171 3.873 2.106l1.526.411a9.752 9.752 0 0 1 2.314-4.926c2.481-2.65 8.278 4.82 8.278 4.82s3.586-5.065 4.966-2.4-.552 8.194-.552 8.194.827-1.93 1.929-2.4 4.139 1.685 4.139 1.685-1.654-3.372 0-4.577c1.5-1.09 3.443 2.743 3.8 3.489a10.537 10.537 0 0 1-.491-6.381c.827-3.855 4.139 1.2 4.139 1.2s-.552-4.819 2.481-5.542-1.38 0 1.657 4.82 1.929-3.372 6.346-2.892 3.309 14.941 3.309 14.941l17.407-8.7s.827-1.447 3.629-1.885 1.059 3.335 1.059 3.335 3.864-3.132 5.518-3.132c.43 0 1.752 1.671 3.473 4.145.125-.253.253-.512.388-.773 1.047-2.007 1.932 2.482 2.3 4.777l.305.461c.223-1.133.873-3.079 2.637-3.079 2.137 0 1 6.43.647 8.215v.021c.275-1.016 1.065-3.465 2.375-3.66 1.654-.24.278 5.3.278 5.3a4.552 4.552 0 0 1 1.929-.722c.61 0-.235 3.361-.748 5.251 1.74 2.826 2.921 4.785 2.921 4.785l-10.985-5.208H62.544l2.793 3.375H10.219s-1.389-2.89-1.114-4.822Z",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M61.781 89.673c.786-2.474 2.073-5.544 3.867-6.691 3.185-2.037 8.366 1.165 11.155-.291s-3.185-15.708 6.384-16.576 13.151 13.672 17.536 15.125 5.977-3.78 11.955-4.07c5.225-.267 15.325 9.938 17.781 12.507Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M61.781 89.673c.786-2.474 2.073-5.544 3.867-6.691 3.185-2.037 8.366 1.165 11.155-.291s-3.185-15.708 6.384-16.576 13.151 13.672 17.536 15.125 5.977-3.78 11.955-4.07c5.225-.267 15.325 9.938 17.781 12.507Z",
    "data-name": "Path 2175",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M87.699 87.111h-2.208l-1.344-38.652-2.832-6.773 2.98 4.454-.44-4.35-4.771-7.7 4.583 4.809.4-11.532.612 7.1 2.254-1.066-1.976 2.372.538 8.4 1.784-2.237-1.536 3.98Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M114.786 87.111h-2.208l-1.344-38.652-2.829-6.76 2.984 4.454-.444-4.35-4.778-7.706 4.6 4.8.393-11.532.625 7.1 2.255-1.066-1.976 2.372.538 8.4 1.787-2.237-1.539 3.98Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M57.035 87.111h-2.207l-1.344-29.709-2.843-5.179 2.984 3.423-.44-3.343-4.771-5.944 4.6 3.705.4-8.861.632 5.457 2.251-.816-1.976 1.821.541 6.454 1.784-1.719-1.535 3.058Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M80.548 87.111h-2.207l-1.344-29.709-2.839-5.179 2.98 3.423-.44-3.343-4.771-5.944 4.6 3.705.4-8.861.625 5.457 2.255-.816-1.979 1.821.541 6.454 1.784-1.719-1.536 3.058Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M65.152 87.111h-2.208L61.6 57.402l-2.842-5.179 2.986 3.42-.443-3.343-4.768-5.944 4.6 3.705.4-8.861.622 5.457 2.255-.816-1.976 1.821.538 6.454 1.787-1.719-1.539 3.058Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M21.736 87.116h-2.208l-1.344-38.652-2.829-6.76 2.98 4.454-.44-4.35-4.771-7.7 4.6 4.8.4-11.532.618 7.1 2.255-1.066-1.976 2.372.538 8.4 1.784-2.236-1.535 3.98Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M32.759 87.111h-2.2l-1.348-38.652-2.832-6.76 2.984 4.454-.444-4.35-4.788-7.706 4.6 4.8.4-11.532.622 7.1 2.254-1.066-1.976 2.372.538 8.4 1.788-2.237-1.546 3.974Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.638 87.111h-2.2l-1.344-38.652-2.829-6.76 2.984 4.454-.444-4.35-4.781-7.706 4.6 4.8.383-11.532.622 7.1 2.255-1.066-1.976 2.372.538 8.4 1.788-2.237-1.539 3.98Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M21.314 89.673c.672-2.474 1.794-5.544 3.343-6.691 2.759-2.037 7.244 1.165 9.656-.291s-2.759-15.709 5.517-16.58 11.38 13.672 15.174 15.125 5.174-3.78 10.345-4.07c4.523-.267 13.262 9.938 15.389 12.507Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M21.314 89.673c.672-2.474 1.794-5.544 3.343-6.691 2.759-2.037 7.244 1.165 9.656-.291s-2.759-15.709 5.517-16.58 11.38 13.672 15.174 15.125 5.174-3.78 10.345-4.07c4.523-.267 13.262 9.938 15.389 12.507Z",
    "data-name": "Path 2185",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M57.869 28.616s4.775 0 6.165 6.155-2.187 7.73 2.191 10.892 4.973 5.369 2.785 6.789-3.383 3-.6 5.366 3.185 5.84-6.763 8.05-17.509-3.156-17.909-6.787 2.987-6 3.185-9-6.767-5.84-5.971-9.943 7.96-2.527 9.949-5.683 2.193-5.839 6.968-5.839Z",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M57.869 28.616s4.775 0 6.165 6.155-2.187 7.73 2.191 10.892 4.973 5.369 2.785 6.789-3.383 3-.6 5.366 3.185 5.84-6.763 8.05-17.509-3.156-17.909-6.787 2.987-6 3.185-9-6.767-5.84-5.971-9.943 7.96-2.527 9.949-5.683 2.193-5.839 6.968-5.839Z",
    "data-name": "Path 2187",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M61.02 88.441h-1.744L56.81 49.928l-2.238-5.331 2.352 3.521-.336-3.439-3.768-6.093 3.632 3.8.316-9.116.49 5.6 1.784-.837-1.562 1.866.427 6.637 1.411-1.767-1.216 3.145Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M86.793 89.673c-.511-2.282-1.344-5.118-2.517-6.174-2.076-1.879-5.446 1.066-7.264-.267s2.076-14.5-4.149-15.3-8.561 12.617-11.424 13.96-3.891-3.492-7.782-3.759c-3.4-.235-9.976 9.173-11.575 11.542Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M86.793 89.673c-.511-2.282-1.344-5.118-2.517-6.174-2.076-1.879-5.446 1.066-7.264-.267s2.076-14.5-4.149-15.3-8.561 12.617-11.424 13.96-3.891-3.492-7.782-3.759c-3.4-.235-9.976 9.173-11.575 11.542Z",
    "data-name": "Path 2190",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M60.916 89.673c.46-1.573 1.216-3.529 2.265-4.265 1.868-1.3 4.9.741 6.535-.184s-1.865-10 3.736-10.556 7.7 8.7 10.271 9.628 3.5-2.4 7-2.591c3.061-.163 8.978 6.328 10.416 7.962Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M120.485 67.188s4.583.384 11.088-4.59-6.273-22.581-11.336-26.409-15.452 20.663-11.579 25.263a15.144 15.144 0 0 0 11.827 5.736Z",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M120.485 67.188s4.583.384 11.088-4.59-6.273-22.581-11.336-26.409-15.452 20.663-11.579 25.263a15.144 15.144 0 0 0 11.827 5.736Z",
    "data-name": "Path 2193",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m122.417 87.282-.726-25.641 3.138-2.679-3.377 1.53v-4.593l4.341-4.017-4.1 2.487.484-3.252-1.206 1.53-.722-9.186-.486 13.97-7.96-3.444 7.96 5.358v28.7",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M21.316 45.781s4.583.381 11.088-4.593-6.276-22.581-11.316-26.409S5.632 35.446 9.51 40.039a15.128 15.128 0 0 0 11.806 5.742Z",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M110.197 89.009a1.669 1.669 0 0 1 .911-1.04c.9-.389.9 0 1.966-.267.706-.173.564-1.434.622-1.866a3.275 3.275 0 0 1 2.8-2.8 6.129 6.129 0 0 1 4.835.976c2.046 1.559 1.8 2.932 3.111 2.988s2.046-1.234 4.338-.456a4.285 4.285 0 0 1 2.49 2.468Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.197 89.009a1.669 1.669 0 0 1 .911-1.04c.9-.389.9 0 1.966-.267.706-.173.564-1.434.622-1.866a3.275 3.275 0 0 1 2.8-2.8 6.129 6.129 0 0 1 4.835.976c2.046 1.559 1.8 2.932 3.111 2.988s2.046-1.234 4.338-.456a4.285 4.285 0 0 1 2.49 2.468Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M129.148 88.916a1.91 1.91 0 0 0-1.586-1.293c-1.223-.107-2.083 1.474-3.9.144s-2.9-4.71-5.712-4.6-2.765 2.8-2.446 3.918-1.542 1.066-2.352.933-1.767.576-1.767 1.008",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m126.611 88.988.995-.717",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m120.54 89.025-2.675-4.313",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m119.226 85.035-.319 1.4-2.13-.936",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m120.945 86.471-1.089 1.583-2.127-.541",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M69.87 88.567a1.849 1.849 0 0 1 1.008-1.149c1.008-.432 1.008 0 2.174-.288.78-.189.625-1.583.689-2.06a3.619 3.619 0 0 1 3.091-3.1 6.812 6.812 0 0 1 5.376 1.066c2.265 1.725 1.992 3.233 3.441 3.305s2.265-1.365 4.8-.5a4.772 4.772 0 0 1 2.752 2.73Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.87 88.567a1.849 1.849 0 0 1 1.008-1.149c1.008-.432 1.008 0 2.174-.288.78-.189.625-1.583.689-2.06a3.619 3.619 0 0 1 3.091-3.1 6.812 6.812 0 0 1 5.376 1.066c2.265 1.725 1.992 3.233 3.441 3.305s2.265-1.365 4.8-.5a4.772 4.772 0 0 1 2.752 2.73Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87.66 88.54 1.102-.794",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m81.661 88.581-2.957-4.772",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m80.321 84.166-.349 1.551-2.355-1.034",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m82.094 85.757-1.2 1.751-2.355-.6",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M96.184 36.994s5.069 0 6.547 4.556-2.323 5.724 2.323 8.059 5.279 3.972 2.954 5.023-3.588 2.219-.631 3.972 3.377 4.323-7.181 5.958-18.571-2.337-19-5.023 3.17-4.439 3.38-6.658-7.181-4.321-6.334-7.358 8.446-1.87 10.556-4.2 2.317-4.329 7.386-4.329Z",
    "data-name": "Path 2207",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M46.933 15.771s6.871.189 8.487 9.106-3.635 11.044 2.463 15.762 6.821 7.922 3.582 9.879-5.057 4.182-1.2 7.7 4.21 8.53-10.245 11.316-25-5.238-25.344-10.479 4.674-8.514 5.151-12.822-9.367-8.671-7.963-14.536 11.612-3.319 14.676-7.784 3.522-8.332 10.393-8.142Z",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.933 15.771s6.871.189 8.487 9.106-3.635 11.044 2.463 15.762 6.821 7.922 3.582 9.879-5.057 4.182-1.2 7.7 4.21 8.53-10.245 11.316-25-5.238-25.344-10.479 4.674-8.514 5.151-12.822-9.367-8.671-7.963-14.536 11.612-3.319 14.676-7.784 3.522-8.332 10.393-8.142Z",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m49.68 91.446-1.911-.053-1.387-34.237-2.2-5.931 2.415 3.93-.217-3.78-3.838-6.79 3.8 4.279.783-9.985.271 6.167 1.993-.865-1.8 2.008.148 7.289 1.632-1.9-1.481 3.41Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M7.446 89.673c.6-2.052 1.582-4.6 2.953-5.555 2.433-1.69 6.384.968 8.521-.24s-2.433-13.043 4.872-13.768 10.046 11.353 13.4 12.561 4.566-3.14 9.132-3.383c3.991-.211 11.706 8.263 13.584 10.4Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M77.603 90.201c-.228-1.407-.353-4 1.435-5.411 2.537-2.013 6.34 1.255 7.291 1.255s1.27-2.01 4.123-3.772 6.34.5 8.242 0-1.586-8.3 3.8-8.549 7.294 10.562 11.09 10.562 4.438-2.013 8.242-.251c2.98 1.378 4.6 4.761 5.158 6.166Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M77.603 90.201c-.228-1.407-.353-4 1.435-5.411 2.537-2.013 6.34 1.255 7.291 1.255s1.27-2.01 4.123-3.772 6.34.5 8.242 0-1.586-8.3 3.8-8.549 7.294 10.562 11.09 10.562 4.438-2.013 8.242-.251c2.98 1.378 4.6 4.761 5.158 6.166Z",
    "data-name": "Path 2214",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m116.753 89.862 3.404-4.385",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m107.21 89.524-1.7-12.707",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m98.25 89.75-1.7-4.947",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87.216 89.975-1.703-3.487",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m116.47 85.589 1.7 2.362 3.968-1.237",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m108.042 77.83-1.982 2.812-2.695-2.588",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m109.088 82.329-2.554 2.474-2.55-1.575",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m97.384 86.938-3.4-1.573",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m97.458 87.839 1.703-3.487",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m86.337 88.175.853-2.25",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m86.718 88.625-2.409-.786",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M69.783 27.332a19.484 19.484 0 0 1 4.166-4.561 13.112 13.112 0 0 1 9.25-2.6c6.814.613 8.679 7.5 10.607 11.694 4.61 10.009 10.328 24.854-6.908 29.226-7.429 1.885-17.633 0-20.62-6.318-2.584-5.465-2.544-11.481-.978-17.127a36.151 36.151 0 0 1 4.483-10.314Z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M84.374 96.628h-2.513L80.34 52.606l-3.222-7.7 3.4 5.065-.511-4.95-5.433-8.767 5.228 5.483.45-13.131.712 8.082 2.567-1.208-2.251 2.7.615 9.559 2.016-2.546-1.747 4.532Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m80.817 69.094-.047-1.3c.4 0 .968.109.968.589 0 .4-.481.6-.921.711Z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.362 54.183c0 .424-.541.629-1.008.73l-.047-1.33c.4.013 1.055.088 1.055.6Z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.649 60.177c0 .453-.622.658-1.1.749l-.047-1.333c.371-.018 1.147.022 1.147.584Z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M80.705 46.063c-.131-.421.5-.437.968-.395l.084 1.333a1.98 1.98 0 0 1-1.052-.938Z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M82.697 88.98c0 .5-.743.7-1.233.773l-.047-1.351c.269-.025 1.28-.062 1.28.578Z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m81.418 41.396.084 1.306a1.906 1.906 0 0 1-.984-.906c-.125-.4.427-.435.9-.4Z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M80.994 37.61c0 .445-.6.65-1.082.744l.047-1.333c.386.008 1.035.08 1.035.589Z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.473 80.274c-.252-.8 1.055-.778 1.9-.685l.114 2.423c-.607-.274-1.745-.89-2.014-1.738Z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.261 82.825s1.344-.163 1.344.576c0 .533-.84.72-1.324.8l-.044-1.264Z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M82.324 72.671c0 .637-.672 1.016-1.374 1.234l-.081-2.317c.689.07 1.455.318 1.455 1.083Z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m82.944 70.363.061 1.3a1.878 1.878 0 0 1-.968-.9c-.128-.414.45-.435.907-.4Z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m82.348 56.813.054 1.114a1.459 1.459 0 0 1-.632-.706c-.098-.309.218-.397.578-.408Z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M82.019 77.739c-.161-.509.8-.427 1.236-.363l.067 1.413c-.201-.08-1.118-.466-1.303-1.05Z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24.131 7.219a19.413 19.413 0 0 1 4.166-4.561 13.112 13.112 0 0 1 9.253-2.6c6.811.61 8.679 7.5 10.607 11.691 4.62 10.012 10.339 24.857-6.911 29.229-7.432 1.885-17.636 0-20.62-6.318-2.584-5.467-2.543-11.481-.981-17.127a36.256 36.256 0 0 1 4.486-10.314Z",
    "data-name": "Path 2233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M24.131 7.219a19.413 19.413 0 0 1 4.166-4.561 13.112 13.112 0 0 1 9.253-2.6c6.811.61 8.679 7.5 10.607 11.691 4.62 10.012 10.339 24.857-6.911 29.229-7.432 1.885-17.636 0-20.62-6.318-2.584-5.467-2.543-11.481-.981-17.127a36.256 36.256 0 0 1 4.486-10.314Z",
    "data-name": "Path 2234",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M32.728 37.543c-.128-.4.255-.533.712-.549l.077 1.458a1.924 1.924 0 0 1-.79-.909Z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m34.553 60.26.084 1.751a2.545 2.545 0 0 1-1.307-1.213c-.175-.548.601-.578 1.223-.538Z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m32.472 21.216.111 1.749a2.516 2.516 0 0 1-1.294-1.208c-.171-.546.564-.586 1.183-.541Z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M33.024 42.548a.361.361 0 0 1 0-.267 2.922 2.922 0 0 1-1.008-1.333c-.255-.8.672-.994 1.62-.984l.185 3.492a1.944 1.944 0 0 1-.797-.908Z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m30.985 16.975.057-1.6a.83.83 0 0 1 .84.749c0 .425-.42.689-.897.851Z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M33.396 28.904a2 2 0 0 1-.48-.533l.027.395c-.474-.229-1.233-.674-1.418-1.269s.642-.589 1.273-.533l.04.653.027-.035v.184a1.545 1.545 0 0 1 1.008-.179Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M32.313 24.935c0 .533-.618.8-1.2.949l-.057-.565-.044-1.176c.535.013 1.301.14 1.301.792Z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M35.078 71.616c-.272-.107-1.509-.629-1.757-1.415-.215-.688 1.079-.576 1.68-.491Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M32.879 57.592a.815.815 0 0 1-.5.685l-.06-1.365a.706.706 0 0 1 .56.68Z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M31.788 44.391c.393-.029 1.7-.064 1.7.784 0 .445-.443.712-.937.872a.617.617 0 0 1 .215.485c0 .416-.39.677-.847.84Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M32.386 38.458a.989.989 0 0 1-.783.816l-.071-1.567a.836.836 0 0 1 .853.752Z",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m31.487 29.872-.057-.581c.847.131 1.68.493 1.68 1.423 0 .861-.89 1.367-1.851 1.666l-.1-2.985Z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M33.685 63.374a1.605 1.605 0 0 1-1.052 1.349l-.118-2.666a1.364 1.364 0 0 1 1.17 1.317Z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m32.992 74.348-.067-1.5a4.677 4.677 0 0 1 2.224-.139l.155 3.242a6.549 6.549 0 0 1-2.312-1.603Z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M33.438 84.624a.775.775 0 0 1 .729.728.915.915 0 0 1-.672.768Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M34.054 77.832c0 .419-.4.68-.857.842l-.071-1.6c.461.06.928.252.928.758Z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M102.305 34.988a13.758 13.758 0 0 1 8.269 6.28c2.876 5.094-1.764 9.1.477 14.171s8.595 7.626 2.916 11.59-12.885-2.276-16.7-1.743-4.109 6.016-14.471 3.657-7.056-9.4-3.084-12.6.887-8.461 3.585-15.527c2.077-5.418 11.576-8.086 19.008-5.828Z",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.305 34.988a13.758 13.758 0 0 1 8.269 6.28c2.876 5.094-1.764 9.1.477 14.171s8.595 7.626 2.916 11.59-12.885-2.276-16.7-1.743-4.109 6.016-14.471 3.657-7.056-9.4-3.084-12.6.887-8.461 3.585-15.527c2.077-5.418 11.576-8.086 19.008-5.828Z",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m100.799 99.947-1.761-40.358 12.126-6.739-12.26 5.4-.1-5.832 2.7-3.4-3.061 2.223-.833-7.688-.642 11.633-8.608-3.8 8.5 5.79.232 7.171-7.015-2.072 7.137 3.745 1.072 33.838Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m100.646 84.382.044 1v.216a6.705 6.705 0 0 1-1.2-.7c-.371-.303.436-.447 1.156-.516Z",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m100.207 73.482.047 1.125a6.214 6.214 0 0 1-1.038-.626c-.353-.28.319-.432.991-.499Z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M100.43 78.949a6.634 6.634 0 0 1-1.226-.717c-.386-.307.45-.451 1.173-.517l.024.515Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M99.485 55.422v.533a5.688 5.688 0 0 1-.927-.57c-.336-.267.265-.413.911-.49Z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M98.916 76.265a2.135 2.135 0 0 1-.712.155l-.034-1.066c.555.276 1.274.703.746.911Z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M99.163 72.2a5.11 5.11 0 0 1-1.112.307l-.067-2.132c1.149.615 2.231 1.409 1.179 1.825Z",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M99.37 80.858a2.874 2.874 0 0 1-1.055.216l-.047-1.493c.766.365 1.844.977 1.102 1.277Z",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m98.416 84.344-.037-1.194c.511.224 1.68.8 1.058 1.048a2.062 2.062 0 0 1-1.021.146Z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m99.996 68.217.05 1.178a6.249 6.249 0 0 1-1.129-.672c-.369-.306.38-.45 1.079-.506Z",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M70.142 96.702a1.836 1.836 0 0 1 1.008-1.149c1.008-.432 1.008 0 2.174-.288.779-.189.625-1.6.689-2.063a3.619 3.619 0 0 1 3.091-3.1 6.783 6.783 0 0 1 5.376 1.066c2.265 1.725 1.992 3.233 3.441 3.3s2.265-1.365 4.8-.5a4.772 4.772 0 0 1 2.752 2.73Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.142 96.702a1.836 1.836 0 0 1 1.008-1.149c1.008-.432 1.008 0 2.174-.288.779-.189.625-1.6.689-2.063a3.619 3.619 0 0 1 3.091-3.1 6.783 6.783 0 0 1 5.376 1.066c2.265 1.725 1.992 3.233 3.441 3.3s2.265-1.365 4.8-.5a4.772 4.772 0 0 1 2.752 2.73Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87.938 96.675 1.102-.794",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m81.938 96.716-2.96-4.772",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m80.598 92.301-.349 1.551-2.359-1.034",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m82.371 93.892-1.2 1.749-2.355-.6",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M84.366 100.101a4.044 4.044 0 0 1 2.23-2.548c2.211-.957 2.211 0 4.822-.637 1.73-.424 1.388-3.516 1.529-4.574.433-3.239 2.688-6.038 6.861-6.872a15.039 15.039 0 0 1 11.9 2.362c5.02 3.825 4.418 7.17 7.634 7.33s5-3.028 10.638-1.117a10.544 10.544 0 0 1 6.1 6.057Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m124.632 100.042 2.446-1.762",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m112.023 100.133-6.562-10.588",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m96.269 99.866-2.11-1.058",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m109.063 90.339-.779 3.441-5.225-2.3",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m112.958 93.869-2.671 3.881-5.225-1.322",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m124.743 97.838.447 1.941 2.446-.352",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m95.588 99.426.333-.97",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(108.601 89.932)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M105.531 89.542a.283.283 0 0 0 .2.276.434.434 0 0 0 .4-.047.247.247 0 0 0 .093-.311.365.365 0 0 0-.329-.184.334.334 0 0 0-.364.266Z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(102.787 91.078)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M105.044 96.378a.292.292 0 0 0 .22.266.43.43 0 0 0 .393-.061.244.244 0 0 0 .077-.312.372.372 0 0 0-.335-.175.329.329 0 0 0-.355.282Z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(110.409 93.533)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(95.54 98.171)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M93.927 98.747a.292.292 0 0 0 .22.265.431.431 0 0 0 .393-.06.244.244 0 0 0 .079-.311.37.37 0 0 0-.332-.177.33.33 0 0 0-.36.283Z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(124.383 97.553)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M126.836 98.131a.369.369 0 1 0 .36-.285.329.329 0 0 0-.36.285Z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(127.434 99.125)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M28.976 67.378s5.446.456 13.181-5.454S34.708 35.1 28.69 30.555s-18.355 24.548-13.752 30a17.979 17.979 0 0 0 14.038 6.823Z",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m14.083 91.246-.86-30.46 3.723-3.18-4.012 1.818v-5.457l5.157-4.774-4.869 2.956.571-3.865-1.431 1.818-.86-10.911-.571 16.594-9.458-4.092 9.458 6.366v34.1",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M26.722 78.08c-.242-.48 1.3-.533 1.71-.552l.04 1.455c-.537-.17-1.548-.511-1.75-.903Z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M25.754 65.773c.783.155 2.386.533 1.919.9a4.285 4.285 0 0 1-1.919.453Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M26.619 69.875c-.245-.485 1.593-.485 1.593-.485v.024l.037 1.28c-.433-.123-1.438-.44-1.63-.819Z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M26.735 63.56c-.181-.363.79-.456 1.3-.48l.034 1.207c-.49-.157-1.179-.423-1.334-.727Z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m28.529 84.707.121.674.024.837c-.42-.112-1.724-.5-1.955-.96-.279-.551 1.81-.551 1.81-.551Z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M27.912 74.421a4.848 4.848 0 0 1-2.167.517v-1.533c.901.179 2.698.597 2.167 1.016Z",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M27.791 60.354a4.554 4.554 0 0 1-2.04.461v-1.381c.723.136 2.534.52 2.04.92Z",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M29.072 51.69c.8.187 1.787.485 1.408.8a3.3 3.3 0 0 1-1.451.413Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M25.749 80.594c.9.179 2.688.6 2.167 1.016a4.812 4.812 0 0 1-2.167.517Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M27.719 55.206v1.245c-.487-.149-1.267-.435-1.431-.762-.212-.398.994-.473 1.431-.483Z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10.335 91.579c-.249-1.8 1.6-3.732 3.931-3.825 2.1-.08 4.4 1.037 6.149.115 1.428-.754 1.458-2.365 1.62-3.732a5.762 5.762 0 0 1 1.747-3.732 5.1 5.1 0 0 1 4.59-1.136c3.222.941 3.42 5.134 6.72 5.907 2.278.533 4.654-.968 6.992-.634 2.863.405 4.156 2.919 6.354 4.148.229.128 1.183.677 2.278 1.312.917.533 1.932 1.122 2.688 1.578Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.335 91.579c-.249-1.8 1.6-3.732 3.931-3.825 2.1-.08 4.4 1.037 6.149.115 1.428-.754 1.458-2.365 1.62-3.732a5.762 5.762 0 0 1 1.747-3.732 5.1 5.1 0 0 1 4.59-1.136c3.222.941 3.42 5.134 6.72 5.907 2.278.533 4.654-.968 6.992-.634 2.863.405 4.156 2.919 6.354 4.148.229.128 1.183.677 2.278 1.312.917.533 1.932 1.122 2.688 1.578Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m33.943 91.429 1.808-4.19",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.371 91.541-3.753-8.05",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17.041 91.541-2.224-1.655",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34.511 90.438-1.193-2.535",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34.559 89.82 4.136-.816",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.022 85.917 1.112-1.434",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m29.134 88.122-4.029-1.762",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.07 90.92-3.703-1.034",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.313 89.777 2.362-3.308",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26.554 83.491a.293.293 0 0 0 .223.264.43.43 0 0 0 .392-.063.244.244 0 0 0 .076-.312.372.372 0 0 0-.335-.174.407.407 0 0 0-.253.084.255.255 0 0 0-.103.201Z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26.653 84.459a.369.369 0 1 0 .359-.285.409.409 0 0 0-.255.083.256.256 0 0 0-.104.202Z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(24.746 86.074)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(29.177 86.184)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(26.087 89.558)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(14.599 89.67)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M35.293 87.24a.292.292 0 0 0 .22.265.431.431 0 0 0 .393-.06.244.244 0 0 0 .079-.311.371.371 0 0 0-.333-.177.33.33 0 0 0-.359.283Z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(33.057 87.626)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.36,
    cy: 0.285,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.36,
    ry: 0.285,
    transform: "translate(38.095 88.719)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M0 95.551a2.234 2.234 0 0 1 1.226-1.4c1.216-.533 1.216 0 2.651-.349.951-.232.763-1.933.84-2.516a4.417 4.417 0 0 1 3.773-3.777 8.27 8.27 0 0 1 6.549 1.3c2.762 2.1 2.429 3.942 4.2 4.03s2.762-1.663 5.853-.613a5.786 5.786 0 0 1 3.36 3.33Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.142 95.518 1.344-.97",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.951 95.567-3.609-5.819",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.176 90.185-.427 1.89-2.873-1.261",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m14.499 92.125-1.465 2.132-2.873-.728",
    "data-name": "Path 2299"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(141.605 61.238)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M6.908 66.159c.228-1.548 3.4.775 3.4.775a7.251 7.251 0 0 1-.679-2.9c0-1.548 2.256.385 2.256.385a9.636 9.636 0 0 1-1.361-5.226c.226-2.709 3.626.388 3.626.388s-1.361-4.069-1.586-5.228 6.343 1.356 6.343 1.356a32.474 32.474 0 0 1-.679-3.485c-.118-.891 1-.52 2.135.056.251-.775.92-.829 1.664-.587l-.158-.628c-.251-1.043 1.489.133 2.935 1.244a5.624 5.624 0 0 1 2.03-3.57c1.1-.936 2.276.107 3.258 1.572l1.627.428c.02-.27.053-.548.1-.835.293-1.752 2 .137 3.18 1.692l1.253.33a7.759 7.759 0 0 1 1.9-3.958c2.038-2.129 6.8 3.872 6.8 3.872s2.945-4.069 4.078-1.928-.454 6.584-.454 6.584.679-1.551 1.584-1.928 3.4 1.354 3.4 1.354-1.358-2.709 0-3.677c1.231-.876 2.827 2.2 3.123 2.8a8.3 8.3 0 0 1-.4-5.127c.679-3.1 3.4.968 3.4.968s-.454-3.872 2.038-4.453-1.133 0 1.361 3.872 1.584-2.709 5.21-2.324 2.717 12 2.717 12l14.293-6.986s.679-1.163 2.98-1.514.87 2.679.87 2.679 3.173-2.517 4.531-2.517c.353 0 1.439 1.343 2.852 3.33.1-.2.208-.411.318-.621.86-1.613 1.586 1.994 1.89 3.838l.251.37c.183-.91.717-2.474 2.165-2.474 1.754 0 .825 5.166.531 6.6v.017c.226-.816.875-2.784 1.95-2.941 1.358-.193.228 4.26.228 4.26a3.784 3.784 0 0 1 1.584-.58c.5 0-.193 2.7-.614 4.219 1.429 2.27 2.4 3.844 2.4 3.844l-9.022-4.191h-47.43l2.293 2.711H7.822a8.6 8.6 0 0 1-.914-3.866Z",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M54.515 72.047c.6-1.987 1.572-4.455 2.933-5.376 2.416-1.636 6.345.936 8.46-.233s-2.416-12.621 4.842-13.321 9.974 10.985 13.3 12.152 4.533-3.037 9.067-3.27c3.963-.214 11.623 7.984 13.486 10.049Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54.515 72.047c.6-1.987 1.572-4.455 2.933-5.376 2.416-1.636 6.345.936 8.46-.233s-2.416-12.621 4.842-13.321 9.974 10.985 13.3 12.152 4.533-3.037 9.067-3.27c3.963-.214 11.623 7.984 13.486 10.049Z",
    "data-name": "Path 2175",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M71.265 69.989h-1.674l-1.019-31.055-2.148-5.442 2.26 3.579-.334-3.5-3.619-6.185 3.476 3.859.3-9.265.464 5.7 1.71-.857-1.5 1.906.408 6.746 1.353-1.8-1.165 3.2Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M93.436 69.989h-1.674l-1.019-31.055-2.146-5.431 2.263 3.579-.336-3.5L86.9 27.39l3.486 3.855.3-9.265.474 5.7 1.71-.857-1.5 1.906.408 6.746 1.356-1.8-1.167 3.2Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M46.167 69.989h-1.674L43.474 46.12l-2.156-4.161 2.263 2.75-.334-2.686-3.619-4.778 3.486 2.977.3-7.119.479 4.384 1.707-.655-1.5 1.463.41 5.185 1.353-1.381-1.165 2.456Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M65.412 69.989h-1.679L62.714 46.12l-2.153-4.161 2.26 2.75-.334-2.686-3.614-4.778 3.486 2.977.3-7.119.474 4.384 1.71-.655-1.5 1.463.41 5.185 1.353-1.381-1.165 2.456Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M52.81 69.989h-1.672L50.119 46.12l-2.156-4.161 2.263 2.75-.336-2.686-3.616-4.778 3.486 2.977.3-7.119.472 4.384 1.71-.655-1.5 1.463.408 5.185 1.356-1.381-1.167 2.456Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M16.484 69.989H14.81l-1.018-31.052-2.146-5.431 2.26 3.579-.334-3.5-3.619-6.19 3.486 3.855.3-9.265.469 5.7 1.71-.857-1.5 1.906.408 6.746 1.353-1.8-1.165 3.2Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M26.295 69.989h-1.672l-1.019-31.055-2.148-5.431 2.263 3.579-.336-3.5-3.631-6.192 3.485 3.855.3-9.265.471 5.7 1.71-.857-1.5 1.906.408 6.746 1.356-1.8-1.167 3.2Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M43.386 69.989h-1.672l-1.019-31.055-2.146-5.431 2.263 3.579-.336-3.5-3.626-6.192 3.486 3.855.29-9.265.471 5.7 1.71-.857-1.5 1.906.408 6.746 1.356-1.8-1.167 3.2Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M18.295 72.047c.51-1.987 1.361-4.455 2.536-5.376 2.092-1.636 5.494.936 7.324-.233s-2.092-12.621 4.184-13.321 8.631 10.985 11.508 12.152 3.924-3.037 7.846-3.27c3.43-.214 10.058 7.984 11.671 10.049Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M18.295 72.047c.51-1.987 1.361-4.455 2.536-5.376 2.092-1.636 5.494.936 7.324-.233s-2.092-12.621 4.184-13.321 8.631 10.985 11.508 12.152 3.924-3.037 7.846-3.27c3.43-.214 10.058 7.984 11.671 10.049Z",
    "data-name": "Path 2185",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M46.825 22.992s3.621 0 4.676 4.945-1.659 6.211 1.661 8.751 3.772 4.313 2.113 5.455-2.566 2.409-.454 4.311 2.416 4.692-5.13 6.468-13.279-2.536-13.582-5.453 2.265-4.821 2.416-7.23-5.132-4.692-4.528-7.989 6.037-2.03 7.546-4.566 1.66-4.692 5.282-4.692Z",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M46.825 22.992s3.621 0 4.676 4.945-1.659 6.211 1.661 8.751 3.772 4.313 2.113 5.455-2.566 2.409-.454 4.311 2.416 4.692-5.13 6.468-13.279-2.536-13.582-5.453 2.265-4.821 2.416-7.23-5.132-4.692-4.528-7.989 6.037-2.03 7.546-4.566 1.66-4.692 5.282-4.692Z",
    "data-name": "Path 2187",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M49.444 71.057h-1.32l-1.87-30.943-1.7-4.283 1.784 2.829-.255-2.763-2.859-4.9 2.755 3.056.24-7.325.372 4.5 1.353-.673-1.185 1.5.324 5.333 1.07-1.42-.922 2.527Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M69.353 72.052c-.387-1.833-1.019-4.112-1.909-4.96-1.575-1.51-4.131.857-5.509-.214s1.575-11.647-3.147-12.293-6.493 10.137-8.664 11.216-2.951-2.806-5.9-3.02c-2.581-.189-7.566 7.37-8.779 9.274Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M69.353 72.052c-.387-1.833-1.019-4.112-1.909-4.96-1.575-1.51-4.131.857-5.509-.214s1.575-11.647-3.147-12.293-6.493 10.137-8.664 11.216-2.951-2.806-5.9-3.02c-2.581-.189-7.566 7.37-8.779 9.274Z",
    "data-name": "Path 2190",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M51.067 72.047c.349-1.264.923-2.836 1.718-3.427 1.417-1.041 3.718.6 4.956-.148s-1.414-8.036 2.834-8.481 5.843 6.993 7.79 7.736 2.655-1.928 5.311-2.082c2.321-.131 6.809 5.084 7.9 6.4Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M99.039 53.982s3.476.308 8.409-3.688-4.758-18.142-8.6-21.218-11.722 16.6-8.781 20.295a11.239 11.239 0 0 0 8.972 4.611Z",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99.039 53.982s3.476.308 8.409-3.688-4.758-18.142-8.6-21.218-11.722 16.6-8.781 20.295a11.239 11.239 0 0 0 8.972 4.611Z",
    "data-name": "Path 2193",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m100.504 70.126-.55-20.6 2.38-2.152-2.561 1.229v-3.69l3.292-3.228-3.112 2 .367-2.613-.915 1.229-.548-7.38-.367 11.223-6.036-2.77 6.037 4.3v23.062",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M16.167 36.782s3.476.306 8.409-3.69-4.76-18.142-8.583-21.218-11.722 16.6-8.781 20.295a11.229 11.229 0 0 0 8.955 4.613Z",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "m18.97 69.246-1.888-36.923 2.378-2.152-2.561 1.229v-3.693l3.295-3.228-3.112 2 .367-2.613-.915 1.229-.55-7.38-.364 11.225-6.037-2.769 6.037 4.3v2l1.338 37.383",
    "data-name": "Path 2196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M91.236 71.514a1.321 1.321 0 0 1 .691-.835c.683-.313.683 0 1.491-.214.535-.139.428-1.152.471-1.5a2.567 2.567 0 0 1 2.12-2.251 4.442 4.442 0 0 1 3.667.784c1.552 1.253 1.366 2.356 2.36 2.4s1.552-.992 3.29-.366a3.357 3.357 0 0 1 1.89 1.988Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.236 71.514a1.321 1.321 0 0 1 .691-.835c.683-.313.683 0 1.491-.214.535-.139.428-1.152.471-1.5a2.567 2.567 0 0 1 2.12-2.251 4.442 4.442 0 0 1 3.667.784c1.552 1.253 1.366 2.356 2.36 2.4s1.552-.992 3.29-.366a3.357 3.357 0 0 1 1.89 1.988Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M105.608 71.439a1.485 1.485 0 0 0-1.2-1.039c-.928-.086-1.58 1.184-2.956.116s-2.2-3.784-4.332-3.7-2.1 2.253-1.855 3.148-1.17.857-1.784.75-1.34.463-1.34.81",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m103.685 71.496.754-.576",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m99.079 71.526-2.028-3.465",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m98.084 68.32-.242 1.126-1.616-.752",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m99.389 69.475-.826 1.272-1.613-.435",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M57.738 71.158a1.464 1.464 0 0 1 .764-.923c.765-.347.765 0 1.649-.231.591-.152.474-1.272.522-1.656a2.837 2.837 0 0 1 2.344-2.491 4.935 4.935 0 0 1 4.077.857c1.718 1.386 1.511 2.6 2.609 2.656s1.718-1.1 3.642-.4a3.74 3.74 0 0 1 2.087 2.193Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.738 71.158a1.464 1.464 0 0 1 .764-.923c.765-.347.765 0 1.649-.231.591-.152.474-1.272.522-1.656a2.837 2.837 0 0 1 2.344-2.491 4.935 4.935 0 0 1 4.077.857c1.718 1.386 1.511 2.6 2.609 2.656s1.718-1.1 3.642-.4a3.74 3.74 0 0 1 2.087 2.193Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m71.458 71.137.836-.638",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m66.463 71.169-2.243-3.834",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m65.374 67.622-.265 1.246-1.786-.831",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m66.803 68.901-.912 1.407-1.786-.48",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M85.485 8.475s5.216 0 6.738 7.123-2.39 8.95 2.39 12.6 5.433 6.211 3.04 7.854-3.692 3.47-.65 6.211 3.476 6.759-7.39 9.316-19.108-3.652-19.558-7.852 3.262-6.941 3.478-10.411-7.39-6.757-6.518-11.501 8.692-2.923 10.863-6.575 2.39-6.765 7.607-6.765Z",
    "data-name": "Path 2206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M85.485 8.475s5.216 0 6.738 7.123-2.39 8.95 2.39 12.6 5.433 6.211 3.04 7.854-3.692 3.47-.65 6.211 3.476 6.759-7.39 9.316-19.108-3.652-19.558-7.852 3.262-6.941 3.478-10.411-7.39-6.757-6.518-11.501 8.692-2.923 10.863-6.575 2.39-6.765 7.607-6.765Z",
    "data-name": "Path 2207",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M89.691 77.695h-1.9l-2.694-44.56-2.446-6.183 2.576 4.069-.382-3.979-4.118-7.048 3.97 4.4.341-10.55.538 6.5 1.947-.972-1.707 2.17.466 7.68 1.529-2.045-1.328 3.641Z",
    "data-name": "Path 2208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M37.358 12.67s5.211.152 6.437 7.316-2.757 8.873 1.868 12.664 5.173 6.365 2.716 7.937-3.835 3.36-.907 6.187 3.193 6.853-7.77 9.092-18.962-4.208-19.222-8.419 3.545-6.841 3.907-10.3-7.1-6.967-6.04-11.679 8.807-2.666 11.131-6.254 2.669-6.696 7.88-6.544Z",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.358 12.67s5.211.152 6.437 7.316-2.757 8.873 1.868 12.664 5.173 6.365 2.716 7.937-3.835 3.36-.907 6.187 3.193 6.853-7.77 9.092-18.962-4.208-19.222-8.419 3.545-6.841 3.907-10.3-7.1-6.967-6.04-11.679 8.807-2.666 11.131-6.254 2.669-6.696 7.88-6.544Z",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m38.761 73.471-1.9-.056-1.381-36.122-2.186-6.258 2.406 4.146-.217-3.988-3.827-7.163 3.784 4.515.78-10.535.27 6.506 1.985-.912-1.8 2.118.148 7.691 1.626-2-1.475 3.6Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M5.647 72.047c.454-1.649 1.2-3.7 2.24-4.463 1.845-1.358 4.842.777 6.462-.193s-1.845-10.479 3.695-11.062 7.62 9.122 10.16 10.092 3.463-2.523 6.926-2.718c3.027-.169 8.878 6.639 10.3 8.353Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M66.516 72.471c-.173-1.131-.268-3.213 1.088-4.348 1.924-1.617 4.809 1.009 5.53 1.009s.963-1.615 3.127-3.03 4.809.4 6.251 0-1.2-6.667 2.885-6.868 5.53 8.485 8.409 8.485 3.366-1.617 6.251-.2c2.26 1.107 3.486 3.825 3.912 4.954Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M66.516 72.471c-.173-1.131-.268-3.213 1.088-4.348 1.924-1.617 4.809 1.009 5.53 1.009s.963-1.615 3.127-3.03 4.809.4 6.251 0-1.2-6.667 2.885-6.868 5.53 8.485 8.409 8.485 3.366-1.617 6.251-.2c2.26 1.107 3.486 3.825 3.912 4.954Z",
    "data-name": "Path 2214",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m96.208 72.199 2.581-3.523",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87.324 71.927-1.289-10.209",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m80.019 72.109-1.289-3.975",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m71.022 72.289-1.292-2.801",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m95.994 68.766 1.289 1.9 3.01-.994",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87.967 62.532-1.5 2.259-2.044-2.079",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m88.816 66.147-1.937 1.988-1.934-1.266",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m79.285 69.85-2.579-1.264",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m79.47 70.573 1.292-2.801",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m70.371 70.844.647-1.808",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m70.6 71.206-1.827-.632",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M57.759 21.96a15.368 15.368 0 0 1 3.16-3.664 9.551 9.551 0 0 1 7.015-2.092c5.168.493 6.582 6.029 8.045 9.4 3.5 8.042 7.833 19.969-5.239 23.481-5.634 1.514-13.374 0-15.639-5.076a20.683 20.683 0 0 1-.742-13.76 29.962 29.962 0 0 1 3.4-8.289Z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M68.513 77.635h-1.906l-1.152-35.368-2.444-6.183 2.576 4.069-.387-3.977-4.118-7.048 3.965 4.405.341-10.55.54 6.494 1.947-.97-1.707 2.17.466 7.68 1.529-2.045-1.325 3.641Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m65.873 55.513-.036-1.045c.3 0 .734.088.734.473-.004.317-.365.487-.698.572Z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M66.263 43.535c0 .341-.41.505-.764.587l-.036-1.071c.3.011.8.071.8.484Z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M66.494 48.349c0 .364-.471.529-.836.6l-.036-1.071c.284-.013.872.019.872.471Z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M65.786 37.009c-.1-.338.377-.351.734-.317l.064 1.071a1.535 1.535 0 0 1-.798-.754Z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M67.346 71.49c0 .4-.563.559-.935.621l-.036-1.086c.204-.019.971-.049.971.465Z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m66.314 33.259.064 1.049a1.483 1.483 0 0 1-.747-.728c-.094-.321.324-.349.683-.321Z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M65.962 30.217c0 .358-.459.523-.821.6l.036-1.071c.293.004.785.062.785.471Z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M66.445 64.496c-.191-.642.8-.625 1.44-.55l.087 1.947c-.461-.222-1.323-.716-1.527-1.397Z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M66.249 66.545s1.019-.131 1.019.463c0 .428-.637.578-1 .642l-.033-1.015Z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M67.037 58.388c0 .512-.51.816-1.042.992l-.061-1.861c.522.055 1.103.249 1.103.869Z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m67.557 56.532.046 1.043a1.461 1.461 0 0 1-.734-.722c-.097-.331.341-.348.688-.321Z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m67.079 45.646.041.9a1.153 1.153 0 0 1-.479-.567c-.074-.253.165-.324.438-.333Z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M66.867 62.458c-.122-.409.607-.343.938-.291l.051 1.135c-.154-.064-.849-.375-.989-.844Z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M18.302 5.8a15.311 15.311 0 0 1 3.16-3.664A9.551 9.551 0 0 1 28.48.044c5.165.49 6.582 6.029 8.045 9.393 3.5 8.044 7.841 19.971-5.242 23.484-5.637 1.514-13.376 0-15.639-5.076a20.7 20.7 0 0 1-.744-13.76A30.046 30.046 0 0 1 18.302 5.8Z",
    "data-name": "Path 2233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M18.302 5.8a15.311 15.311 0 0 1 3.16-3.664A9.551 9.551 0 0 1 28.48.044c5.165.49 6.582 6.029 8.045 9.393 3.5 8.044 7.841 19.971-5.242 23.484-5.637 1.514-13.376 0-15.639-5.076a20.7 20.7 0 0 1-.744-13.76A30.046 30.046 0 0 1 18.302 5.8Z",
    "data-name": "Path 2234",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M29.373 71.514h-1.906l-1.883-45.4-2.444-6.183L25.714 24l-.385-3.975-4.121-7.048 3.97 4.4.337-10.542.54 6.494 1.944-.97-1.7 2.17.464 7.68 1.542-2.045-1.325 3.641Z",
    "data-name": "Path 2235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M26.674 30.164c-.1-.319.194-.428.54-.441l.059 1.171a1.524 1.524 0 0 1-.599-.73Z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m28.099 48.416.064 1.407a1.978 1.978 0 0 1-.991-.974c-.129-.442.456-.465.927-.433Z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m26.409 17.046.084 1.4a1.958 1.958 0 0 1-.981-.97c-.134-.434.424-.464.897-.43Z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M26.871 34.186a.306.306 0 0 1 0-.214 2.34 2.34 0 0 1-.764-1.071c-.194-.642.51-.8 1.228-.79l.14 2.806a1.538 1.538 0 0 1-.604-.731Z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m25.255 13.639.043-1.285a.646.646 0 0 1 .637.6c0 .342-.318.554-.68.685Z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M27.132 23.223a1.586 1.586 0 0 1-.364-.428l.02.317a2.079 2.079 0 0 1-1.075-1.019c-.14-.478.487-.473.966-.428l.031.525.02-.028v.148a1.116 1.116 0 0 1 .765-.144Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M26.271 20.038c0 .428-.469.643-.912.762l-.043-.454-.033-.944c.406.007.988.112.988.636Z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M28.503 57.539c-.206-.086-1.144-.505-1.333-1.137-.163-.553.818-.463 1.274-.394Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M26.763 46.271a.653.653 0 0 1-.38.55l-.046-1.1a.561.561 0 0 1 .426.55Z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M25.92 35.666c.3-.024 1.289-.051 1.289.63 0 .358-.336.572-.711.7a.508.508 0 0 1 .163.39c0 .334-.3.544-.642.675Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M26.349 30.899a.778.778 0 0 1-.594.655l-.053-1.259a.65.65 0 0 1 .647.604Z",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m25.66 24-.043-.467c.642.1 1.274.4 1.274 1.144 0 .692-.675 1.1-1.4 1.339l-.079-2.4Z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M27.393 50.915a1.281 1.281 0 0 1-.8 1.084l-.089-2.142a1.079 1.079 0 0 1 .889 1.058Z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m26.908 59.735-.051-1.208a3.357 3.357 0 0 1 1.687-.111l.117 2.6a4.973 4.973 0 0 1-1.753-1.281Z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M27.253 67.99a.608.608 0 0 1 .553.585.725.725 0 0 1-.51.617Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M27.705 62.533c0 .336-.3.546-.65.677l-.053-1.285c.349.047.703.201.703.608Z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M85.252 28.11a10.449 10.449 0 0 1 6.271 5.046c2.181 4.093-1.338 7.31.362 11.385s6.519 6.127 2.212 9.312-9.773-1.829-12.662-1.4-3.117 4.834-10.976 2.938-5.351-7.554-2.339-10.119.673-6.8 2.719-12.475c1.57-4.355 8.775-6.501 14.413-4.687Z",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.252 28.11a10.449 10.449 0 0 1 6.271 5.046c2.181 4.093-1.338 7.31.362 11.385s6.519 6.127 2.212 9.312-9.773-1.829-12.662-1.4-3.117 4.834-10.976 2.938-5.351-7.554-2.339-10.119.673-6.8 2.719-12.475c1.57-4.355 8.775-6.501 14.413-4.687Z",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m82.423 80.301-1.339-32.425 9.2-5.414-9.3 4.341-.074-4.686 2.051-2.733-2.322 1.786-.632-6.177-.487 9.346-6.529-3.05 6.445 4.652.176 5.761-5.323-1.668 5.413 3.009.813 27.186Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m81.983 67.796.033.805v.173a5.022 5.022 0 0 1-.91-.565c-.283-.242.329-.353.877-.413Z",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m81.625 59.038.036.9a4.674 4.674 0 0 1-.787-.5c-.268-.224.242-.35.751-.4Z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.802 63.431a4.981 4.981 0 0 1-.93-.576c-.293-.246.341-.362.889-.416l.018.413Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.036 44.528v.428a4.287 4.287 0 0 1-.7-.458c-.255-.214.2-.332.691-.394Z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M80.584 61.272a1.544 1.544 0 0 1-.54.124l-.025-.857c.417.226.965.568.565.733Z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M80.789 58.008a3.7 3.7 0 0 1-.844.246l-.051-1.713c.872.495 1.693 1.133.895 1.467Z",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M80.951 64.962a2.076 2.076 0 0 1-.8.174l-.036-1.2c.582.296 1.4.788.836 1.026Z",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m80.229 67.765-.028-.959c.387.18 1.274.642.8.842a1.484 1.484 0 0 1-.772.117Z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m81.453 54.808.038.947a4.7 4.7 0 0 1-.856-.54c-.28-.244.288-.362.818-.407Z",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M57.963 77.694a1.453 1.453 0 0 1 .764-.923c.765-.347.765 0 1.649-.231.591-.152.474-1.285.522-1.658a2.837 2.837 0 0 1 2.344-2.489 4.915 4.915 0 0 1 4.077.857c1.718 1.386 1.511 2.6 2.609 2.654s1.718-1.1 3.642-.4a3.74 3.74 0 0 1 2.087 2.193Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.963 77.694a1.453 1.453 0 0 1 .764-.923c.765-.347.765 0 1.649-.231.591-.152.474-1.285.522-1.658a2.837 2.837 0 0 1 2.344-2.489 4.915 4.915 0 0 1 4.077.857c1.718 1.386 1.511 2.6 2.609 2.654s1.718-1.1 3.642-.4a3.74 3.74 0 0 1 2.087 2.193Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m71.684 77.673.836-.638",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m66.688 77.706-2.245-3.834",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m65.601 74.159-.265 1.247-1.789-.831",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m67.029 75.437-.912 1.4-1.786-.48",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M71.645 80.425a3.207 3.207 0 0 1 1.695-2.047c1.677-.769 1.677 0 3.657-.512 1.312-.341 1.052-2.825 1.159-3.675a6.284 6.284 0 0 1 5.2-5.521 10.9 10.9 0 0 1 9.026 1.9c3.807 3.073 3.351 5.761 5.79 5.89s3.794-2.433 8.068-.9a8.262 8.262 0 0 1 4.628 4.866Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m102.184 80.379 1.855-1.416",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m91.198 80.451-4.977-8.507",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m78.396 80.237-1.6-.85",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m88.788 72.582-.591 2.765-3.963-1.844",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m91.949 75.418-2.026 3.118-3.963-1.062",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m102.268 78.607.339 1.559 1.855-.283",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m77.89 79.884.252-.78",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(88.511 72.255)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M86.009 71.942a.227.227 0 0 0 .154.222.314.314 0 0 0 .3-.038.205.205 0 0 0 .071-.25.275.275 0 0 0-.249-.148.256.256 0 0 0-.276.214Z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(83.773 73.176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M85.613 77.433a.232.232 0 0 0 .167.213.312.312 0 0 0 .3-.049.2.2 0 0 0 .059-.251.278.278 0 0 0-.254-.14.254.254 0 0 0-.272.227Z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(91.397 75.148)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(77.867 78.875)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M76.552 79.34a.232.232 0 0 0 .167.213.312.312 0 0 0 .3-.048.2.2 0 0 0 .06-.25.277.277 0 0 0-.252-.142.254.254 0 0 0-.275.227Z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(101.995 78.378)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M103.855 78.842a.277.277 0 1 0 .273-.229.254.254 0 0 0-.273.229Z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(104.309 79.641)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M21.976 54.133s4.131.366 10-4.382-5.65-21.552-10.214-25.2-13.921 19.723-10.43 24.107a13.345 13.345 0 0 0 10.644 5.475Z",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m23.717 73.311-.652-24.473 2.824-2.555-3.043 1.461V43.36l3.912-3.836-3.692 2.375.433-3.105-1.086 1.461-.652-8.766-.433 13.332-7.174-3.288 7.174 5.114v27.394",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M21.789 62.733c-.183-.385.986-.428 1.3-.443l.031 1.169c-.411-.137-1.18-.411-1.331-.726Z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M21.004 52.845c.594.124 1.809.428 1.455.72a3.1 3.1 0 0 1-1.455.364Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M21.704 56.141c-.186-.39 1.208-.39 1.208-.39v.019l.028 1.028c-.329-.098-1.091-.353-1.236-.657Z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M21.796 51.067c-.138-.291.6-.366.984-.385l.026.97c-.371-.127-.893-.341-1.01-.585Z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m23.163 68.057.092.542.018.672c-.318-.09-1.307-.4-1.483-.771-.212-.443 1.373-.443 1.373-.443Z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M22.646 59.792a3.511 3.511 0 0 1-1.644.415v-1.231c.681.14 2.044.48 1.644.816Z",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M22.553 48.491a3.3 3.3 0 0 1-1.547.371v-1.11c.547.109 1.918.418 1.547.739Z",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M23.701 41.53c.609.15 1.356.39 1.068.642a2.4 2.4 0 0 1-1.1.332Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M21.002 64.752c.68.143 2.039.48 1.644.816a3.484 3.484 0 0 1-1.644.415Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M22.517 44.355v1c-.37-.12-.961-.349-1.086-.612-.16-.319.755-.378 1.086-.388Z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M7.839 73.579a3.023 3.023 0 0 1 2.982-3.073c1.59-.064 3.338.833 4.663.092 1.083-.606 1.106-1.9 1.228-3a4.751 4.751 0 0 1 1.325-3 3.716 3.716 0 0 1 3.481-.912c2.444.756 2.594 4.125 5.1 4.746 1.728.428 3.529-.777 5.3-.51 2.171.326 3.152 2.345 4.819 3.333.173.1.9.544 1.728 1.054.7.428 1.465.9 2.039 1.268Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.839 73.579a3.023 3.023 0 0 1 2.982-3.073c1.59-.064 3.338.833 4.663.092 1.083-.606 1.106-1.9 1.228-3a4.751 4.751 0 0 1 1.325-3 3.716 3.716 0 0 1 3.481-.912c2.444.756 2.594 4.125 5.1 4.746 1.728.428 3.529-.777 5.3-.51 2.171.326 3.152 2.345 4.819 3.333.173.1.9.544 1.728 1.054.7.428 1.465.9 2.039 1.268Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.679 73.459 1.371-3.367",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.942 73.548-2.846-6.468",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.925 73.548-1.687-1.33",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.067 72.662-.905-2.037",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.217 72.164 3.137-.655",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.843 69.029.843-1.152",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23.552 70.801-3.055-1.416",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.698 73.049-2.808-.831",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.28 72.131 1.791-2.658",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M21.642 67.08a.232.232 0 0 0 .169.212.311.311 0 0 0 .3-.051.2.2 0 0 0 .057-.25.278.278 0 0 0-.254-.14.3.3 0 0 0-.192.067.21.21 0 0 0-.08.162Z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M21.722 67.858a.277.277 0 1 0 .273-.229.3.3 0 0 0-.194.066.21.21 0 0 0-.079.163Z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(18.768 69.156)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(23.779 69.244)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(19.785 71.955)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(11.072 72.045)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M28.764 70.091a.232.232 0 0 0 .167.213.312.312 0 0 0 .3-.048.2.2 0 0 0 .06-.25.277.277 0 0 0-.252-.142.254.254 0 0 0-.275.227Z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(26.942 70.402)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.273,
    cy: 0.229,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.273,
    ry: 0.229,
    transform: "translate(31.048 71.28)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M0 76.769a1.769 1.769 0 0 1 .93-1.127c.922-.428.922 0 2.011-.281.721-.186.578-1.553.637-2.022a3.462 3.462 0 0 1 2.862-3.035 5.992 5.992 0 0 1 4.967 1.043c2.095 1.69 1.842 3.167 3.183 3.238s2.095-1.336 4.439-.493a4.534 4.534 0 0 1 2.548 2.675Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.793 76.744 1.019-.78",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.581 76.782-2.737-4.675",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.235 72.458-.324 1.519-2.179-1.013",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.996 74.017 9.885 75.73l-2.179-.585",
    "data-name": "Path 2299"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h369.025v48.389H0z",
    "data-name": "Rectangle 435",
    transform: "translate(13.367 117.483)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m346.022 110.775 6.734-1.413.273 27.5-12.243-3.427a45.993 45.993 0 0 0 4.24-10.823 49.412 49.412 0 0 0 .996-11.837Z",
    "data-name": "Path 2550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m322.292 44.623-7.6-6.746 8.472-.667 5.023 13.459 8.894 5.346-.854 11.255-3.2 4.09Z",
    "data-name": "Path 2551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.336 94.744 36.174 72.063l-7.541-9.266v-2.578l7.043 7.944 1.288-10.866 1.2-1.493-1.2 13.294 5.112 9.389 1.283-16.647 1.253 1.484v19.517l4.434 8.855 1.833 2.342-5.86 12.775-2.944 7.885-.71 6.972 1.471 11.311-6.34 1.544.369-14.138 3.1-11.045Z",
    "data-name": "Path 2552"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m350.579 142.99-1.946-1.223-2.081 1.268-2.081-1.268-2.081 1.268-2.084-1.268-2.081 1.268-2.077-1.265-2.081 1.268-2.081-1.268-2.081 1.268-2.081-1.268-2.081 1.268-2.081-1.268-2.123 1.41-2.037-1.41-2.081 1.268-2.081-1.268-2.081 1.268v1.681h41.452v-1.729l-1.721-1.223Z",
    "data-name": "Path 235",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m277.859 143.038-2.078-1.268-2.081 1.268-2.078-1.268-2.081 1.268-2.078-1.268-2.081 1.268-2.081-1.268-2.081 1.268-2.081-1.268-2.078 1.268v1.681l20.8-.536Z",
    "data-name": "Path 2129",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m257.254 143.038 2.078-1.268 2.081 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.078 1.268 2.081-1.268 2.078 1.268 2.081-1.268",
    "data-name": "Path 2130",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 85",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M337.295 141.232c2.109-4.27 6.507-14.07 7.154-16.676a57.6 57.6 0 0 0 0-26.5c-1.211-5.022-4.544-13.179-9.984-23.563s-9.831-24.775-11.79-29.107-20.875-16.11-25.11-18.884l-4.235-2.77",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M365.932 16.45s-8.473 9.876-13.011 16.46-16.489 34.31-16.489 34.31 7.262 13.168 10.286 20.439 6.354 17.322 6.354 26.333.15 17.672.15 22a16.308 16.308 0 0 0 1.16 5.511",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m341.205 18.057-.539 31.311-.443.8-6.826 12.533a93.152 93.152 0 0 1-4.069-9.176c-3.1-7.719-7.763-20.439-7.61-22s12.45-15.942 13.208-17.154",
    "data-name": "Path 224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M295.592 23.381s22.236 14.2 23.746 14.552-8.014-20.618-8.014-20.618",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M313.593 17.142s5.736 9.183 6.5 10.048 12.7-13.34 12.7-13.34",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m352.919 8.654 1.966 17.33 11.347-12.822",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m342.716 15.458 1.8 26.574 8.33-15.07-1.163-20.669",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M349.742 141.502s-.258-2.23.911-7.438a81.043 81.043 0 0 0 1.3-21.574",
    "data-name": "Path 229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M350.653 117.111a57.846 57.846 0 0 1-.392 9.522",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M349.095 124.998a40.415 40.415 0 0 1-.911 7.737 35.571 35.571 0 0 1-1.689 5.949",
    "data-name": "Path 231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M349.353 98.066s1.689 6.7 2.078 9.822",
    "data-name": "Path 232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M349.873 108.632s.389 4.314.519 5.5",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m345.587 87.059-5.717-11.756",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m341.17 79.916-5.197-9.223",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M298.085 70.153a2 2 0 0 0 1.389 1.314 4.142 4.142 0 0 0 2.361-.6 6.512 6.512 0 0 0-2.084-1.336 1.6 1.6 0 0 0-1.667.62Z",
    "data-name": "Path 296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M308.454 38.597a3.008 3.008 0 0 0-3-.9c-1.721.558-3.311 2.891-3.311 2.891a9.993 9.993 0 0 0 4.1.365 3.254 3.254 0 0 0 2.211-2.356Z",
    "data-name": "Path 297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330.466 91.376a3.008 3.008 0 0 0-3-.9c-1.721.558-3.314 2.891-3.314 2.891a10 10 0 0 0 4.1.365 3.269 3.269 0 0 0 2.214-2.356Z",
    "data-name": "Path 298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M296.476 34.842a3.569 3.569 0 0 0-2 2.708 10.191 10.191 0 0 0 .851 4.668 13.552 13.552 0 0 0 2.052-4.084 3.689 3.689 0 0 0-.903-3.292Z",
    "data-name": "Path 299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M305.701 105.162a3.585 3.585 0 0 0-2 2.708 10.222 10.222 0 0 0 .838 4.668 13.552 13.552 0 0 0 2.052-4.084 3.7 3.7 0 0 0-.89-3.292Z",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M326.885 35.046a2 2 0 0 0 1.389 1.314 4.156 4.156 0 0 0 2.364-.6 6.544 6.544 0 0 0-2.087-1.336 1.6 1.6 0 0 0-1.666.622Z",
    "data-name": "Path 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M312.998 31.454a2 2 0 0 0 1.386 1.314 4.147 4.147 0 0 0 2.364-.6 6.512 6.512 0 0 0-2.087-1.336 1.6 1.6 0 0 0-1.663.622Z",
    "data-name": "Path 302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M284.331 104.785a2 2 0 0 0 1.386 1.314 4.177 4.177 0 0 0 2.364-.6 6.534 6.534 0 0 0-2.087-1.339 1.607 1.607 0 0 0-1.663.625Z",
    "data-name": "Path 303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M332.984 25.232a3.59 3.59 0 0 0 2.231 2.453c1.74.489 4.12-.69 4.12-.69a11.574 11.574 0 0 0-3.435-2.591 2.741 2.741 0 0 0-2.916.828Z",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M306.644 20.91a3.59 3.59 0 0 0 2.231 2.453c1.74.489 4.12-.686 4.12-.686a11.6 11.6 0 0 0-3.426-2.61 2.768 2.768 0 0 0-2.925.843Z",
    "data-name": "Path 305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M344.924 16.644a4.036 4.036 0 0 0 1.275 3.241 7.131 7.131 0 0 0 4.041 1.15 13.611 13.611 0 0 0-2.32-3.891 2.666 2.666 0 0 0-2.996-.5Z",
    "data-name": "Path 306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M285.344 54.441a3.7 3.7 0 0 0-2.078-2.635c-1.711-.635-4.143.336-4.143.336a11.906 11.906 0 0 0 3.257 2.876 2.709 2.709 0 0 0 2.964-.577Z",
    "data-name": "Path 307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M338.235 15.688a3.69 3.69 0 0 0-2.075-2.639c-1.711-.635-4.143.339-4.143.339a11.854 11.854 0 0 0 3.257 2.876 2.7 2.7 0 0 0 2.961-.576Z",
    "data-name": "Path 308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M284.714 37.82a3.694 3.694 0 0 0-2.078-2.635c-1.711-.635-4.143.339-4.143.339a11.971 11.971 0 0 0 3.257 2.876 2.7 2.7 0 0 0 2.964-.58Z",
    "data-name": "Path 309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M284.714 37.82a3.694 3.694 0 0 0-2.078-2.635c-1.711-.635-4.143.339-4.143.339a11.971 11.971 0 0 0 3.257 2.876 2.7 2.7 0 0 0 2.964-.58Z",
    "data-name": "Path 310",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M326.267 63.737a3.687 3.687 0 0 0-2.074-2.635c-1.711-.635-4.143.339-4.143.339a11.917 11.917 0 0 0 3.257 2.876 2.692 2.692 0 0 0 2.96-.58Z",
    "data-name": "Path 311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M326.267 63.737a3.687 3.687 0 0 0-2.074-2.635c-1.711-.635-4.143.339-4.143.339a11.917 11.917 0 0 0 3.257 2.876 2.692 2.692 0 0 0 2.96-.58Z",
    "data-name": "Path 312",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M307.609 51.685a2.922 2.922 0 0 0-3.094.15c-1.5 1.1-2.422 3.883-2.422 3.883a10.255 10.255 0 0 0 4.012-1.04 3.6 3.6 0 0 0 1.504-2.993Z",
    "data-name": "Path 313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M307.609 51.685a2.922 2.922 0 0 0-3.094.15c-1.5 1.1-2.422 3.883-2.422 3.883a10.255 10.255 0 0 0 4.012-1.04 3.6 3.6 0 0 0 1.504-2.993Z",
    "data-name": "Path 314",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M358.509 84.197a2.936 2.936 0 0 0 3.094.237c1.616-.909 2.772-3.558 2.772-3.558a10.05 10.05 0 0 0-4.085.536 3.492 3.492 0 0 0-1.781 2.785Z",
    "data-name": "Path 315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M358.509 84.197a2.936 2.936 0 0 0 3.094.237c1.616-.909 2.772-3.558 2.772-3.558a10.05 10.05 0 0 0-4.085.536 3.492 3.492 0 0 0-1.781 2.785Z",
    "data-name": "Path 316",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M364.483 31.735a2.936 2.936 0 0 0 3.094.237c1.616-.909 2.772-3.559 2.772-3.559a10.05 10.05 0 0 0-4.085.536 3.492 3.492 0 0 0-1.781 2.786Z",
    "data-name": "Path 317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M364.483 31.735a2.936 2.936 0 0 0 3.094.237c1.616-.909 2.772-3.559 2.772-3.559a10.05 10.05 0 0 0-4.085.536 3.492 3.492 0 0 0-1.781 2.786Z",
    "data-name": "Path 318",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.442 15.958a2.913 2.913 0 0 0-3.1.15c-1.52 1.106-2.419 3.88-2.419 3.88a10.245 10.245 0 0 0 4.009-1.04 3.6 3.6 0 0 0 1.51-2.99Z",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M320.442 15.958a2.913 2.913 0 0 0-3.1.15c-1.52 1.106-2.419 3.88-2.419 3.88a10.245 10.245 0 0 0 4.009-1.04 3.6 3.6 0 0 0 1.51-2.99Z",
    "data-name": "Path 320",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M309.537 26.089a2.908 2.908 0 0 0-3.094.15c-1.517 1.106-2.422 3.88-2.422 3.88a10.255 10.255 0 0 0 4.012-1.04 3.59 3.59 0 0 0 1.504-2.99Z",
    "data-name": "Path 321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M309.537 26.089a2.908 2.908 0 0 0-3.094.15c-1.517 1.106-2.422 3.88-2.422 3.88a10.255 10.255 0 0 0 4.012-1.04 3.59 3.59 0 0 0 1.504-2.99Z",
    "data-name": "Path 322",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M302.096 22.954a4.123 4.123 0 0 0-.7 3.46 8.873 8.873 0 0 0 2.622 3.7 15.048 15.048 0 0 0 .191-4.7 3.173 3.173 0 0 0-2.113-2.46Z",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M302.096 22.954a4.123 4.123 0 0 0-.7 3.46 8.873 8.873 0 0 0 2.622 3.7 15.048 15.048 0 0 0 .191-4.7 3.173 3.173 0 0 0-2.113-2.46Z",
    "data-name": "Path 324",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M283.503 20.064a3.93 3.93 0 0 0 1.593 3.051 7.023 7.023 0 0 0 4.143.595 13.084 13.084 0 0 0-2.725-3.529 2.719 2.719 0 0 0-3.011-.117Z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M283.503 20.064a3.93 3.93 0 0 0 1.593 3.051 7.023 7.023 0 0 0 4.143.595 13.084 13.084 0 0 0-2.725-3.529 2.719 2.719 0 0 0-3.011-.117Z",
    "data-name": "Path 326",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M284.631 29.053a2.966 2.966 0 0 0 2.986-.938c1.262-1.464 1.593-4.405 1.593-4.405a10.772 10.772 0 0 0-3.706 2.044 3.762 3.762 0 0 0-.873 3.299Z",
    "data-name": "Path 327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M284.631 29.053a2.966 2.966 0 0 0 2.986-.938c1.262-1.464 1.593-4.405 1.593-4.405a10.772 10.772 0 0 0-3.706 2.044 3.762 3.762 0 0 0-.873 3.299Z",
    "data-name": "Path 328",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M353.289 38.407a3.77 3.77 0 0 0 1.635-3.015 9.871 9.871 0 0 0-1.44-4.475 14.231 14.231 0 0 0-1.5 4.38 3.558 3.558 0 0 0 1.305 3.11Z",
    "data-name": "Path 329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M353.289 38.407a3.77 3.77 0 0 0 1.635-3.015 9.871 9.871 0 0 0-1.44-4.475 14.231 14.231 0 0 0-1.5 4.38 3.558 3.558 0 0 0 1.305 3.11Z",
    "data-name": "Path 330",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M359.726 33.123a3.67 3.67 0 0 0-2.1-2.606c-1.718-.61-4.143.4-4.143.4a11.864 11.864 0 0 0 3.289 2.829 2.71 2.71 0 0 0 2.954-.623Z",
    "data-name": "Path 331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M359.726 33.123a3.67 3.67 0 0 0-2.1-2.606c-1.718-.61-4.143.4-4.143.4a11.864 11.864 0 0 0 3.289 2.829 2.71 2.71 0 0 0 2.954-.623Z",
    "data-name": "Path 332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M344.937 21.118a3.932 3.932 0 0 0 1.593 3.048 7.068 7.068 0 0 0 4.143.6 12.883 12.883 0 0 0-2.706-3.551 2.693 2.693 0 0 0-3.03-.097Z",
    "data-name": "Path 333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M344.937 21.118a3.932 3.932 0 0 0 1.593 3.048 7.068 7.068 0 0 0 4.143.6 12.883 12.883 0 0 0-2.706-3.551 2.693 2.693 0 0 0-3.03-.097Z",
    "data-name": "Path 334",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M346.065 30.105a2.962 2.962 0 0 0 2.989-.938c1.262-1.467 1.593-4.4 1.593-4.4a10.835 10.835 0 0 0-3.709 2.04 3.75 3.75 0 0 0-.873 3.298Z",
    "data-name": "Path 335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M346.065 30.105a2.962 2.962 0 0 0 2.989-.938c1.262-1.467 1.593-4.4 1.593-4.4a10.835 10.835 0 0 0-3.709 2.04 3.75 3.75 0 0 0-.873 3.298Z",
    "data-name": "Path 336",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M313.352 33.71a3.92 3.92 0 0 0 1.593 3.048 7.069 7.069 0 0 0 4.143.6 12.883 12.883 0 0 0-2.705-3.551 2.693 2.693 0 0 0-3.031-.097Z",
    "data-name": "Path 337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M313.352 33.71a3.92 3.92 0 0 0 1.593 3.048 7.069 7.069 0 0 0 4.143.6 12.883 12.883 0 0 0-2.705-3.551 2.693 2.693 0 0 0-3.031-.097Z",
    "data-name": "Path 338",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.479 42.696a2.971 2.971 0 0 0 2.989-.938c1.265-1.464 1.593-4.4 1.593-4.4a10.8 10.8 0 0 0-3.706 2.04 3.767 3.767 0 0 0-.876 3.298Z",
    "data-name": "Path 339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M314.479 42.696a2.971 2.971 0 0 0 2.989-.938c1.265-1.464 1.593-4.4 1.593-4.4a10.8 10.8 0 0 0-3.706 2.04 3.767 3.767 0 0 0-.876 3.298Z",
    "data-name": "Path 340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.708 37.871a3.58 3.58 0 0 0-2.256-2.434c-1.753-.474-4.114.73-4.114.73a11.406 11.406 0 0 0 3.448 2.555 2.786 2.786 0 0 0 2.922-.851Z",
    "data-name": "Path 341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M329.708 37.871a3.58 3.58 0 0 0-2.256-2.434c-1.753-.474-4.114.73-4.114.73a11.406 11.406 0 0 0 3.448 2.555 2.786 2.786 0 0 0 2.922-.851Z",
    "data-name": "Path 342",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M326.468 29.582a3.188 3.188 0 0 0-2.651 1.825 10.333 10.333 0 0 0-.484 4.745 12.3 12.3 0 0 0 3.075-3.128 3.832 3.832 0 0 0 .06-3.442Z",
    "data-name": "Path 343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M326.468 29.582a3.188 3.188 0 0 0-2.651 1.825 10.333 10.333 0 0 0-.484 4.745 12.3 12.3 0 0 0 3.075-3.128 3.832 3.832 0 0 0 .06-3.442Z",
    "data-name": "Path 344",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M323.727 26.75a3.583 3.583 0 0 0-2.253-2.438c-1.749-.474-4.117.73-4.117.73a11.392 11.392 0 0 0 3.451 2.555 2.777 2.777 0 0 0 2.919-.847Z",
    "data-name": "Path 345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M323.727 26.75a3.583 3.583 0 0 0-2.253-2.438c-1.749-.474-4.117.73-4.117.73a11.392 11.392 0 0 0 3.451 2.555 2.777 2.777 0 0 0 2.919-.847Z",
    "data-name": "Path 346",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.491 18.461a3.191 3.191 0 0 0-2.648 1.825 10.4 10.4 0 0 0-.488 4.745 12.333 12.333 0 0 0 3.075-3.124 3.843 3.843 0 0 0 .061-3.446Z",
    "data-name": "Path 347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M320.491 18.461a3.191 3.191 0 0 0-2.648 1.825 10.4 10.4 0 0 0-.488 4.745 12.333 12.333 0 0 0 3.075-3.124 3.843 3.843 0 0 0 .061-3.446Z",
    "data-name": "Path 348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M335.231 44.783a3.92 3.92 0 0 0 1.593 3.048 7.069 7.069 0 0 0 4.143.6 12.885 12.885 0 0 0-2.705-3.551 2.693 2.693 0 0 0-3.031-.097Z",
    "data-name": "Path 349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M335.231 44.783a3.92 3.92 0 0 0 1.593 3.048 7.069 7.069 0 0 0 4.143.6 12.885 12.885 0 0 0-2.705-3.551 2.693 2.693 0 0 0-3.031-.097Z",
    "data-name": "Path 350",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.356 53.759a2.971 2.971 0 0 0 2.989-.938c1.265-1.464 1.593-4.4 1.593-4.4a10.8 10.8 0 0 0-3.706 2.04 3.768 3.768 0 0 0-.876 3.298Z",
    "data-name": "Path 351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M336.356 53.759a2.971 2.971 0 0 0 2.989-.938c1.265-1.464 1.593-4.4 1.593-4.4a10.8 10.8 0 0 0-3.706 2.04 3.768 3.768 0 0 0-.876 3.298Z",
    "data-name": "Path 352",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M358.706 61.901a2.917 2.917 0 0 0-3.094.15c-1.517 1.1-2.422 3.883-2.422 3.883a10.256 10.256 0 0 0 4.012-1.04 3.6 3.6 0 0 0 1.504-2.993Z",
    "data-name": "Path 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M358.706 61.901a2.917 2.917 0 0 0-3.094.15c-1.517 1.1-2.422 3.883-2.422 3.883a10.256 10.256 0 0 0 4.012-1.04 3.6 3.6 0 0 0 1.504-2.993Z",
    "data-name": "Path 354",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M351.262 58.769a4.123 4.123 0 0 0-.7 3.46 8.873 8.873 0 0 0 2.623 3.7 14.959 14.959 0 0 0 .191-4.708 3.162 3.162 0 0 0-2.114-2.452Z",
    "data-name": "Path 355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M351.262 58.769a4.123 4.123 0 0 0-.7 3.46 8.873 8.873 0 0 0 2.623 3.7 14.959 14.959 0 0 0 .191-4.708 3.162 3.162 0 0 0-2.114-2.452Z",
    "data-name": "Path 356",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M338.873 34.955a14.485 14.485 0 0 1 1.37 4.442 7.636 7.636 0 0 1-3.645-2.3 4.225 4.225 0 0 1-.491-3.507 2.787 2.787 0 0 1 2.766 1.365Zm-2.731 4.774a3.429 3.429 0 0 0-1.883 2.694 2.943 2.943 0 0 0 3.078.391c1.644-.829 2.906-3.416 2.906-3.416a10.045 10.045 0 0 0-4.101.33Z",
    "data-name": "Path 357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M346.473 37.444a10.094 10.094 0 0 1-4.095-.431s1.593-2.321 3.349-2.832a3.023 3.023 0 0 1 2.983.953 3.234 3.234 0 0 1-2.237 2.31Zm-2.645-4.854a3.525 3.525 0 0 0-1.348-3.084 3.78 3.78 0 0 0-1.593 3.04 9.9 9.9 0 0 0 1.495 4.453 14.14 14.14 0 0 0 1.446-4.409Z",
    "data-name": "Path 358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M328.172 19.9a12.473 12.473 0 0 1-2.817 3.434 10.388 10.388 0 0 1 .108-4.767 3.289 3.289 0 0 1 2.492-2.11 3.82 3.82 0 0 1 .217 3.443Zm-4.958-.588a2.681 2.681 0 0 0-2.954-.679 4.1 4.1 0 0 0 1.112 3.314 7.189 7.189 0 0 0 3.983 1.387 13.671 13.671 0 0 0-2.141-4.022Z",
    "data-name": "Path 359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M313.485 30.736a12.537 12.537 0 0 1-2.817 3.434 10.4 10.4 0 0 1 .108-4.77 3.271 3.271 0 0 1 2.492-2.106 3.82 3.82 0 0 1 .217 3.442Zm-4.958-.588a2.681 2.681 0 0 0-2.954-.679 4.1 4.1 0 0 0 1.112 3.31 7.205 7.205 0 0 0 3.983 1.391 13.67 13.67 0 0 0-2.141-4.022Z",
    "data-name": "Path 360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M294.563 20.699a14.485 14.485 0 0 1 1.37 4.442 7.654 7.654 0 0 1-3.649-2.3 4.2 4.2 0 0 1-.491-3.5 2.786 2.786 0 0 1 2.77 1.358Zm-2.731 4.774a3.429 3.429 0 0 0-1.883 2.694 2.941 2.941 0 0 0 3.078.391c1.647-.828 2.906-3.416 2.906-3.416a10.045 10.045 0 0 0-4.101.331Z",
    "data-name": "Path 361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M346.409 49.419a14.966 14.966 0 0 1 .054-4.712 8.769 8.769 0 0 1 2.728 3.6 4.14 4.14 0 0 1-.6 3.482 3.12 3.12 0 0 1-2.182-2.37Zm4.012-3.4a3.018 3.018 0 0 0 2.581-1.781 3.216 3.216 0 0 0-2.772-1.588c-1.8.124-3.757 2.055-3.757 2.055a10.422 10.422 0 0 0 3.948 1.316Z",
    "data-name": "Path 362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M300.972 24.319a10.9 10.9 0 0 1-3.776-1.869s2.161-1.635 3.955-1.5a3.37 3.37 0 0 1 2.578 1.967 2.9 2.9 0 0 1-2.757 1.402Zm-1.2-5.54a3.805 3.805 0 0 0-.446-3.412 3.35 3.35 0 0 0-2.342 2.321 10.25 10.25 0 0 0 .21 4.745 12.7 12.7 0 0 0 2.58-3.654Z",
    "data-name": "Path 363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M267.305 56.919a10.058 10.058 0 0 1 4.114-.04s-1.4 2.493-3.085 3.2a2.969 2.969 0 0 1-3.053-.609 3.352 3.352 0 0 1 2.024-2.551Zm3.053 4.5a3.441 3.441 0 0 0 1.612 2.92 3.915 3.915 0 0 0 1.326-3.208 9.564 9.564 0 0 0-1.877-4.259 14.73 14.73 0 0 0-1.057 4.551Z",
    "data-name": "Path 364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M361.86 15.856a14.638 14.638 0 0 1-1.106 4.537 9.593 9.593 0 0 1-1.832-4.281 3.9 3.9 0 0 1 1.355-3.194 3.426 3.426 0 0 1 1.583 2.938Zm-4.63 2.113a2.782 2.782 0 0 0-2.893.967 3.538 3.538 0 0 0 2.326 2.343c1.762.405 4.092-.887 4.092-.887a11.371 11.371 0 0 0-3.525-2.423Z",
    "data-name": "Path 365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M277.621 71.825a2.094 2.094 0 0 0-1.625 1.263 6.551 6.551 0 0 0-.178 3.018 8.065 8.065 0 0 0 1.861-2.091 2.442 2.442 0 0 0-.058-2.19Z",
    "data-name": "Path 366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M277.621 71.825a2.094 2.094 0 0 0-1.625 1.263 6.551 6.551 0 0 0-.178 3.018 8.065 8.065 0 0 0 1.861-2.091 2.442 2.442 0 0 0-.058-2.19Z",
    "data-name": "Path 367",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.726 79.131a2.092 2.092 0 0 0-1.628 1.259 6.6 6.6 0 0 0-.178 3.018 8.113 8.113 0 0 0 1.864-2.091 2.438 2.438 0 0 0-.058-2.186Z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M331.726 79.131a2.092 2.092 0 0 0-1.628 1.259 6.6 6.6 0 0 0-.178 3.018 8.113 8.113 0 0 0 1.864-2.091 2.438 2.438 0 0 0-.058-2.186Z",
    "data-name": "Path 369",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M268.746 108.706a2.093 2.093 0 0 0-1.625 1.263 6.552 6.552 0 0 0-.178 3.018 8.065 8.065 0 0 0 1.861-2.091 2.467 2.467 0 0 0-.058-2.19Z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.746 108.706a2.093 2.093 0 0 0-1.625 1.263 6.552 6.552 0 0 0-.178 3.018 8.065 8.065 0 0 0 1.861-2.091 2.467 2.467 0 0 0-.058-2.19Z",
    "data-name": "Path 371",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M334.657 46.823a1.846 1.846 0 0 0-1.963.095 5.955 5.955 0 0 0-1.536 2.46 6.528 6.528 0 0 0 2.549-.661 2.236 2.236 0 0 0 .95-1.894Z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M334.657 46.823a1.846 1.846 0 0 0-1.963.095 5.955 5.955 0 0 0-1.536 2.46 6.528 6.528 0 0 0 2.549-.661 2.236 2.236 0 0 0 .95-1.894Z",
    "data-name": "Path 373",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Flying kite-bro"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.203 138.142a3.4 3.4 0 0 0 .946-.519s-.389-.384-.416-.384c-.319-.231-1.05-.469-1.376-.161a.63.63 0 0 0 0 .853.945.945 0 0 0 .846.211Z",
    "data-name": "Path 2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.252 134.614s-.148-.561-.158-.592c-.154-.384-.651-1.057-1.07-1a.492.492 0 0 0-.346.242.638.638 0 0 0-.073.457 1.144 1.144 0 0 0 .607.73 3.132 3.132 0 0 0 1.04.163Z",
    "data-name": "Path 2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.041 144.072q.218.3.393.576h.3c-.151-.219-.336-.469-.52-.738-.114-.158-.242-.323-.369-.488a5.311 5.311 0 0 0 .335-.519 2.862 2.862 0 0 0 .876.069c.02.2.04.384.054.576.034.419.054.788.071 1.1h.238a22.62 22.62 0 0 0-.091-1.122c-.02-.2-.044-.419-.07-.642a2.855 2.855 0 0 0 .829-.43 1.1 1.1 0 0 0 .352-.769.533.533 0 0 0-.159-.367.4.4 0 0 0-.344-.11c-.366.077-.641.769-.688 1.153v.419a1.9 1.9 0 0 0-.034-.269c-.027-.184-.054-.384-.084-.565l-.057-.288c-.02-.096-.044-.2-.064-.292a10.2 10.2 0 0 0-.191-.684 2.667 2.667 0 0 0 .849-.277 1.054 1.054 0 0 0 .456-.715.556.556 0 0 0-.111-.389.421.421 0 0 0-.325-.169c-.372 0-.738.653-.832 1.015 0 .023-.047.3-.067.442a9.146 9.146 0 0 0-.131-.407c-.138-.384-.289-.788-.436-1.184l-.131-.361a2.731 2.731 0 0 0 .879-.281 1.051 1.051 0 0 0 .453-.715.553.553 0 0 0-.11-.39.417.417 0 0 0-.326-.167c-.369 0-.735.649-.829 1.015 0 .027-.067.415-.077.515-.1-.265-.191-.53-.275-.8a9.456 9.456 0 0 1-.285-1.1 2.8 2.8 0 0 0 .886-.281 1.051 1.051 0 0 0 .453-.715.553.553 0 0 0-.11-.39.417.417 0 0 0-.326-.167c-.369 0-.735.649-.829 1.015 0 .023-.05.319-.07.461h-.02a7.246 7.246 0 0 1-.107-1.153v-.615a2.524 2.524 0 0 0 .886-.169 1.008 1.008 0 0 0 .52-.649.563.563 0 0 0-.07-.4.433.433 0 0 0-.309-.208c-.369-.035-.8.557-.923.907 0 .019-.057.219-.094.384a1.447 1.447 0 0 1 .017-.269c.023-.319.06-.611.1-.869.02-.146.044-.277.064-.384a2.946 2.946 0 0 0 .715-.615 1.174 1.174 0 0 0 .2-.853.5.5 0 0 0-.226-.318.389.389 0 0 0-.358-.02c-.336.161-.483.911-.453 1.287 0 .034.091.538.1.534-.023.119-.047.246-.07.384-.04.258-.087.55-.114.869a10.056 10.056 0 0 0-.054 1.041 7.381 7.381 0 0 0 .087 1.153c-.05-.108-.2-.411-.215-.434-.195-.3-.728-.769-1.08-.63a.469.469 0 0 0-.258.283.566.566 0 0 0 .013.409.937.937 0 0 0 .638.5 2.645 2.645 0 0 0 .913-.077 9.613 9.613 0 0 0 .272 1.153c.064.219.134.434.208.653l-.094-.188c-.195-.3-.731-.769-1.084-.63a.473.473 0 0 0-.256.284.571.571 0 0 0 .012.408.933.933 0 0 0 .641.5 2.513 2.513 0 0 0 .886-.073c.027.085.057.165.087.25.138.384.282.8.409 1.187.044.138.084.277.124.415l-.081-.162c-.2-.307-.731-.768-1.084-.634a.477.477 0 0 0-.257.286.574.574 0 0 0 .012.41.933.933 0 0 0 .641.5 2.47 2.47 0 0 0 .862-.069c.037.146.074.288.1.427s.044.188.06.288.034.192.047.288c.027.185.054.384.074.553s.027.246.04.384a9.608 9.608 0 0 0-.144-.43 1.828 1.828 0 0 0-.6-.707.479.479 0 0 0-.05-.092.432.432 0 0 0-.311-.2.406.406 0 0 0-.34.128c-.268.292-.164 1.049-.02 1.387 0 .023.124.227.2.357l-.161-.2-.336-.419-.184-.2c-.06-.073-.131-.134-.195-.2-.158-.158-.336-.3-.49-.45a3.223 3.223 0 0 0 .577-.769 1.2 1.2 0 0 0 .034-.884.456.456 0 0 0-.279-.254.393.393 0 0 0-.352.066c-.3.246-.3 1.011-.2 1.372 0 .023.1.273.158.411-.1-.088-.2-.173-.309-.257-.3-.242-.617-.477-.929-.711l-.289-.219a3.389 3.389 0 0 0 .6-.792 1.192 1.192 0 0 0 .034-.88.456.456 0 0 0-.278-.257.393.393 0 0 0-.353.064c-.3.246-.3 1.011-.2 1.372l.185.48a16.516 16.516 0 0 1-.614-.492 8.493 8.493 0 0 1-.768-.738 3.369 3.369 0 0 0 .6-.8 1.2 1.2 0 0 0 .033-.884.456.456 0 0 0-.279-.254.393.393 0 0 0-.352.066c-.305.242-.3 1.011-.2 1.372 0 .023.111.3.164.427a6.125 6.125 0 0 1-.641-.892 7.933 7.933 0 0 1-.288-.515 3.137 3.137 0 0 0 .671-.7 1.179 1.179 0 0 0 .117-.872.477.477 0 0 0-.252-.289.389.389 0 0 0-.356.02c-.336.2-.4.965-.336 1.337 0 .023.057.223.1.384l-.117-.231c-.134-.284-.242-.55-.336-.788a5.043 5.043 0 0 1-.138-.384 3.663 3.663 0 0 0 .3-.961 1.161 1.161 0 0 0-.245-.842.4.4 0 0 0-.34-.122.433.433 0 0 0-.307.207 1.614 1.614 0 0 0 .242 1.364c.017.027.335.384.335.384.037.112.077.234.124.365.091.238.195.511.336.8a8.671 8.671 0 0 0 .456.9 6.41 6.41 0 0 0 .631.911 7.227 7.227 0 0 0-.386-.227c-.312-.131-.98-.177-1.208.158a.557.557 0 0 0-.077.4.5.5 0 0 0 .208.332.82.82 0 0 0 .772 0 3.188 3.188 0 0 0 .721-.642 8.1 8.1 0 0 0 .778.769c.158.142.336.277.49.411l-.171-.1c-.312-.131-.976-.177-1.208.158a.561.561 0 0 0-.077.4.506.506 0 0 0 .208.334.809.809 0 0 0 .772 0 2.947 2.947 0 0 0 .7-.619l.191.154c.309.242.617.484.913.73.107.088.2.177.305.269l-.148-.084c-.309-.131-.976-.177-1.2.157a.566.566 0 0 0-.077.4.511.511 0 0 0 .2.335.819.819 0 0 0 .772 0 2.979 2.979 0 0 0 .671-.6c.1.1.2.188.3.288s.128.127.188.2l.178.211.336.415.208.281-.336-.265c-.292-.184-.943-.346-1.215-.054a.545.545 0 0 0-.129.38.532.532 0 0 0 .159.365.826.826 0 0 0 .762.142 2.9 2.9 0 0 0 .8-.5q.137.209.288.43Z",
    "data-name": "Path 2029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.232 136.631a2.989 2.989 0 0 1-.829-.452s.343-.327.367-.345c.277-.205.916-.412 1.2-.143a.549.549 0 0 1 0 .75.824.824 0 0 1-.738.19Z",
    "data-name": "Path 2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.07 133.547s.127-.5.137-.52c.133-.345.569-.922.936-.877a.433.433 0 0 1 .3.214.561.561 0 0 1 .063.4 1 1 0 0 1-.53.635 2.745 2.745 0 0 1-.906.148Z",
    "data-name": "Path 2031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.477 141.596c-.127.18-.24.35-.345.5h-.26c.131-.192.284-.41.456-.645.1-.135.218-.28.323-.427a4.8 4.8 0 0 1-.288-.452 2.451 2.451 0 0 1-.768.06 26.678 26.678 0 0 0-.105 1.457h-.218c.017-.277.041-.607.081-.98.018-.177.037-.367.061-.562a2.475 2.475 0 0 1-.722-.375.964.964 0 0 1-.312-.687.465.465 0 0 1 .138-.318.351.351 0 0 1 .3-.1c.321.065.563.675.6 1v.367a1.774 1.774 0 0 1 .03-.237c.022-.162.046-.322.074-.5l.046-.25c.015-.085.039-.172.059-.25.048-.2.1-.4.166-.6a2.283 2.283 0 0 1-.742-.25.918.918 0 0 1-.4-.625.485.485 0 0 1 .1-.34.367.367 0 0 1 .285-.147c.323 0 .644.57.727.89 0 .02.042.25.059.385.037-.12.074-.25.116-.357.12-.345.251-.69.38-1.035.039-.1.078-.21.116-.317a2.443 2.443 0 0 1-.768-.25.916.916 0 0 1-.4-.625.482.482 0 0 1 .09-.35.363.363 0 0 1 .29-.15c.325 0 .655.57.727.887 0 .025.057.365.068.452.085-.232.168-.465.242-.7a8.645 8.645 0 0 0 .246-.962 2.427 2.427 0 0 1-.772-.25.911.911 0 0 1-.4-.622.481.481 0 0 1 .094-.341.362.362 0 0 1 .285-.146c.325 0 .655.57.727.887 0 .02.044.28.061.4h.018a6.209 6.209 0 0 0 .094-1v-.537a2.193 2.193 0 0 1-.775-.148.883.883 0 0 1-.454-.57.492.492 0 0 1 .062-.351.378.378 0 0 1 .269-.182c.323-.03.694.485.805.792 0 .017.052.192.083.322a1.382 1.382 0 0 0-.013-.232c-.02-.28-.055-.535-.085-.75-.02-.127-.037-.25-.057-.352a2.549 2.549 0 0 1-.624-.535 1.01 1.01 0 0 1-.175-.75.433.433 0 0 1 .2-.278.34.34 0 0 1 .312-.019c.3.142.421.8.4 1.127 0 .03-.079.472-.085.467.02.1.039.212.059.335.037.225.076.48.1.75a7.933 7.933 0 0 1 .046.91 6.287 6.287 0 0 1-.074 1.015v.013c.044-.1.177-.36.188-.38.17-.267.639-.67.947-.552a.415.415 0 0 1 .227.248.5.5 0 0 1-.009.359.82.82 0 0 1-.559.432 2.418 2.418 0 0 1-.8-.067 8.844 8.844 0 0 1-.236 1c-.057.192-.12.382-.183.572a2.71 2.71 0 0 1 .083-.165c.17-.267.639-.667.947-.552a.415.415 0 0 1 .227.248.5.5 0 0 1-.009.359.807.807 0 0 1-.559.432 2.238 2.238 0 0 1-.775-.062l-.087.26c-.122.347-.247.695-.358 1.04-.039.12-.076.25-.111.362l.072-.142c.172-.267.639-.67.947-.552a.412.412 0 0 1 .228.248.5.5 0 0 1-.01.36.816.816 0 0 1-.55.435 2.184 2.184 0 0 1-.753-.057c-.035.125-.068.25-.094.372-.017.085-.039.165-.052.25s-.028.17-.042.25c-.022.162-.046.327-.063.485l-.035.32c.037-.12.118-.355.127-.375a1.611 1.611 0 0 1 .524-.617.74.74 0 0 1 .046-.083.377.377 0 0 1 .27-.178.354.354 0 0 1 .3.111c.233.25.144.917.017 1.217 0 .018-.107.2-.172.31.048-.06.092-.118.142-.177.094-.122.192-.25.3-.365l.159-.18c.052-.063.116-.12.172-.18.135-.135.279-.265.426-.392a2.817 2.817 0 0 1-.5-.67 1.041 1.041 0 0 1-.03-.772.4.4 0 0 1 .244-.224.342.342 0 0 1 .308.059c.266.212.264.882.177 1.2 0 .017-.087.237-.135.357.089-.075.177-.152.268-.225.266-.212.541-.417.816-.622l.249-.19a3.038 3.038 0 0 1-.524-.692 1.05 1.05 0 0 1-.031-.772.4.4 0 0 1 .244-.223.344.344 0 0 1 .308.058c.266.212.264.882.179 1.2 0 .025-.127.34-.162.417.183-.14.364-.28.539-.43a6.823 6.823 0 0 0 .67-.645 2.992 2.992 0 0 1-.526-.695 1.041 1.041 0 0 1-.031-.772.4.4 0 0 1 .244-.224.342.342 0 0 1 .308.059c.266.212.264.882.177 1.2 0 .02-.1.25-.142.375l.015.012a5.807 5.807 0 0 0 .561-.78c.094-.15.175-.3.253-.45a2.8 2.8 0 0 1-.576-.612 1.038 1.038 0 0 1-.1-.765.413.413 0 0 1 .221-.253.339.339 0 0 1 .312.02c.286.177.347.842.292 1.17 0 .017-.05.192-.085.32l.1-.2a8.974 8.974 0 0 0 .415-1.017 3.266 3.266 0 0 1-.262-.842 1.013 1.013 0 0 1 .218-.732.353.353 0 0 1 .3-.107.379.379 0 0 1 .269.182 1.39 1.39 0 0 1-.218 1.192 6.523 6.523 0 0 1-.295.335c-.033.1-.068.2-.109.32-.079.21-.17.447-.284.7a8.7 8.7 0 0 1-.4.787 5.669 5.669 0 0 1-.552.8c.083-.052.321-.19.338-.2.273-.115.855-.155 1.056.137a.488.488 0 0 1 .068.349.44.44 0 0 1-.182.291.71.71 0 0 1-.674 0 2.739 2.739 0 0 1-.633-.56 7.067 7.067 0 0 1-.681.685 5.138 5.138 0 0 1-.436.362l.148-.085c.273-.115.855-.155 1.056.137a.488.488 0 0 1 .068.349.439.439 0 0 1-.182.291.7.7 0 0 1-.674 0 2.629 2.629 0 0 1-.615-.54l-.168.133a35.56 35.56 0 0 0-.8.64 8.732 8.732 0 0 0-.266.235l.129-.072c.271-.115.855-.155 1.056.135a.494.494 0 0 1 .067.35.445.445 0 0 1-.181.292.713.713 0 0 1-.676 0 2.558 2.558 0 0 1-.6-.525c-.087.085-.175.167-.257.25a1.8 1.8 0 0 0-.164.177l-.157.182c-.094.12-.194.25-.286.365l-.183.25c.092-.077.27-.222.286-.232.253-.162.825-.3 1.063-.05a.479.479 0 0 1 .113.335.467.467 0 0 1-.141.32.719.719 0 0 1-.665.125 2.625 2.625 0 0 1-.7-.432 5.051 5.051 0 0 0-.297.401Z",
    "data-name": "Path 2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.289 137.857a3.769 3.769 0 0 1-1.03-.561s.426-.407.453-.43c.336-.254 1.141-.511 1.493-.177a.68.68 0 0 1 0 .922 1.026 1.026 0 0 1-.916.246Z",
    "data-name": "Path 2033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.758 134.015s.158-.607.171-.646c.168-.427.708-1.153 1.161-1.088a.535.535 0 0 1 .38.266.694.694 0 0 1 .076.5 1.246 1.246 0 0 1-.671.792 3.481 3.481 0 0 1-1.117.176Z",
    "data-name": "Path 2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.905 138.023a3.56 3.56 0 0 0 1.007-.55s-.413-.384-.443-.415c-.336-.246-1.107-.5-1.453-.173a.664.664 0 0 0 0 .9 1 1 0 0 0 .889.238Z",
    "data-name": "Path 2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.142 134.295s-.154-.592-.168-.626c-.161-.415-.671-1.115-1.127-1.061a.518.518 0 0 0-.367.256.672.672 0 0 0-.076.485 1.2 1.2 0 0 0 .638.769 3.283 3.283 0 0 0 1.1.177Z",
    "data-name": "Path 2037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.626 144.007c.154.215.292.419.416.607h.315c-.158-.231-.336-.5-.55-.769-.121-.165-.255-.342-.389-.519a5.777 5.777 0 0 0 .336-.546 3.082 3.082 0 0 0 .926.073c.023.211.04.415.057.611.037.438.057.83.074 1.153h.252a31.72 31.72 0 0 0-.094-1.184 20.01 20.01 0 0 0-.077-.68 2.92 2.92 0 0 0 .876-.453 1.168 1.168 0 0 0 .376-.826.565.565 0 0 0-.169-.387.425.425 0 0 0-.364-.116c-.386.081-.671.815-.725 1.214v.442a2.2 2.2 0 0 0-.037-.288c-.027-.192-.057-.384-.087-.6-.02-.1-.04-.2-.057-.3s-.047-.2-.07-.307a11.567 11.567 0 0 0-.2-.723 2.8 2.8 0 0 0 .9-.292 1.1 1.1 0 0 0 .48-.769.578.578 0 0 0-.114-.413.436.436 0 0 0-.346-.175c-.389 0-.778.688-.876 1.072 0 .023-.05.307-.07.465-.047-.146-.091-.288-.141-.434-.144-.415-.3-.83-.46-1.249l-.141-.384a2.9 2.9 0 0 0 .929-.3 1.12 1.12 0 0 0 .48-.769.582.582 0 0 0-.115-.411.44.44 0 0 0-.344-.177c-.393 0-.778.688-.876 1.072 0 .031-.07.438-.081.546-.1-.281-.2-.561-.292-.845a10.045 10.045 0 0 1-.3-1.153 2.936 2.936 0 0 0 .919-.261 1.116 1.116 0 0 0 .48-.769.582.582 0 0 0-.115-.411.439.439 0 0 0-.344-.177c-.393 0-.778.688-.879 1.072 0 .027-.054.338-.074.488h-.02a7.722 7.722 0 0 1-.114-1.215v-.644a2.744 2.744 0 0 0 .936-.177 1.069 1.069 0 0 0 .55-.692.593.593 0 0 0-.075-.423.456.456 0 0 0-.324-.219c-.393-.038-.842.588-.976.957 0 .019-.06.234-.1.384a1.575 1.575 0 0 1 .017-.28c.027-.338.067-.646.1-.919.023-.154.047-.292.07-.423a3.136 3.136 0 0 0 .752-.649 1.221 1.221 0 0 0 .211-.9.523.523 0 0 0-.236-.338.41.41 0 0 0-.378-.023c-.362.173-.51.964-.48 1.364 0 .035.094.569.1.565-.023.127-.047.261-.071.407-.044.273-.091.58-.124.918-.036.365-.054.732-.054 1.1a7.8 7.8 0 0 0 .091 1.226 19.4 19.4 0 0 0-.228-.457c-.2-.323-.772-.807-1.144-.669a.5.5 0 0 0-.271.3.605.605 0 0 0 .013.433.991.991 0 0 0 .671.523 2.821 2.821 0 0 0 .963-.081 10 10 0 0 0 .285 1.207c.067.234.144.461.221.692l-.1-.2c-.208-.327-.772-.811-1.144-.669a.494.494 0 0 0-.273.3.6.6 0 0 0 .014.432.971.971 0 0 0 .671.523 2.7 2.7 0 0 0 .936-.073l.091.261c.151.423.3.842.433 1.257.05.146.091.292.134.438l-.087-.173c-.208-.323-.772-.807-1.144-.665a.5.5 0 0 0-.271.3.6.6 0 0 0 .013.431.981.981 0 0 0 .671.523 2.648 2.648 0 0 0 .909-.069c.04.15.081.3.114.45s.044.2.06.3l.05.3c.027.2.054.384.077.588.017.131.027.258.04.384-.044-.146-.141-.43-.151-.453a1.987 1.987 0 0 0-.634-.746.557.557 0 0 0-.054-.1.453.453 0 0 0-.32-.207.426.426 0 0 0-.351.126c-.285.311-.174 1.111-.023 1.468 0 .023.131.242.208.384l-.168-.215-.362-.442-.195-.215c-.064-.077-.138-.142-.208-.215a9.303 9.303 0 0 0-.513-.477 3.433 3.433 0 0 0 .607-.811 1.257 1.257 0 0 0 .037-.93.478.478 0 0 0-.3-.275.412.412 0 0 0-.375.075c-.319.258-.319 1.064-.215 1.449 0 .023.107.288.164.431l-.335-.269c-.319-.258-.651-.5-.983-.769l-.3-.231a3.527 3.527 0 0 0 .631-.834 1.253 1.253 0 0 0 .04-.934.484.484 0 0 0-.3-.271.418.418 0 0 0-.374.071c-.336.257-.319 1.068-.215 1.449 0 .031.151.411.195.507a19.474 19.474 0 0 1-.651-.519 8.924 8.924 0 0 1-.812-.769 3.645 3.645 0 0 0 .637-.842 1.257 1.257 0 0 0 .037-.93.479.479 0 0 0-.3-.275.412.412 0 0 0-.375.075c-.319.257-.319 1.065-.215 1.449 0 .023.117.315.174.45h-.02a6.807 6.807 0 0 1-.671-.938 10.115 10.115 0 0 1-.305-.546 3.282 3.282 0 0 0 .695-.742 1.247 1.247 0 0 0 .128-.922.5.5 0 0 0-.267-.3.41.41 0 0 0-.377.024c-.335.215-.419 1.018-.352 1.41 0 .023.06.234.1.384-.04-.085-.084-.165-.121-.246-.141-.3-.255-.58-.356-.83-.057-.146-.1-.277-.148-.384a3.829 3.829 0 0 0 .336-1.014 1.223 1.223 0 0 0-.262-.888.424.424 0 0 0-.352-.122.455.455 0 0 0-.319.211 1.711 1.711 0 0 0 .255 1.441c.02.027.356.415.359.407a13.347 13.347 0 0 0 .47 1.226 10.04 10.04 0 0 0 .48.949 6.656 6.656 0 0 0 .671.965l-.413-.238c-.335-.138-1.03-.188-1.272.165a.587.587 0 0 0-.083.419.53.53 0 0 0 .217.35.853.853 0 0 0 .815 0 3.394 3.394 0 0 0 .765-.676 8.263 8.263 0 0 0 .822.826c.168.15.335.3.517.438l-.181-.1c-.335-.138-1.033-.185-1.275.165a.6.6 0 0 0-.078.419.538.538 0 0 0 .216.35.861.861 0 0 0 .815 0 3.237 3.237 0 0 0 .745-.653l.2.161c.336.257.654.511.966.769.111.092.218.188.336.285l-.154-.089c-.336-.138-1.033-.188-1.275.165a.592.592 0 0 0-.08.419.533.533 0 0 0 .217.349.862.862 0 0 0 .815 0 3.224 3.224 0 0 0 .725-.634c.1.1.211.2.312.3a2.351 2.351 0 0 1 .195.215l.191.219c.114.146.235.3.335.442l.221.3-.336-.284c-.305-.192-1.007-.361-1.282-.058a.574.574 0 0 0-.138.4.559.559 0 0 0 .172.387.862.862 0 0 0 .8.15 3.135 3.135 0 0 0 .842-.534 5.491 5.491 0 0 0 .375.55Z",
    "data-name": "Path 2038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.483 143.376c-.154.215-.292.419-.416.607h-.315c.158-.231.336-.5.55-.769.121-.165.255-.342.389-.519a5.794 5.794 0 0 1-.336-.546 3.092 3.092 0 0 1-.926.073c-.023.211-.04.415-.057.611-.037.438-.057.83-.074 1.153h-.252c.02-.334.05-.734.094-1.184.02-.215.047-.446.077-.68a2.916 2.916 0 0 1-.876-.453 1.168 1.168 0 0 1-.376-.826.565.565 0 0 1 .169-.387.426.426 0 0 1 .364-.116c.386.081.671.815.725 1.214v.442a2.2 2.2 0 0 1 .037-.288c.027-.192.057-.384.087-.6.02-.1.04-.2.057-.3s.047-.2.07-.307c.057-.242.127-.484.2-.722a2.793 2.793 0 0 1-.9-.292 1.1 1.1 0 0 1-.48-.768.578.578 0 0 1 .114-.413.435.435 0 0 1 .346-.175c.389 0 .778.688.876 1.072 0 .023.05.307.07.465.047-.146.091-.288.141-.434.144-.415.3-.83.46-1.249l.141-.384a2.906 2.906 0 0 1-.929-.3 1.12 1.12 0 0 1-.48-.769.582.582 0 0 1 .115-.411.44.44 0 0 1 .344-.177c.393 0 .778.688.876 1.072 0 .031.07.438.081.546.1-.281.2-.561.292-.845a10.049 10.049 0 0 0 .3-1.153 2.943 2.943 0 0 1-.919-.261 1.116 1.116 0 0 1-.48-.769.582.582 0 0 1 .115-.411.439.439 0 0 1 .344-.177c.393 0 .778.688.879 1.072 0 .027.054.338.074.488h.02a7.718 7.718 0 0 0 .114-1.214v-.647a2.744 2.744 0 0 1-.936-.177 1.069 1.069 0 0 1-.55-.692.593.593 0 0 1 .075-.423.456.456 0 0 1 .324-.219c.393-.038.842.588.976.957 0 .019.06.234.1.384a1.58 1.58 0 0 0-.017-.281c-.027-.338-.067-.646-.1-.918a16.293 16.293 0 0 0-.07-.423 3.135 3.135 0 0 1-.752-.649 1.221 1.221 0 0 1-.211-.9.523.523 0 0 1 .236-.338.41.41 0 0 1 .378-.023c.362.173.51.964.48 1.364 0 .035-.094.569-.1.565.023.127.047.261.07.407.044.273.091.58.124.918q.054.547.054 1.1a7.8 7.8 0 0 1-.091 1.226 19.4 19.4 0 0 1 .228-.457c.2-.323.772-.807 1.144-.669a.5.5 0 0 1 .271.3.605.605 0 0 1-.013.433.991.991 0 0 1-.671.523 2.819 2.819 0 0 1-.963-.081 9.989 9.989 0 0 1-.285 1.207c-.067.234-.144.461-.221.692l.1-.2c.208-.327.772-.811 1.144-.669a.493.493 0 0 1 .273.3.6.6 0 0 1-.014.432.971.971 0 0 1-.671.523 2.7 2.7 0 0 1-.936-.073l-.091.261c-.151.423-.3.842-.433 1.257-.05.146-.091.292-.134.438l.087-.173c.208-.323.772-.807 1.144-.665a.5.5 0 0 1 .271.3.6.6 0 0 1-.013.431.982.982 0 0 1-.671.523 2.646 2.646 0 0 1-.909-.069c-.04.15-.081.3-.114.45s-.044.2-.06.3l-.05.3c-.027.2-.054.384-.077.588-.017.131-.027.258-.04.384.044-.146.141-.43.151-.453a1.987 1.987 0 0 1 .634-.746.56.56 0 0 1 .054-.1.453.453 0 0 1 .32-.207.425.425 0 0 1 .351.126c.285.311.174 1.111.023 1.468 0 .023-.131.242-.208.384l.168-.215.362-.442.195-.215c.064-.077.138-.142.208-.215.164-.165.336-.323.513-.477a3.43 3.43 0 0 1-.607-.811 1.258 1.258 0 0 1-.037-.93.479.479 0 0 1 .3-.275.412.412 0 0 1 .375.075c.319.258.319 1.065.215 1.449 0 .023-.107.288-.164.43l.336-.269c.319-.257.651-.5.983-.769l.3-.23a3.524 3.524 0 0 1-.631-.834 1.252 1.252 0 0 1-.04-.934.484.484 0 0 1 .3-.271.418.418 0 0 1 .374.071c.336.257.319 1.068.215 1.449 0 .031-.151.411-.195.507.221-.169.439-.342.651-.519a8.92 8.92 0 0 0 .812-.768 3.641 3.641 0 0 1-.637-.842 1.257 1.257 0 0 1-.037-.93.479.479 0 0 1 .3-.275.412.412 0 0 1 .375.075c.319.257.319 1.065.215 1.449 0 .023-.117.315-.174.45h.02a6.812 6.812 0 0 0 .671-.938c.111-.184.211-.365.305-.546a3.284 3.284 0 0 1-.695-.742 1.247 1.247 0 0 1-.128-.922.5.5 0 0 1 .267-.3.41.41 0 0 1 .377.024c.336.215.419 1.018.352 1.41 0 .023-.06.234-.1.384.04-.085.084-.165.121-.246.141-.3.255-.58.356-.83.057-.146.1-.277.148-.384a3.827 3.827 0 0 1-.336-1.015 1.222 1.222 0 0 1 .262-.888.425.425 0 0 1 .352-.122.455.455 0 0 1 .319.211 1.711 1.711 0 0 1-.255 1.441c-.02.027-.356.415-.359.407a13.347 13.347 0 0 1-.47 1.226 10.032 10.032 0 0 1-.48.949 6.654 6.654 0 0 1-.671.965l.413-.238c.336-.138 1.03-.188 1.272.165a.587.587 0 0 1 .083.419.53.53 0 0 1-.217.35.853.853 0 0 1-.815 0 3.39 3.39 0 0 1-.765-.676 8.255 8.255 0 0 1-.822.826c-.168.15-.336.3-.517.438l.181-.1c.336-.138 1.033-.185 1.275.165a.6.6 0 0 1 .078.419.538.538 0 0 1-.216.35.861.861 0 0 1-.815 0 3.24 3.24 0 0 1-.745-.653l-.2.161c-.335.257-.654.511-.966.769-.111.092-.218.188-.336.284l.154-.089c.335-.138 1.033-.188 1.275.165a.592.592 0 0 1 .08.419.534.534 0 0 1-.217.35.862.862 0 0 1-.815 0 3.229 3.229 0 0 1-.725-.634c-.1.1-.211.2-.312.3a2.362 2.362 0 0 0-.195.215l-.191.219c-.114.146-.235.3-.335.442l-.221.3.336-.284c.305-.192 1.007-.361 1.282-.058a.574.574 0 0 1 .138.4.559.559 0 0 1-.172.387.862.862 0 0 1-.8.15 3.139 3.139 0 0 1-.842-.534 5.5 5.5 0 0 1-.375.55Z",
    "data-name": "Path 2127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.071 140.052a2.438 2.438 0 0 1-.671-.365s.275-.265.3-.281c.225-.161.742-.33.97-.111a.421.421 0 0 1 0 .6.659.659 0 0 1-.599.157Z",
    "data-name": "Path 2042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.8 137.561s.1-.384.111-.419c.111-.277.46-.745.755-.707a.348.348 0 0 1 .246.171.452.452 0 0 1 .052.324.8.8 0 0 1-.429.511 2.207 2.207 0 0 1-.735.12Z",
    "data-name": "Path 2043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.846 138.695a3.311 3.311 0 0 1-.9-.492l.4-.384c.3-.223 1.006-.446 1.305-.154a.591.591 0 0 1 0 .807.894.894 0 0 1-.8.223Z",
    "data-name": "Path 2045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.355 132.551s.138-.53.151-.565c.144-.384.617-1 1.007-.953a.469.469 0 0 1 .331.232.607.607 0 0 1 .069.437 1.078 1.078 0 0 1-.577.692 2.962 2.962 0 0 1-.981.157Z",
    "data-name": "Path 2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.707 141.293-.372.546h-.282c.141-.208.309-.442.493-.7l.352-.461a5.117 5.117 0 0 1-.312-.5 2.713 2.713 0 0 1-.835.069c-.017.188-.037.384-.05.55-.03.384-.05.745-.064 1.038h-.228c.017-.3.044-.657.087-1.064a5.34 5.34 0 0 1 .067-.607 2.7 2.7 0 0 1-.785-.407 1.043 1.043 0 0 1-.336-.746.507.507 0 0 1 .152-.349.382.382 0 0 1 .328-.1c.336.073.611.734.651 1.091v.384a2.26 2.26 0 0 1 .033-.257c.024-.177.05-.35.081-.538l.05-.273c.017-.088.044-.184.064-.277.054-.219.114-.434.181-.649a2.457 2.457 0 0 1-.805-.261 1 1 0 0 1-.433-.68.527.527 0 0 1 .1-.37.4.4 0 0 1 .309-.161c.336 0 .7.619.788.965 0 .023.047.28.064.419.04-.127.081-.257.128-.384.131-.384.272-.749.413-1.122.044-.115.084-.23.124-.342a2.585 2.585 0 0 1-.832-.269 1 1 0 0 1-.433-.676.523.523 0 0 1 .1-.371.4.4 0 0 1 .31-.159c.352 0 .7.619.788.964 0 .027.064.384.074.488.091-.254.181-.5.262-.769a9.419 9.419 0 0 0 .272-1.045 2.644 2.644 0 0 1-.842-.269 1 1 0 0 1-.433-.676.527.527 0 0 1 .105-.371.4.4 0 0 1 .311-.159c.352 0 .7.619.789.965 0 .023.047.3.064.438h.033a6.923 6.923 0 0 0 .1-1.091v-.58a2.414 2.414 0 0 1-.839-.161.943.943 0 0 1-.493-.619.528.528 0 0 1 .066-.381.406.406 0 0 1 .293-.2c.336-.035.755.527.876.857 0 .019.057.211.091.354v-.254c-.023-.3-.06-.58-.094-.826-.02-.138-.044-.265-.064-.384a2.821 2.821 0 0 1-.671-.584 1.1 1.1 0 0 1-.188-.811.469.469 0 0 1 .212-.3.368.368 0 0 1 .338-.021c.336.158.46.869.433 1.226 0 .031-.087.511-.091.507.02.111.044.234.064.365.04.246.084.523.111.826a9.071 9.071 0 0 1 .05.988 7.394 7.394 0 0 1-.081 1.1c.047-.1.191-.384.2-.411.184-.292.691-.73 1.027-.6a.448.448 0 0 1 .245.271.539.539 0 0 1-.014.39.885.885 0 0 1-.607.469 2.5 2.5 0 0 1-.866-.073 9.282 9.282 0 0 1-.258 1.088c-.06.208-.127.415-.2.619l.091-.177c.188-.292.695-.726 1.03-.6a.452.452 0 0 1 .242.27.545.545 0 0 1-.011.387.872.872 0 0 1-.607.469 2.474 2.474 0 0 1-.842-.065l-.081.234c-.134.384-.268.769-.389 1.13-.044.131-.084.261-.121.384.04-.081.074-.146.077-.158.188-.288.695-.726 1.03-.6a.448.448 0 0 1 .244.269.54.54 0 0 1-.012.388.88.88 0 0 1-.607.473 2.312 2.312 0 0 1-.819-.065c-.037.138-.07.273-.1.407s-.04.177-.057.273l-.044.273c-.023.173-.05.354-.07.527s-.024.234-.037.346a8.21 8.21 0 0 1 .138-.407 1.732 1.732 0 0 1 .567-.669.444.444 0 0 1 .05-.088.409.409 0 0 1 .294-.2.383.383 0 0 1 .324.12c.255.281.154 1 .017 1.322a3.838 3.838 0 0 1-.185.338c.05-.065.1-.127.151-.2a4.862 4.862 0 0 1 .336-.384l.174-.192c.057-.069.124-.131.188-.2q.221-.219.463-.426a3.026 3.026 0 0 1-.547-.726 1.131 1.131 0 0 1-.034-.838.43.43 0 0 1 .265-.246.37.37 0 0 1 .336.066c.289.231.285.957.191 1.3 0 .019-.094.257-.148.384.1-.081.191-.165.292-.246.289-.227.587-.45.886-.672l.272-.208a3.324 3.324 0 0 1-.57-.769 1.131 1.131 0 0 1-.034-.838.436.436 0 0 1 .265-.243.376.376 0 0 1 .335.062c.289.234.285.961.195 1.3a4.072 4.072 0 0 1-.174.453c.2-.15.4-.3.584-.465a7.574 7.574 0 0 0 .728-.7 3.322 3.322 0 0 1-.57-.769 1.1 1.1 0 0 1-.034-.838.432.432 0 0 1 .264-.242.373.373 0 0 1 .334.062c.289.234.285.961.195 1.3 0 .023-.107.284-.158.407h.017a5.982 5.982 0 0 0 .611-.845c.1-.165.191-.331.275-.492a2.865 2.865 0 0 1-.624-.665 1.109 1.109 0 0 1-.114-.826.451.451 0 0 1 .238-.276.369.369 0 0 1 .339.019c.309.2.376.918.319 1.272l-.094.35.108-.219c.127-.269.231-.523.335-.749.05-.127.091-.246.131-.357a3.406 3.406 0 0 1-.285-.915 1.075 1.075 0 0 1 .235-.8.383.383 0 0 1 .323-.116.41.41 0 0 1 .291.2 1.532 1.532 0 0 1-.228 1.3c-.017.023-.336.384-.336.365l-.121.346c-.084.227-.185.484-.305.768a9.231 9.231 0 0 1-.436.853 6.105 6.105 0 0 1-.6.869 4.133 4.133 0 0 1 .369-.215c.3-.127.929-.169 1.147.146a.532.532 0 0 1 .074.38.479.479 0 0 1-.2.316.77.77 0 0 1-.731 0 3.037 3.037 0 0 1-.671-.611 7.742 7.742 0 0 1-.738.746 7.899 7.899 0 0 1-.466.384l.164-.092c.292-.123.926-.165 1.144.15a.527.527 0 0 1 .075.38.474.474 0 0 1-.2.316.761.761 0 0 1-.731 0 2.85 2.85 0 0 1-.671-.588c-.06.05-.121.1-.184.146-.292.231-.584.461-.866.7-.1.081-.195.169-.292.254l.141-.081c.3-.123.929-.165 1.147.15a.528.528 0 0 1 .115.479.449.449 0 0 1-.317.34.768.768 0 0 1-.735 0 2.708 2.708 0 0 1-.651-.569c-.094.092-.191.181-.279.273s-.121.123-.178.192l-.171.2-.312.384c-.067.092-.131.181-.2.265.1-.081.292-.242.312-.254.275-.173.9-.327 1.151-.05a.512.512 0 0 1 .124.361.5.5 0 0 1-.154.346.778.778 0 0 1-.721.138 2.756 2.756 0 0 1-.755-.48c-.096.153-.2.292-.297.43Z",
    "data-name": "Path 2047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.526 139.84a2.647 2.647 0 0 1-.725-.384s.3-.288.319-.3c.245-.177.805-.361 1.054-.123a.477.477 0 0 1 0 .649.723.723 0 0 1-.648.158Z",
    "data-name": "Path 2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.003 137.14s.111-.431.121-.457c.117-.3.5-.807.819-.769a.375.375 0 0 1 .275.181.49.49 0 0 1 .061.356.866.866 0 0 1-.463.557 2.37 2.37 0 0 1-.813.132Z",
    "data-name": "Path 2049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.48 144.19-.3.442h-.242c.114-.165.248-.357.4-.561.087-.123.181-.25.282-.384a3.9 3.9 0 0 1-.252-.384 2.3 2.3 0 0 1-.671.054c0 .15-.027.3-.04.442-.023.319-.04.6-.05.838h-.185c0-.242.037-.53.067-.857.017-.158.037-.323.057-.492a2.106 2.106 0 0 1-.634-.33.84.84 0 0 1-.272-.6.407.407 0 0 1 .122-.282.306.306 0 0 1 .264-.084c.279.058.493.592.527.88v.323a.554.554 0 0 1 .027-.207c.017-.142.04-.284.064-.434l.04-.219a1.166 1.166 0 0 1 .05-.227c.044-.173.094-.35.148-.523a1.941 1.941 0 0 1-.651-.211.806.806 0 0 1-.336-.549.422.422 0 0 1 .084-.3.318.318 0 0 1 .251-.127c.285 0 .567.5.638.769 0 0 .037.223.05.338.034-.1.067-.211.1-.315.1-.3.218-.6.335-.907l.1-.277a2.022 2.022 0 0 1-.671-.215.805.805 0 0 1-.336-.546.422.422 0 0 1 .084-.3.318.318 0 0 1 .251-.127c.285 0 .564.5.638.769 0 .023.05.319.057.384.074-.2.148-.407.211-.611a7.316 7.316 0 0 0 .218-.845 2.2 2.2 0 0 1-.671-.215.83.83 0 0 1-.336-.549.421.421 0 0 1 .084-.3.318.318 0 0 1 .251-.127c.282 0 .564.5.634.769 0 .019.04.246.054.354a5.4 5.4 0 0 0 .084-.88v-.469a1.93 1.93 0 0 1-.671-.131.765.765 0 0 1-.4-.5.43.43 0 0 1 .054-.306.331.331 0 0 1 .234-.159c.285-.027.611.427.708.692 0 0 .047.169.074.284v-.2a9.622 9.622 0 0 0-.124-.972 2.3 2.3 0 0 1-.547-.473.9.9 0 0 1-.154-.653.379.379 0 0 1 .172-.245.3.3 0 0 1 .274-.016c.262.127.369.7.336.988 0 .027-.07.415-.074.411.02.092.037.188.054.3q.058.33.087.665a7.352 7.352 0 0 1 .04.8 5.488 5.488 0 0 1-.064.891c.04-.084.154-.315.164-.33.151-.234.56-.588.829-.484a.361.361 0 0 1 .2.217.436.436 0 0 1-.009.313.708.708 0 0 1-.49.384 2.092 2.092 0 0 1-.7-.061 7.774 7.774 0 0 1-.208.88c-.05.165-.1.334-.161.5l.074-.142c.151-.235.56-.588.829-.484a.361.361 0 0 1 .2.217.435.435 0 0 1-.009.313.7.7 0 0 1-.49.384 1.94 1.94 0 0 1-.671-.054l-.067.192c-.107.3-.215.607-.312.911-.037.1-.067.211-.1.319a1.219 1.219 0 0 1 .064-.127c.148-.234.56-.584.829-.484a.361.361 0 0 1 .2.217.435.435 0 0 1-.009.313.715.715 0 0 1-.49.384 1.9 1.9 0 0 1-.671-.05c-.03.108-.057.219-.081.327s-.034.146-.047.219-.023.15-.037.223c-.02.138-.04.284-.054.423s-.023.188-.03.28c.034-.1.1-.311.107-.327a1.465 1.465 0 0 1 .46-.542l.04-.073a.329.329 0 0 1 .239-.158.31.31 0 0 1 .261.1 1.21 1.21 0 0 1 0 1.064l-.151.273.124-.158c.084-.108.168-.208.262-.319l.141-.158c.047-.054.1-.1.151-.158.117-.119.245-.231.372-.342a2.5 2.5 0 0 1-.44-.588.909.909 0 0 1-.027-.676.349.349 0 0 1 .213-.2.3.3 0 0 1 .27.051c.232.184.232.768.154 1.049 0 .019-.077.212-.117.315l.235-.2c.235-.184.473-.365.715-.546l.218-.165a2.674 2.674 0 0 1-.46-.607.927.927 0 0 1-.027-.676.349.349 0 0 1 .214-.2.3.3 0 0 1 .272.053c.232.188.228.769.154 1.053 0 0-.111.3-.141.365a4.625 4.625 0 0 0 .473-.384 6.8 6.8 0 0 0 .587-.565 2.655 2.655 0 0 1-.463-.611.923.923 0 0 1-.027-.676.348.348 0 0 1 .214-.194.3.3 0 0 1 .269.052c.235.184.231.769.158 1.049a3.9 3.9 0 0 1-.124.327 4.976 4.976 0 0 0 .49-.68c.084-.134.154-.265.221-.384a2.4 2.4 0 0 1-.5-.538.893.893 0 0 1-.091-.669.363.363 0 0 1 .194-.221.3.3 0 0 1 .273.017c.248.158.3.738.255 1.026 0 0-.044.169-.077.281.03-.058.064-.119.091-.177.1-.215.185-.423.258-.6.04-.1.074-.2.1-.288a2.81 2.81 0 0 1-.228-.738.87.87 0 0 1 .188-.642.309.309 0 0 1 .26-.1.33.33 0 0 1 .236.158 1.239 1.239 0 0 1-.185 1.045 2.934 2.934 0 0 1-.262.3c-.03.088-.06.181-.1.28-.07.184-.148.384-.248.611s-.214.468-.335.692a5.336 5.336 0 0 1-.483.7c.07-.046.278-.169.3-.173.238-.1.752-.138.926.119a.429.429 0 0 1 .059.306.386.386 0 0 1-.16.255.63.63 0 0 1-.591 0 2.445 2.445 0 0 1-.554-.492 5.972 5.972 0 0 1-.6.6c-.121.108-.248.215-.376.319l.131-.077c.238-.1.752-.135.926.123a.429.429 0 0 1 .059.306.386.386 0 0 1-.16.255.629.629 0 0 1-.591 0 2.251 2.251 0 0 1-.56-.407l-.148.119c-.235.185-.473.384-.7.561-.081.065-.158.134-.235.2l.114-.065c.235-.1.748-.135.923.119a.428.428 0 0 1 .062.308.387.387 0 0 1-.16.257.627.627 0 0 1-.594 0 2.141 2.141 0 0 1-.523-.457l-.228.219c-.047.054-.1.1-.141.158l-.138.158c-.084.107-.171.215-.252.323s-.107.142-.161.211c.081-.065.235-.2.252-.2.222-.142.721-.265.929-.042a.416.416 0 0 1 .1.292.406.406 0 0 1-.124.28.628.628 0 0 1-.584.108 2.2 2.2 0 0 1-.611-.384Z",
    "data-name": "Path 2050"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1",
    "data-name": "freepik--Plants--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.606 136.037a3.4 3.4 0 0 1-.946-.519s.389-.384.416-.384c.319-.231 1.05-.469 1.376-.161a.63.63 0 0 1 0 .853.945.945 0 0 1-.846.211Z",
    "data-name": "Path 2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.596 133.05s.176-.667.188-.7c.184-.457.774-1.256 1.272-1.192a.584.584 0 0 1 .412.288.758.758 0 0 1 .087.544 1.361 1.361 0 0 1-.722.868 3.721 3.721 0 0 1-1.237.192Z",
    "data-name": "Path 2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.069 142.205q.259.361.467.685h.355c-.179-.26-.4-.557-.618-.877a24.07 24.07 0 0 0-.439-.58 6.311 6.311 0 0 0 .4-.617 3.4 3.4 0 0 0 1.041.082c.024.238.048.457.064.685.04.5.064.937.084 1.307h.283c-.02-.379-.056-.827-.108-1.334-.024-.242-.052-.5-.084-.763a3.39 3.39 0 0 0 .985-.512 1.31 1.31 0 0 0 .419-.914.633.633 0 0 0-.189-.436.476.476 0 0 0-.409-.131c-.435.091-.762.914-.818 1.37v.5a2.271 2.271 0 0 0-.04-.32c-.032-.219-.064-.457-.1-.672-.024-.114-.044-.228-.068-.343s-.052-.233-.076-.347a12.093 12.093 0 0 0-.227-.813 3.168 3.168 0 0 0 1.009-.329 1.253 1.253 0 0 0 .542-.85.661.661 0 0 0-.132-.462.5.5 0 0 0-.387-.2c-.443 0-.878.777-.989 1.206 0 .027-.056.352-.08.525-.048-.16-.1-.324-.156-.484a110.9 110.9 0 0 0-.519-1.407l-.156-.43a3.242 3.242 0 0 0 1.045-.333 1.25 1.25 0 0 0 .538-.85.656.656 0 0 0-.13-.464.5.5 0 0 0-.388-.2c-.439 0-.873.772-.985 1.206 0 .032-.08.493-.092.612-.116-.315-.227-.63-.327-.95a11.223 11.223 0 0 1-.339-1.307 3.337 3.337 0 0 0 1.053-.334 1.25 1.25 0 0 0 .539-.85.657.657 0 0 0-.131-.463.5.5 0 0 0-.388-.2c-.439 0-.874.772-.985 1.206 0 .027-.06.379-.084.548h-.024a8.607 8.607 0 0 1-.128-1.37v-.731a3 3 0 0 0 1.053-.2 1.2 1.2 0 0 0 .618-.772.669.669 0 0 0-.084-.478.515.515 0 0 0-.367-.248c-.439-.041-.945.662-1.1 1.078 0 .023-.068.26-.112.457a1.727 1.727 0 0 1 .02-.32 15.015 15.015 0 0 1 .192-1.49 3.5 3.5 0 0 0 .85-.731 1.4 1.4 0 0 0 .239-1.014.588.588 0 0 0-.269-.378.463.463 0 0 0-.425-.024c-.4.192-.574 1.083-.538 1.53 0 .041.108.64.116.635-.028.142-.056.292-.084.457-.048.306-.1.653-.136 1.033a11.9 11.9 0 0 0-.064 1.238 8.771 8.771 0 0 0 .1 1.371c-.06-.128-.239-.489-.255-.516-.231-.361-.866-.914-1.284-.749a.557.557 0 0 0-.307.336.673.673 0 0 0 .016.486 1.114 1.114 0 0 0 .758.589 3.147 3.147 0 0 0 1.085-.091 11.426 11.426 0 0 0 .323 1.371c.076.26.16.516.247.777l-.112-.224c-.231-.361-.87-.914-1.288-.749a.562.562 0 0 0-.3.337.678.678 0 0 0 .014.485 1.109 1.109 0 0 0 .762.589 2.986 2.986 0 0 0 1.053-.087c.032.1.068.2.1.3.164.457.335.946.487 1.412.052.165.1.329.148.493l-.1-.192c-.235-.365-.87-.914-1.288-.754a.567.567 0 0 0-.3.34.683.683 0 0 0 .014.487 1.109 1.109 0 0 0 .762.589 2.934 2.934 0 0 0 1.025-.082c.044.174.088.343.124.507s.052.224.072.343.04.229.056.343c.032.219.064.457.088.658s.032.292.048.457c-.052-.169-.16-.489-.172-.512a2.174 2.174 0 0 0-.714-.841.565.565 0 0 0-.06-.11.513.513 0 0 0-.369-.243.482.482 0 0 0-.4.152c-.319.347-.2 1.247-.024 1.649 0 .027.148.27.235.425l-.191-.242-.4-.5-.219-.242c-.072-.087-.156-.16-.231-.242-.187-.187-.4-.361-.582-.535a3.829 3.829 0 0 0 .686-.914 1.428 1.428 0 0 0 .04-1.051.543.543 0 0 0-.332-.3.468.468 0 0 0-.418.079c-.359.292-.359 1.2-.243 1.631 0 .027.124.324.188.489a8.493 8.493 0 0 0-.367-.306c-.359-.288-.734-.566-1.1-.845l-.343-.26a4.035 4.035 0 0 0 .714-.941 1.417 1.417 0 0 0 .04-1.046.543.543 0 0 0-.331-.305.467.467 0 0 0-.419.077c-.359.292-.359 1.2-.243 1.631l.219.571c-.247-.192-.495-.384-.73-.585a10.109 10.109 0 0 1-.913-.877 4 4 0 0 0 .718-.946 1.427 1.427 0 0 0 .04-1.051.542.542 0 0 0-.332-.3.467.467 0 0 0-.418.079c-.363.288-.359 1.2-.243 1.631 0 .027.132.356.2.507a7.286 7.286 0 0 1-.762-1.06 8.873 8.873 0 0 1-.343-.612 3.734 3.734 0 0 0 .8-.831 1.4 1.4 0 0 0 .14-1.037.566.566 0 0 0-.3-.343.462.462 0 0 0-.423.023c-.4.242-.471 1.147-.4 1.59 0 .027.068.265.12.457l-.14-.274c-.16-.338-.287-.653-.4-.936a7.602 7.602 0 0 1-.164-.457 4.355 4.355 0 0 0 .355-1.142 1.381 1.381 0 0 0-.291-1 .481.481 0 0 0-.4-.145.515.515 0 0 0-.365.246 1.919 1.919 0 0 0 .287 1.622c.02.032.4.457.4.457.044.133.092.279.148.434.108.283.231.608.4.946a10.338 10.338 0 0 0 .542 1.074 7.628 7.628 0 0 0 .75 1.083 8.597 8.597 0 0 0-.459-.269c-.371-.155-1.165-.21-1.436.187a.662.662 0 0 0-.092.474.6.6 0 0 0 .247.394.975.975 0 0 0 .917 0 3.8 3.8 0 0 0 .858-.763 9.585 9.585 0 0 0 .925.914c.187.169.4.329.582.489l-.2-.114c-.371-.155-1.161-.21-1.436.187a.668.668 0 0 0-.092.476.6.6 0 0 0 .248.4.961.961 0 0 0 .917 0 3.5 3.5 0 0 0 .838-.735l.227.183c.367.288.734.576 1.085.868.128.105.243.21.363.32l-.176-.1c-.367-.155-1.161-.21-1.432.187a.673.673 0 0 0-.092.474.609.609 0 0 0 .244.4.975.975 0 0 0 .917 0 3.543 3.543 0 0 0 .8-.713c.12.114.239.224.351.343s.152.151.223.238l.211.251.4.493.247.334-.4-.315c-.347-.219-1.121-.411-1.444-.064a.648.648 0 0 0-.154.452.632.632 0 0 0 .19.434.982.982 0 0 0 .905.169 3.441 3.441 0 0 0 .945-.6q.173.266.348.526Z",
    "data-name": "Path 2029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.377 133.72a4.586 4.586 0 0 0 1.275-.7s-.527-.5-.564-.53c-.426-.315-1.409-.634-1.849-.219a.845.845 0 0 0 0 1.153 1.268 1.268 0 0 0 1.138.296Z",
    "data-name": "Path 2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.456 131.475s-.195-.768-.211-.8c-.2-.53-.876-1.418-1.439-1.349a.666.666 0 0 0-.466.328.862.862 0 0 0-.1.617 1.532 1.532 0 0 0 .815.976 4.211 4.211 0 0 0 1.401.228Z",
    "data-name": "Path 2031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.997 141.354c.195.277.369.538.53.769h.4c-.2-.3-.436-.63-.7-.991-.154-.208-.336-.431-.5-.657a7.406 7.406 0 0 0 .443-.7 3.768 3.768 0 0 0 1.181.092 39.137 39.137 0 0 1 .161 2.241h.336a36.072 36.072 0 0 0-.124-1.506 35.905 35.905 0 0 0-.094-.865 3.8 3.8 0 0 0 1.111-.576 1.483 1.483 0 0 0 .48-1.057.716.716 0 0 0-.213-.488.54.54 0 0 0-.458-.15c-.493.1-.866 1.038-.926 1.537v.565a2.741 2.741 0 0 0-.047-.365c-.034-.25-.07-.5-.114-.769l-.07-.384c-.023-.131-.06-.265-.091-.384a14.88 14.88 0 0 0-.255-.918 3.509 3.509 0 0 0 1.141-.384 1.412 1.412 0 0 0 .614-.961.746.746 0 0 0-.149-.523.565.565 0 0 0-.438-.226c-.5 0-.99.876-1.117 1.368 0 .031-.064.384-.091.592-.057-.185-.114-.384-.178-.55-.185-.53-.386-1.061-.584-1.591-.06-.161-.121-.323-.178-.488a3.755 3.755 0 0 0 1.181-.384 1.409 1.409 0 0 0 .611-.961.741.741 0 0 0-.138-.537.558.558 0 0 0-.446-.231c-.5 0-1.007.876-1.117 1.364 0 .039-.087.561-.1.7a24.871 24.871 0 0 1-.372-1.076 13.32 13.32 0 0 1-.379-1.48 3.729 3.729 0 0 0 1.188-.384 1.4 1.4 0 0 0 .611-.957.739.739 0 0 0-.145-.525.558.558 0 0 0-.439-.225c-.5 0-1.007.876-1.117 1.364 0 .031-.067.43-.094.619h-.027a9.553 9.553 0 0 1-.144-1.537v-.826a3.368 3.368 0 0 0 1.191-.227 1.357 1.357 0 0 0 .7-.876.755.755 0 0 0-.1-.539.582.582 0 0 0-.414-.279c-.5-.046-1.067.745-1.238 1.218 0 .027-.081.3-.128.5a2.1 2.1 0 0 1 .02-.357c.03-.43.084-.822.131-1.153.03-.2.057-.384.087-.542a3.911 3.911 0 0 0 .96-.822 1.552 1.552 0 0 0 .268-1.153.666.666 0 0 0-.3-.428.524.524 0 0 0-.48-.029c-.46.219-.648 1.226-.611 1.733 0 .046.121.726.131.719-.03.158-.06.327-.091.515-.057.346-.117.738-.154 1.153a12.208 12.208 0 0 0-.07 1.4 9.652 9.652 0 0 0 .114 1.56v.019a22.38 22.38 0 0 0-.289-.584c-.262-.411-.983-1.03-1.456-.849a.638.638 0 0 0-.349.382.771.771 0 0 0 .013.552 1.261 1.261 0 0 0 .859.665 3.725 3.725 0 0 0 1.228-.1 13.6 13.6 0 0 0 .362 1.537c.087.3.185.588.282.88a4.902 4.902 0 0 0-.127-.254c-.262-.411-.983-1.026-1.456-.849a.638.638 0 0 0-.349.381.77.77 0 0 0 .014.552 1.241 1.241 0 0 0 .859.665 3.438 3.438 0 0 0 1.191-.1l.134.4c.188.534.379 1.068.55 1.6.06.184.117.384.171.557l-.111-.219c-.265-.411-.983-1.03-1.456-.849a.633.633 0 0 0-.35.381.767.767 0 0 0 .015.553 1.256 1.256 0 0 0 .845.669 3.357 3.357 0 0 0 1.158-.088c.054.192.1.384.144.573.027.131.06.254.081.384l.064.384c.034.25.07.5.1.746.02.169.037.33.054.492a13.695 13.695 0 0 0-.195-.576 2.476 2.476 0 0 0-.805-.949 1.184 1.184 0 0 0-.07-.127.579.579 0 0 0-.416-.274.544.544 0 0 0-.456.17c-.359.384-.221 1.41-.027 1.871 0 .027.164.3.265.476-.074-.092-.141-.181-.218-.273a9.072 9.072 0 0 0-.46-.561l-.245-.277c-.081-.1-.178-.185-.265-.277a11.65 11.65 0 0 0-.654-.6 4.316 4.316 0 0 0 .772-1.03 1.6 1.6 0 0 0 .047-1.187.611.611 0 0 0-.375-.345.526.526 0 0 0-.474.091c-.409.327-.406 1.356-.272 1.845 0 .027.134.365.208.55-.138-.115-.272-.234-.413-.346a46.05 46.05 0 0 0-1.255-.957l-.382-.292a4.673 4.673 0 0 0 .805-1.065 1.613 1.613 0 0 0 .047-1.187.613.613 0 0 0-.375-.343.529.529 0 0 0-.474.089c-.409.327-.406 1.357-.275 1.845 0 .038.195.523.248.642-.282-.215-.56-.43-.829-.661a10.5 10.5 0 0 1-1.03-.992 4.6 4.6 0 0 0 .809-1.068 1.6 1.6 0 0 0 .047-1.187.611.611 0 0 0-.375-.345.526.526 0 0 0-.474.091c-.409.327-.406 1.357-.272 1.845 0 .031.148.384.218.576l-.023.019a8.923 8.923 0 0 1-.862-1.2c-.144-.231-.268-.465-.389-.692a4.3 4.3 0 0 0 .886-.941 1.6 1.6 0 0 0 .161-1.176.636.636 0 0 0-.339-.389.521.521 0 0 0-.479.031c-.439.273-.533 1.3-.45 1.8 0 .027.077.3.131.492l-.154-.311a13.612 13.612 0 0 1-.453-1.057 14.3 14.3 0 0 1-.184-.507 5.021 5.021 0 0 0 .4-1.3 1.558 1.558 0 0 0-.336-1.126.543.543 0 0 0-.459-.165.582.582 0 0 0-.414.28 2.137 2.137 0 0 0 .335 1.833c.024.035.45.526.453.515.05.154.1.315.168.492.121.323.262.688.436 1.072a13.343 13.343 0 0 0 .614 1.21 8.724 8.724 0 0 0 .849 1.23 9.192 9.192 0 0 0-.52-.3c-.419-.177-1.315-.238-1.624.211a.75.75 0 0 0-.105.537.675.675 0 0 0 .28.447 1.09 1.09 0 0 0 1.037 0 4.2 4.2 0 0 0 .973-.861 10.89 10.89 0 0 0 1.047 1.053 7.962 7.962 0 0 0 .671.557l-.228-.131c-.419-.177-1.315-.238-1.624.211a.75.75 0 0 0-.105.537.676.676 0 0 0 .28.447 1.08 1.08 0 0 0 1.037 0 4.047 4.047 0 0 0 .946-.83l.258.2c.416.327.832.653 1.231.984a13 13 0 0 1 .409.361l-.2-.111c-.416-.177-1.315-.238-1.624.207a.759.759 0 0 0-.1.538.684.684 0 0 0 .278.45 1.1 1.1 0 0 0 1.04 0 3.942 3.942 0 0 0 .923-.807c.134.131.268.257.4.384a2.788 2.788 0 0 1 .252.273l.242.28.44.561.282.384a16.366 16.366 0 0 0-.439-.357c-.389-.25-1.268-.465-1.634-.077a.738.738 0 0 0-.173.514.718.718 0 0 0 .217.492 1.106 1.106 0 0 0 1.023.192 4.035 4.035 0 0 0 1.08-.665c.137.213.285.417.419.609Z",
    "data-name": "Path 2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.003 137.858a3.769 3.769 0 0 0 1.03-.561s-.426-.407-.453-.43c-.336-.254-1.141-.511-1.493-.177a.68.68 0 0 0 0 .922 1.026 1.026 0 0 0 .916.246Z",
    "data-name": "Path 2033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.418 134.015s-.158-.607-.171-.646c-.168-.427-.708-1.153-1.161-1.088a.535.535 0 0 0-.38.266.694.694 0 0 0-.076.5 1.246 1.246 0 0 0 .671.792 3.481 3.481 0 0 0 1.117.176Z",
    "data-name": "Path 2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.819 142.041c.133.188.251.366.359.528h.283c-.136-.2-.283-.427-.475-.673-.1-.142-.22-.295-.339-.447a4.86 4.86 0 0 0 .3-.476 2.478 2.478 0 0 0 .8.065c.017.185.034.362.048.531.031.379.048.715.062 1h.22a22.473 22.473 0 0 0-.085-1.026c-.017-.184-.04-.382-.065-.586a2.667 2.667 0 0 0 .757-.392 1.022 1.022 0 0 0 .325-.719.489.489 0 0 0-.147-.333.369.369 0 0 0-.314-.1c-.333.071-.588.706-.627 1.049v.385a1.965 1.965 0 0 0-.031-.249c-.023-.168-.051-.324-.079-.515a1.428 1.428 0 0 0-.048-.262c-.017-.087-.04-.178-.059-.269a10.63 10.63 0 0 0-.175-.625 2.431 2.431 0 0 0 .777-.253.972.972 0 0 0 .415-.647.508.508 0 0 0-.1-.355.384.384 0 0 0-.3-.154c-.339 0-.673.6-.76.929 0 .019-.042.265-.059.4-.04-.123-.079-.249-.121-.372a41.134 41.134 0 0 0-.4-1.081l-.121-.324a2.591 2.591 0 0 0 .805-.259.972.972 0 0 0 .415-.647.508.508 0 0 0-.1-.357.384.384 0 0 0-.3-.155c-.339 0-.675.6-.76.929 0 .026-.059.379-.068.469-.09-.243-.178-.486-.254-.728a8.945 8.945 0 0 1-.26-1.007 2.535 2.535 0 0 0 .808-.259.971.971 0 0 0 .415-.647.5.5 0 0 0-.1-.357.378.378 0 0 0-.3-.151c-.336 0-.673.6-.757.926 0 .023-.048.291-.065.421h-.017a6.533 6.533 0 0 1-.1-1.049v-.56a2.452 2.452 0 0 0 .808-.155.934.934 0 0 0 .475-.6.514.514 0 0 0-.065-.367.4.4 0 0 0-.282-.19c-.336-.032-.726.508-.848.825 0 .019-.054.2-.088.34v-.243a13.4 13.4 0 0 1 .149-1.166 2.677 2.677 0 0 0 .653-.563 1.075 1.075 0 0 0 .184-.78.458.458 0 0 0-.2-.3.358.358 0 0 0-.331-.024c-.311.152-.441.835-.415 1.181 0 .029.085.492.09.489l-.065.353c-.037.233-.076.5-.1.793q-.047.474-.048.952a6.946 6.946 0 0 0 .079 1.062 5.972 5.972 0 0 0-.2-.395c-.178-.282-.667-.7-.986-.579a.434.434 0 0 0-.241.265.524.524 0 0 0 .015.383.855.855 0 0 0 .585.453 2.478 2.478 0 0 0 .834-.071 8.911 8.911 0 0 0 .249 1.045c.059.2.124.4.189.6-.042-.084-.079-.162-.088-.172-.178-.278-.667-.7-.989-.579a.431.431 0 0 0-.241.265.52.52 0 0 0 .018.382.854.854 0 0 0 .585.453 2.406 2.406 0 0 0 .811-.065l.076.227c.13.362.26.725.376 1.087.042.126.079.253.116.379l-.076-.149c-.178-.278-.667-.7-.989-.579a.432.432 0 0 0-.241.265.521.521 0 0 0 .018.382.854.854 0 0 0 .585.453 2.248 2.248 0 0 0 .786-.061c.037.133.071.262.1.392s.04.172.054.262.028.175.045.262c.023.168.045.343.065.508a2.771 2.771 0 0 0 .037.324c-.04-.126-.124-.372-.133-.392a1.686 1.686 0 0 0-.548-.647.333.333 0 0 0-.048-.087.394.394 0 0 0-.283-.187.37.37 0 0 0-.311.116 1.5 1.5 0 0 0-.017 1.272c0 .019.113.207.178.324l-.144-.188a9.81 9.81 0 0 0-.314-.379l-.167-.188c-.057-.065-.121-.126-.181-.188a5.491 5.491 0 0 0-.446-.411 2.882 2.882 0 0 0 .526-.7 1.1 1.1 0 0 0 .034-.809.416.416 0 0 0-.25-.226.358.358 0 0 0-.315.054c-.283.223-.283.922-.187 1.253 0 .023.093.249.141.376-.093-.078-.184-.159-.283-.236-.283-.22-.565-.434-.848-.647l-.26-.2a3.151 3.151 0 0 0 .546-.722 1.1 1.1 0 0 0 .034-.809.415.415 0 0 0-.25-.226.358.358 0 0 0-.315.054c-.283.223-.283.922-.187 1.253 0 .026.133.356.167.437a19.522 19.522 0 0 1-.565-.45 7.471 7.471 0 0 1-.7-.673 3.148 3.148 0 0 0 .551-.725 1.1 1.1 0 0 0 .023-.829.413.413 0 0 0-.25-.227.356.356 0 0 0-.315.056c-.283.223-.283.923-.186 1.253 0 .023.1.275.15.392a5.433 5.433 0 0 1-.588-.812c-.1-.159-.184-.324-.263-.473a2.775 2.775 0 0 0 .6-.647 1.091 1.091 0 0 0 .11-.8.435.435 0 0 0-.234-.27.356.356 0 0 0-.331.024c-.3.188-.362.884-.305 1.223 0 .019.054.2.09.324-.034-.071-.074-.142-.1-.21a9.6 9.6 0 0 1-.308-.722 9.355 9.355 0 0 1-.127-.343 3.362 3.362 0 0 0 .283-.88 1.063 1.063 0 0 0-.223-.764.37.37 0 0 0-.311-.114.4.4 0 0 0-.282.189 1.481 1.481 0 0 0 .22 1.246c.017.026.305.359.311.353.034.1.071.214.116.324.082.22.175.469.283.732a8.705 8.705 0 0 0 .418.822 5.883 5.883 0 0 0 .565.835 7.554 7.554 0 0 0-.356-.207c-.283-.12-.893-.162-1.1.142a.512.512 0 0 0-.071.365.462.462 0 0 0 .19.3.75.75 0 0 0 .7 0 2.806 2.806 0 0 0 .661-.586 7.7 7.7 0 0 0 .712.719c.144.129.283.253.446.375l-.155-.087c-.283-.12-.893-.162-1.1.142a.508.508 0 0 0-.072.366.458.458 0 0 0 .191.3.734.734 0 0 0 .7 0 2.815 2.815 0 0 0 .644-.566l.175.139c.283.223.565.443.848.67.093.078.186.162.283.243l-.133-.075c-.283-.12-.9-.162-1.1.142a.513.513 0 0 0-.071.365.462.462 0 0 0 .19.3.751.751 0 0 0 .706 0 2.646 2.646 0 0 0 .627-.547c.09.087.184.175.268.265s.116.117.172.185l.164.191.3.382c.1.126.127.172.189.256a10.98 10.98 0 0 0-.3-.246c-.266-.168-.862-.324-1.111-.049a.5.5 0 0 0-.119.349.486.486 0 0 0 .147.334.759.759 0 0 0 .7.129 2.651 2.651 0 0 0 .729-.463Z",
    "data-name": "Path 2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.347 138.023a3.558 3.558 0 0 0 1.007-.55s-.413-.384-.443-.415c-.336-.246-1.107-.5-1.453-.173a.664.664 0 0 0 0 .9 1 1 0 0 0 .889.238Z",
    "data-name": "Path 2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.494 134.295s-.154-.592-.168-.626c-.161-.415-.671-1.115-1.127-1.061a.518.518 0 0 0-.367.256.672.672 0 0 0-.075.485 1.2 1.2 0 0 0 .638.769 3.283 3.283 0 0 0 1.099.177Z",
    "data-name": "Path 2037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.775 137.561s.1-.384.111-.419c.111-.277.46-.745.755-.707a.348.348 0 0 1 .246.171.452.452 0 0 1 .052.324.8.8 0 0 1-.429.511 2.21 2.21 0 0 1-.735.12Z",
    "data-name": "Path 2043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.991 144.24c-.1.142-.195.281-.278.407h-.208c.1-.158.228-.33.366-.523.081-.108.168-.227.262-.346a3.459 3.459 0 0 1-.235-.384 1.9 1.9 0 0 1-.617.05c0 .142-.027.277-.037.407-.023.3-.04.557-.05.769h-.168c0-.227.034-.492.064-.792a3.624 3.624 0 0 1 .05-.453 2.1 2.1 0 0 1-.584-.3.784.784 0 0 1-.252-.553.378.378 0 0 1 .112-.259.285.285 0 0 1 .243-.079c.258.054.453.546.487.811v.3a1.412 1.412 0 0 1 .027-.192c.01-.069.037-.257.057-.384l.04-.2c.012-.07.028-.139.047-.207.037-.161.084-.323.134-.484a1.816 1.816 0 0 1-.6-.192.737.737 0 0 1-.336-.5.391.391 0 0 1 .082-.269.3.3 0 0 1 .227-.115c.262 0 .52.461.587.719 0 0 .034.2.047.311.03-.1.06-.192.094-.288a56.421 56.421 0 0 1 .399-1.092 1.986 1.986 0 0 1-.621-.2.741.741 0 0 1-.336-.5.387.387 0 0 1 .08-.27.292.292 0 0 1 .228-.114c.262 0 .52.457.587.715 0 0 .047.3.054.365.067-.188.134-.384.195-.565a6.6 6.6 0 0 0 .2-.768 2.049 2.049 0 0 1-.624-.2.729.729 0 0 1-.336-.5.391.391 0 0 1 .082-.269.3.3 0 0 1 .227-.115c.262 0 .52.461.587.719 0 0 .034.227.047.327h.017a5.3 5.3 0 0 0 .074-.811v-.434a1.783 1.783 0 0 1-.624-.119.71.71 0 0 1-.366-.457.4.4 0 0 1 .049-.283.3.3 0 0 1 .216-.147c.262-.027.564.384.671.638l.067.261v-.188c-.017-.227-.044-.43-.067-.615a1.368 1.368 0 0 0-.047-.281 2.131 2.131 0 0 1-.5-.434.817.817 0 0 1-.141-.6.349.349 0 0 1 .157-.226.274.274 0 0 1 .252-.016c.242.115.335.646.335.911 0 .023-.064.384-.07.384.017.085.034.173.05.269.027.185.06.384.081.615s.035.489.037.734a5.788 5.788 0 0 1-.06.819l.151-.307c.141-.215.517-.542.765-.446a.331.331 0 0 1 .183.2.4.4 0 0 1-.008.289.642.642 0 0 1-.453.35 1.924 1.924 0 0 1-.644-.054 6.4 6.4 0 0 1-.191.807 7.391 7.391 0 0 1-.148.465l.067-.135c.138-.215.517-.542.765-.446a.336.336 0 0 1 .181.2.405.405 0 0 1-.007.288.643.643 0 0 1-.453.35 1.744 1.744 0 0 1-.624-.05c-.023.058-.04.119-.064.177-.1.28-.2.561-.289.838-.03.1-.06.2-.087.3.027-.061.054-.108.057-.115.138-.219.517-.542.765-.446a.332.332 0 0 1 .18.2.4.4 0 0 1-.009.288.656.656 0 0 1-.45.35 1.821 1.821 0 0 1-.611-.046c-.027.1-.054.2-.074.3s-.03.135-.04.2-.024.135-.037.2l-.05.384c0 .088-.02.173-.027.258.03-.1.094-.288.1-.3a1.322 1.322 0 0 1 .423-.5.4.4 0 0 1 .037-.065.3.3 0 0 1 .219-.145.285.285 0 0 1 .24.092 1.116 1.116 0 0 1 0 .98l-.138.254.111-.146.245-.3.127-.142.138-.146c.111-.108.228-.215.336-.315a2.356 2.356 0 0 1-.406-.542.836.836 0 0 1-.023-.623.318.318 0 0 1 .2-.184.274.274 0 0 1 .25.049c.211.169.211.711.141.968 0 0-.07.192-.111.288l.218-.181c.215-.173.436-.338.671-.5l.2-.154a2.391 2.391 0 0 1-.419-.557.835.835 0 0 1-.027-.622.324.324 0 0 1 .2-.18.279.279 0 0 1 .249.046c.215.173.211.711.144.968 0 .019-.1.273-.131.338.148-.115.3-.231.436-.35a5.771 5.771 0 0 0 .54-.519 2.454 2.454 0 0 1-.426-.561.835.835 0 0 1-.023-.623.318.318 0 0 1 .2-.184.274.274 0 0 1 .25.049c.215.169.211.711.144.968 0 0-.081.211-.117.3a4.744 4.744 0 0 0 .453-.626 3.93 3.93 0 0 0 .2-.384 2.276 2.276 0 0 1-.456-.473.838.838 0 0 1-.084-.615.335.335 0 0 1 .178-.2.273.273 0 0 1 .251.016c.232.142.282.68.238.942 0 0-.044.158-.07.261.027-.054.057-.112.081-.165.094-.2.171-.384.238-.553.037-.1.067-.185.1-.265a2.64 2.64 0 0 1-.211-.68.807.807 0 0 1 .175-.592.281.281 0 0 1 .24-.09.3.3 0 0 1 .217.147 1.133 1.133 0 0 1-.171.964s-.235.277-.238.269c-.027.081-.054.165-.087.258a9.826 9.826 0 0 1-.228.561q-.153.329-.336.638a4.742 4.742 0 0 1-.443.646l.275-.158c.218-.092.671-.127.852.111a.4.4 0 0 1 .053.281.355.355 0 0 1-.147.234.569.569 0 0 1-.544 0 2.261 2.261 0 0 1-.51-.454 5.378 5.378 0 0 1-.55.553c-.111.1-.228.2-.335.292l.121-.069c.218-.092.691-.123.852.112a.4.4 0 0 1 .055.282.36.36 0 0 1-.145.237.575.575 0 0 1-.547 0 2.072 2.072 0 0 1-.5-.434l-.134.108a33.27 33.27 0 0 0-.648.515l-.215.188.1-.058c.218-.092.691-.127.852.111a.394.394 0 0 1 .055.281.356.356 0 0 1-.145.234.574.574 0 0 1-.547 0 2.025 2.025 0 0 1-.483-.423c-.07.065-.144.134-.208.2l-.134.142-.124.146-.232.3-.148.2c.07-.065.218-.181.232-.192.2-.127.671-.242.856-.038a.387.387 0 0 1 .091.271.377.377 0 0 1-.115.259.6.6 0 0 1-.537.1 2.08 2.08 0 0 1-.56-.357 1.961 1.961 0 0 0-.24.3Z",
    "data-name": "Path 2044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.897 138.695a3.314 3.314 0 0 0 .9-.492l-.4-.384c-.3-.223-1.007-.446-1.305-.154a.592.592 0 0 0 0 .807.894.894 0 0 0 .805.223Z",
    "data-name": "Path 2045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 135.344s-.138-.53-.151-.565c-.144-.384-.617-1-1.007-.953a.469.469 0 0 0-.331.232.608.608 0 0 0-.068.437 1.078 1.078 0 0 0 .577.692 2.962 2.962 0 0 0 .98.157Z",
    "data-name": "Path 2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.329 142.109-.314.46h-.237c.119-.175.26-.372.415-.589.093-.123.192-.256.3-.388a4.306 4.306 0 0 1-.263-.418 2.286 2.286 0 0 1-.7.058c-.014.159-.031.324-.042.463-.025.324-.042.628-.054.874h-.192c.014-.253.037-.554.073-.9a4.5 4.5 0 0 1 .057-.512 2.273 2.273 0 0 1-.661-.343.879.879 0 0 1-.283-.628.428.428 0 0 1 .128-.294.323.323 0 0 1 .276-.088c.283.061.514.618.548.919v.324a1.9 1.9 0 0 1 .028-.217c.02-.149.042-.295.068-.453l.042-.23c.014-.074.037-.155.054-.233.045-.185.1-.366.153-.547a2.071 2.071 0 0 1-.678-.22.84.84 0 0 1-.364-.573.444.444 0 0 1 .088-.311.336.336 0 0 1 .26-.135c.283 0 .591.521.664.813 0 .019.039.236.054.353.034-.107.068-.217.107-.324.11-.324.229-.631.348-.945.037-.1.071-.194.1-.288a2.178 2.178 0 0 1-.7-.227.839.839 0 0 1-.365-.57.441.441 0 0 1 .087-.312.333.333 0 0 1 .261-.134c.3 0 .591.521.664.812 0 .023.054.324.062.411.076-.214.153-.424.221-.647a7.993 7.993 0 0 0 .229-.88 2.232 2.232 0 0 1-.709-.227.842.842 0 0 1-.365-.57.444.444 0 0 1 .089-.312.334.334 0 0 1 .262-.134c.3 0 .588.521.664.812 0 .019.04.256.054.369h.028a5.833 5.833 0 0 0 .088-.919v-.489a2.035 2.035 0 0 1-.706-.136.794.794 0 0 1-.415-.521.446.446 0 0 1 .056-.321.342.342 0 0 1 .247-.165c.283-.029.636.443.738.722 0 .016.048.178.076.3v-.214c-.02-.256-.051-.489-.079-.7-.017-.117-.037-.223-.054-.324a2.375 2.375 0 0 1-.565-.492.925.925 0 0 1-.158-.683.4.4 0 0 1 .179-.254.311.311 0 0 1 .284-.018c.283.133.387.732.365 1.033 0 .026-.073.431-.076.427.017.094.037.2.054.307.034.207.071.44.093.7a7.59 7.59 0 0 1 .042.832 6.21 6.21 0 0 1-.068.926c.04-.087.161-.324.172-.346.155-.246.582-.615.865-.508a.377.377 0 0 1 .207.228.455.455 0 0 1-.012.329.746.746 0 0 1-.511.395 2.107 2.107 0 0 1-.729-.062 7.842 7.842 0 0 1-.218.916c-.051.175-.107.35-.167.521l.076-.149c.158-.246.585-.612.868-.5a.381.381 0 0 1 .2.228.459.459 0 0 1-.009.326.734.734 0 0 1-.511.395 2.085 2.085 0 0 1-.709-.055l-.068.2c-.113.324-.226.647-.328.952-.037.11-.071.22-.1.324.034-.068.062-.123.065-.133.158-.243.585-.612.868-.5a.376.376 0 0 1 .205.227.455.455 0 0 1-.01.327.741.741 0 0 1-.511.4 1.954 1.954 0 0 1-.69-.055 10.697 10.697 0 0 0-.133.573l-.037.23c-.02.146-.042.3-.059.443s-.02.2-.031.291c.034-.11.107-.324.116-.343a1.458 1.458 0 0 1 .478-.563.375.375 0 0 1 .042-.074.345.345 0 0 1 .247-.166.323.323 0 0 1 .273.1c.215.236.13.842.014 1.113a3.2 3.2 0 0 1-.155.285c.042-.055.085-.107.127-.165a4.14 4.14 0 0 1 .283-.324l.147-.162c.048-.058.1-.11.158-.165q.187-.185.39-.359a2.55 2.55 0 0 1-.461-.612.953.953 0 0 1-.028-.706.362.362 0 0 1 .223-.208.311.311 0 0 1 .283.055c.243.194.24.806.161 1.1 0 .016-.079.217-.124.324.082-.068.161-.139.246-.207.243-.191.495-.379.746-.566l.229-.175a2.8 2.8 0 0 1-.48-.647.953.953 0 0 1-.028-.706.367.367 0 0 1 .224-.2.316.316 0 0 1 .282.052c.243.2.24.809.164 1.1a3.428 3.428 0 0 1-.147.382c.167-.126.333-.256.492-.392a6.4 6.4 0 0 0 .613-.589 2.8 2.8 0 0 1-.48-.647.926.926 0 0 1-.028-.706.364.364 0 0 1 .222-.2.314.314 0 0 1 .281.052c.243.2.24.809.164 1.1 0 .019-.09.24-.133.343h.014a5.043 5.043 0 0 0 .514-.712c.085-.139.161-.278.232-.414a2.414 2.414 0 0 1-.526-.56.935.935 0 0 1-.1-.7.38.38 0 0 1 .2-.233.31.31 0 0 1 .285.016c.26.165.317.774.268 1.071l-.079.295.09-.185c.107-.227.195-.44.283-.631.042-.107.076-.207.11-.3a2.87 2.87 0 0 1-.24-.77.905.905 0 0 1 .2-.67.322.322 0 0 1 .272-.1.345.345 0 0 1 .245.166 1.291 1.291 0 0 1-.192 1.091c-.014.019-.283.324-.283.308l-.1.291c-.071.191-.155.408-.257.647a7.792 7.792 0 0 1-.367.718 5.142 5.142 0 0 1-.5.732 3.514 3.514 0 0 1 .311-.181c.249-.107.783-.142.967.123a.448.448 0 0 1 .062.32.4.4 0 0 1-.167.266.649.649 0 0 1-.616 0 2.56 2.56 0 0 1-.565-.515 6.517 6.517 0 0 1-.622.628c-.127.113-.26.223-.393.324l.138-.078c.246-.1.78-.139.964.126a.444.444 0 0 1 .063.32.4.4 0 0 1-.168.266.641.641 0 0 1-.616 0 2.4 2.4 0 0 1-.565-.5c-.051.042-.1.084-.155.123-.246.194-.492.388-.729.586-.085.068-.164.142-.246.214l.119-.068c.249-.1.783-.139.966.126a.445.445 0 0 1 .1.4.378.378 0 0 1-.267.286.646.646 0 0 1-.619 0 2.278 2.278 0 0 1-.548-.479c-.079.078-.161.152-.235.23s-.1.1-.15.162l-.144.168-.263.324c-.057.078-.11.152-.167.223l.263-.214c.232-.146.754-.275.969-.042a.431.431 0 0 1 .1.3.421.421 0 0 1-.13.291.656.656 0 0 1-.608.116 2.318 2.318 0 0 1-.636-.4 2.909 2.909 0 0 0-.274.344Z",
    "data-name": "Path 2047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.483 137.736a2.648 2.648 0 0 0 .725-.384s-.3-.288-.319-.3c-.245-.177-.805-.361-1.054-.123a.478.478 0 0 0 0 .649.723.723 0 0 0 .648.161Z",
    "data-name": "Path 2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.393 135.035s-.111-.431-.121-.457c-.117-.3-.5-.807-.819-.769a.375.375 0 0 0-.275.181.49.49 0 0 0-.061.356.866.866 0 0 0 .463.557 2.37 2.37 0 0 0 .813.132Z",
    "data-name": "Path 2049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.101 142.086.3.442h.242a19.004 19.004 0 0 0-.4-.561 15.84 15.84 0 0 0-.282-.384 3.905 3.905 0 0 0 .252-.384 2.3 2.3 0 0 0 .671.054c0 .15.027.3.04.442.023.319.04.6.05.838h.185c0-.242-.037-.53-.067-.857-.017-.158-.037-.323-.057-.492a2.106 2.106 0 0 0 .634-.33.84.84 0 0 0 .272-.6.407.407 0 0 0-.122-.282.306.306 0 0 0-.264-.084c-.278.058-.493.592-.527.88v.323a.554.554 0 0 0-.027-.207c-.017-.142-.04-.284-.064-.434l-.04-.219a1.161 1.161 0 0 0-.05-.227c-.044-.173-.094-.35-.148-.523a1.941 1.941 0 0 0 .651-.211.806.806 0 0 0 .335-.549.422.422 0 0 0-.084-.3.318.318 0 0 0-.251-.127c-.285 0-.567.5-.638.769 0 0-.037.223-.05.338-.034-.1-.067-.211-.1-.315-.1-.3-.218-.6-.336-.907l-.1-.277a2.022 2.022 0 0 0 .671-.215.8.8 0 0 0 .336-.546.422.422 0 0 0-.084-.3.318.318 0 0 0-.251-.127c-.285 0-.564.5-.637.769 0 .023-.05.319-.057.384-.074-.2-.148-.407-.211-.611a7.31 7.31 0 0 1-.218-.845 2.2 2.2 0 0 0 .671-.215.83.83 0 0 0 .336-.549.421.421 0 0 0-.084-.3.318.318 0 0 0-.251-.127c-.282 0-.564.5-.634.769 0 .019-.04.246-.054.354a5.4 5.4 0 0 1-.084-.88v-.469a1.93 1.93 0 0 0 .671-.131.765.765 0 0 0 .4-.5.43.43 0 0 0-.054-.306.332.332 0 0 0-.234-.159c-.285-.027-.611.427-.708.692 0 0-.047.169-.074.284v-.2a9.622 9.622 0 0 1 .124-.972 2.3 2.3 0 0 0 .547-.473.9.9 0 0 0 .154-.653.379.379 0 0 0-.172-.245.3.3 0 0 0-.274-.016c-.262.127-.369.7-.336.988 0 .027.07.415.074.411-.02.092-.037.188-.054.3q-.058.33-.087.665a7.352 7.352 0 0 0-.04.8 5.485 5.485 0 0 0 .064.891c-.04-.084-.154-.315-.164-.33-.151-.234-.56-.588-.829-.484a.361.361 0 0 0-.2.217.435.435 0 0 0 .009.313.708.708 0 0 0 .49.384 2.092 2.092 0 0 0 .7-.061 7.784 7.784 0 0 0 .208.88c.05.165.1.334.161.5l-.074-.142c-.151-.235-.56-.588-.829-.484a.361.361 0 0 0-.2.217.435.435 0 0 0 .009.313.7.7 0 0 0 .49.384 1.94 1.94 0 0 0 .671-.054l.067.192c.107.3.215.607.312.911.037.1.067.211.1.319a1.231 1.231 0 0 0-.064-.127c-.148-.234-.56-.584-.829-.484a.361.361 0 0 0-.2.217.436.436 0 0 0 .009.313.715.715 0 0 0 .49.384 1.9 1.9 0 0 0 .671-.05c.03.108.057.219.081.327s.034.146.047.219.023.15.037.223c.02.138.04.284.054.423s.023.188.03.28c-.034-.1-.1-.311-.107-.327a1.464 1.464 0 0 0-.46-.542l-.04-.073a.33.33 0 0 0-.239-.158.31.31 0 0 0-.261.1 1.209 1.209 0 0 0 0 1.064l.151.273-.124-.158a9.752 9.752 0 0 0-.262-.319l-.141-.158c-.047-.054-.1-.1-.151-.158a6.727 6.727 0 0 0-.372-.342 2.5 2.5 0 0 0 .439-.588.909.909 0 0 0 .027-.676.348.348 0 0 0-.213-.2.3.3 0 0 0-.27.051c-.232.184-.232.768-.154 1.049 0 .019.077.212.117.315l-.235-.2a40.675 40.675 0 0 0-.715-.546l-.218-.165a2.669 2.669 0 0 0 .46-.607.926.926 0 0 0 .027-.676.349.349 0 0 0-.214-.2.3.3 0 0 0-.272.053c-.231.188-.228.769-.154 1.053 0 0 .111.3.141.365a4.639 4.639 0 0 1-.473-.384 6.79 6.79 0 0 1-.587-.565 2.656 2.656 0 0 0 .463-.611.923.923 0 0 0 .027-.676.348.348 0 0 0-.214-.194.3.3 0 0 0-.269.052c-.235.184-.231.769-.158 1.049 0 .019.084.231.124.327a4.975 4.975 0 0 1-.49-.68c-.084-.134-.154-.265-.221-.384a2.406 2.406 0 0 0 .5-.538.893.893 0 0 0 .091-.669.363.363 0 0 0-.194-.221.3.3 0 0 0-.273.017c-.248.158-.3.738-.255 1.026 0 0 .044.169.077.281-.03-.058-.064-.119-.091-.177-.1-.215-.185-.423-.258-.6-.04-.1-.074-.2-.1-.288a2.812 2.812 0 0 0 .228-.738.87.87 0 0 0-.188-.642.309.309 0 0 0-.26-.1.33.33 0 0 0-.236.158 1.238 1.238 0 0 0 .185 1.045 2.935 2.935 0 0 0 .262.3c.03.088.06.181.1.28.07.184.148.384.248.611s.214.468.335.692a5.331 5.331 0 0 0 .483.7 3.297 3.297 0 0 0-.3-.173c-.238-.1-.752-.138-.926.119a.428.428 0 0 0-.059.306.386.386 0 0 0 .16.255.63.63 0 0 0 .591 0 2.442 2.442 0 0 0 .554-.492 5.966 5.966 0 0 0 .6.6c.121.108.248.215.376.319l-.131-.077c-.238-.1-.752-.135-.926.123a.428.428 0 0 0-.059.306.386.386 0 0 0 .16.255.629.629 0 0 0 .59 0 2.249 2.249 0 0 0 .56-.407l.148.119c.235.185.473.384.7.561.081.065.158.134.235.2l-.114-.065c-.235-.1-.748-.135-.923.119a.428.428 0 0 0-.063.308.387.387 0 0 0 .16.257.627.627 0 0 0 .594 0 2.14 2.14 0 0 0 .523-.457l.228.219c.047.054.1.1.141.158l.138.158c.084.107.171.215.252.323s.107.142.161.211c-.081-.065-.235-.2-.252-.2-.221-.142-.721-.265-.929-.042a.416.416 0 0 0-.1.292.406.406 0 0 0 .124.28.628.628 0 0 0 .584.108 2.2 2.2 0 0 0 .611-.384Z",
    "data-name": "Path 2050"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M176.086 144.648h108.038",
    "data-name": "Line 254"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.492 144.648h6.472",
    "data-name": "Path 2555"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M112.251 144.648h32.912",
    "data-name": "Line 310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.376 144.648h118.556",
    "data-name": "Path 62422"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M291.142 144.648h109.291",
    "data-name": "Line 254"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m116.726 143.177 1.707-1.073 1.826 1.112 1.826-1.112 1.826 1.112 1.828-1.112 1.826 1.112 1.826-1.112 1.826 1.112 1.826-1.112 1.826 1.112 1.826-1.112 1.826 1.112 1.826-1.112 1.862 1.237 1.787-1.237 1.761 1.658v.851l-31.614-.073Z",
    "data-name": "Path 2125",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m67.058 144.49-35.934.057 2.59-1.367 1.71-1.076 1.833 1.115 1.831-1.115 1.831 1.115 1.834-1.115 1.831 1.115 1.83-1.115 1.832 1.115 1.831-1.115 1.831 1.115 1.831-1.115 1.832 1.115 1.83-1.115 1.868 1.241 1.792-1.241 1.831 1.115 1.832-1.115 1.83 1.115 1.829-1.115 1.457.888 1.414-.888 1.831 1.115 1.83-1.115 1.832 1.115 1.833-1.115 1.831 1.115 1.832-1.115 1.831 1.115 1.831-1.115 1.831 1.115 1.83-1.115 1.832 1.115 1.826-1.115 1.868 1.241 1.796-1.241 1.836 1.115 1.827-1.115 1.831 1.115 1.828-1.115 1.831 1.115v1.267l-39.09.061Z",
    "data-name": "Union 95",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m190.345 142.914 2.02-1.27 2.161 1.316 2.161-1.316 2.161 1.316 2.163-1.316 2.157 1.32 2.161-1.316 2.161 1.316 2.161-1.316 2.161 1.316 2.161-1.316 2.161 1.316 2.161-1.316 2.2 1.464 2.115-1.464 2.083 1.962v1.007l-37.409-.086Z",
    "data-name": "Path 2553",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m72.042 142.104-1.829 1.115-1.831-1.115-1.829 1.115-1.831-1.115-1.831 1.115-1.831-1.115-1.829 1.115-1.831-1.115-1.83 1.12-1.831-1.115-1.831 1.115-1.831-1.115-1.831 1.115-1.831-1.115-1.831 1.115-1.831-1.115-1.834 1.115-1.831-1.115-1.831 1.115-1.831-1.115-1.831 1.115-1.831-1.115-1.834 1.115",
    "data-name": "Path 2123",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m143.999 142.104-1.824 1.112-1.826-1.112-1.826 1.112-1.826-1.112-1.826 1.112-1.826-1.112-1.826 1.112-1.826-1.112-1.826 1.112-1.826-1.112-1.828 1.112-1.826-1.112-1.826 1.112-1.826-1.112-1.826 1.112-1.826-1.112-1.828 1.112",
    "data-name": "Path 2126",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m71.928 142.104 1.824 1.113 1.826-1.113 1.826 1.113 1.826-1.113 1.826 1.113 1.826-1.113 1.826 1.113 1.826-1.113 1.826 1.113 1.826-1.113 1.828 1.113 1.826-1.113 1.826 1.113 1.826-1.113 1.826 1.113 1.826-1.113 1.828 1.113",
    "data-name": "Path 70596",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m222.613 141.644-2.158 1.316-2.161-1.316-2.161 1.316-2.161-1.316-2.161 1.316-2.161-1.316-2.161 1.316-2.161-1.316-2.161 1.316-2.161-1.316-2.156 1.32-2.161-1.316-2.161 1.316-2.161-1.316-2.161 1.316-2.161-1.316-2.165 1.316",
    "data-name": "Path 2554",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 86",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "freepik--Tree--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M47.185 141.581a102.521 102.521 0 0 1-4.629-10.79 37.267 37.267 0 0 1 0-17.15c.784-3.25 2.94-8.528 6.46-15.246s6.361-16.03 7.629-18.834 13.507-10.424 16.248-12.219l2.74-1.792",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M28.658 60.842s5.482 6.39 8.419 10.651 10.668 22.2 10.668 22.2-4.7 8.521-6.656 13.225-4.111 11.208-4.111 17.039-.1 11.435-.1 14.236a10.556 10.556 0 0 1-.751 3.566",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m44.656 61.882.348 20.26.287.517 4.417 8.11a60.277 60.277 0 0 0 2.633-5.937c2-4.995 5.023-13.225 4.924-14.233s-8.056-10.315-8.546-11.1",
    "data-name": "Path 224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M74.169 65.327s-14.388 9.191-15.365 9.416 5.186-13.341 5.186-13.341",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M62.522 61.291s-3.711 5.942-4.208 6.5-8.221-8.632-8.221-8.632",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m37.076 55.798-1.272 11.21-7.342-8.3",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m43.679 60.2-1.163 17.195-5.39-9.751.75-13.374",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M39.133 142.34a16.591 16.591 0 0 0-.59-4.813 52.437 52.437 0 0 1-.839-13.959",
    "data-name": "Path 229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M38.543 125.974a37.445 37.445 0 0 0 .254 6.161",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M39.551 131.078a26.155 26.155 0 0 0 .59 5.007 23.01 23.01 0 0 0 1.093 3.849",
    "data-name": "Path 231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M39.383 113.652s-1.093 4.333-1.344 6.355",
    "data-name": "Path 232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M39.048 120.488s-.252 2.791-.336 3.561",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m41.821 106.53 3.699-7.607",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m44.679 101.908 3.363-5.968",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Leaves--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.557 95.59a1.293 1.293 0 0 1-.9.85 2.68 2.68 0 0 1-1.528-.387 4.214 4.214 0 0 1 1.348-.864 1.038 1.038 0 0 1 1.08.401Z",
    "data-name": "Path 296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M65.848 75.172a1.946 1.946 0 0 1 1.938-.583 5.488 5.488 0 0 1 2.142 1.87 6.466 6.466 0 0 1-2.654.236 2.106 2.106 0 0 1-1.426-1.523Z",
    "data-name": "Path 297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.604 109.323a1.946 1.946 0 0 1 1.938-.583 5.5 5.5 0 0 1 2.144 1.87 6.472 6.472 0 0 1-2.654.236 2.115 2.115 0 0 1-1.428-1.523Z",
    "data-name": "Path 298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M73.596 72.742a2.309 2.309 0 0 1 1.295 1.752 6.594 6.594 0 0 1-.551 3.02 8.769 8.769 0 0 1-1.328-2.643 2.387 2.387 0 0 1 .584-2.129Z",
    "data-name": "Path 299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.629 118.242a2.32 2.32 0 0 1 1.3 1.752 6.614 6.614 0 0 1-.542 3.021 8.77 8.77 0 0 1-1.328-2.643 2.4 2.4 0 0 1 .57-2.13Z",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M53.922 72.874a1.293 1.293 0 0 1-.9.85 2.689 2.689 0 0 1-1.53-.387 4.235 4.235 0 0 1 1.35-.864 1.038 1.038 0 0 1 1.08.401Z",
    "data-name": "Path 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.908 70.551a1.293 1.293 0 0 1-.9.85 2.683 2.683 0 0 1-1.53-.387 4.213 4.213 0 0 1 1.351-.864 1.036 1.036 0 0 1 1.079.401Z",
    "data-name": "Path 302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.456 117.999a1.293 1.293 0 0 1-.9.85 2.7 2.7 0 0 1-1.53-.387 4.228 4.228 0 0 1 1.351-.867 1.04 1.04 0 0 1 1.079.404Z",
    "data-name": "Path 303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M49.975 66.524a2.323 2.323 0 0 1-1.443 1.587 4.58 4.58 0 0 1-2.666-.446 7.49 7.49 0 0 1 2.223-1.677 1.774 1.774 0 0 1 1.886.536Z",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M67.019 63.732a2.323 2.323 0 0 1-1.443 1.587 4.586 4.586 0 0 1-2.666-.444 7.506 7.506 0 0 1 2.217-1.689 1.791 1.791 0 0 1 1.892.546Z",
    "data-name": "Path 305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M42.25 60.968a2.612 2.612 0 0 1-.825 2.1 4.614 4.614 0 0 1-2.614.744 8.807 8.807 0 0 1 1.5-2.517 1.725 1.725 0 0 1 1.939-.327Z",
    "data-name": "Path 306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M80.801 85.42a2.39 2.39 0 0 1 1.34-1.7 4.512 4.512 0 0 1 2.68.217 7.7 7.7 0 0 1-2.107 1.861 1.753 1.753 0 0 1-1.913-.378Z",
    "data-name": "Path 307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M46.578 60.349a2.387 2.387 0 0 1 1.342-1.707 4.5 4.5 0 0 1 2.68.22 7.671 7.671 0 0 1-2.107 1.861 1.747 1.747 0 0 1-1.915-.374Z",
    "data-name": "Path 308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.209 74.669a2.391 2.391 0 0 1 1.344-1.705 4.5 4.5 0 0 1 2.68.22 7.746 7.746 0 0 1-2.107 1.861 1.747 1.747 0 0 1-1.917-.376Z",
    "data-name": "Path 309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M81.209 74.669a2.391 2.391 0 0 1 1.344-1.705 4.5 4.5 0 0 1 2.68.22 7.746 7.746 0 0 1-2.107 1.861 1.747 1.747 0 0 1-1.917-.376Z",
    "data-name": "Path 310",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.322 91.438a2.385 2.385 0 0 1 1.342-1.705 4.5 4.5 0 0 1 2.68.22 7.71 7.71 0 0 1-2.107 1.861 1.742 1.742 0 0 1-1.915-.376Z",
    "data-name": "Path 311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54.322 91.438a2.385 2.385 0 0 1 1.342-1.705 4.5 4.5 0 0 1 2.68.22 7.71 7.71 0 0 1-2.107 1.861 1.742 1.742 0 0 1-1.915-.376Z",
    "data-name": "Path 312",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.394 83.641a1.891 1.891 0 0 1 2 .1 6.117 6.117 0 0 1 1.567 2.513 6.636 6.636 0 0 1-2.6-.673 2.327 2.327 0 0 1-.967-1.94Z",
    "data-name": "Path 313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M66.394 83.641a1.891 1.891 0 0 1 2 .1 6.117 6.117 0 0 1 1.567 2.513 6.636 6.636 0 0 1-2.6-.673 2.327 2.327 0 0 1-.967-1.94Z",
    "data-name": "Path 314",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.46 104.679a1.9 1.9 0 0 1-2 .154 5.737 5.737 0 0 1-1.794-2.3 6.5 6.5 0 0 1 2.643.347 2.259 2.259 0 0 1 1.151 1.799Z",
    "data-name": "Path 315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M33.46 104.679a1.9 1.9 0 0 1-2 .154 5.737 5.737 0 0 1-1.794-2.3 6.5 6.5 0 0 1 2.643.347 2.259 2.259 0 0 1 1.151 1.799Z",
    "data-name": "Path 316",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.594 70.733a1.9 1.9 0 0 1-2 .154 5.737 5.737 0 0 1-1.794-2.3 6.5 6.5 0 0 1 2.643.347 2.26 2.26 0 0 1 1.151 1.799Z",
    "data-name": "Path 317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M29.594 70.733a1.9 1.9 0 0 1-2 .154 5.737 5.737 0 0 1-1.794-2.3 6.5 6.5 0 0 1 2.643.347 2.26 2.26 0 0 1 1.151 1.799Z",
    "data-name": "Path 318",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.091 60.524a1.885 1.885 0 0 1 2 .1 5.974 5.974 0 0 1 1.565 2.51 6.629 6.629 0 0 1-2.594-.673 2.328 2.328 0 0 1-.971-1.937Z",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M58.091 60.524a1.885 1.885 0 0 1 2 .1 5.974 5.974 0 0 1 1.565 2.51 6.629 6.629 0 0 1-2.594-.673 2.328 2.328 0 0 1-.971-1.937Z",
    "data-name": "Path 320",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.147 67.079a1.882 1.882 0 0 1 2 .1 6.011 6.011 0 0 1 1.567 2.51 6.636 6.636 0 0 1-2.6-.673 2.323 2.323 0 0 1-.967-1.937Z",
    "data-name": "Path 321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M65.147 67.079a1.882 1.882 0 0 1 2 .1 6.011 6.011 0 0 1 1.567 2.51 6.636 6.636 0 0 1-2.6-.673 2.323 2.323 0 0 1-.967-1.937Z",
    "data-name": "Path 322",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.963 65.05a2.668 2.668 0 0 1 .452 2.239 5.741 5.741 0 0 1-1.7 2.4 9.736 9.736 0 0 1-.124-3.044 2.053 2.053 0 0 1 1.372-1.595Z",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M69.963 65.05a2.668 2.668 0 0 1 .452 2.239 5.741 5.741 0 0 1-1.7 2.4 9.736 9.736 0 0 1-.124-3.044 2.053 2.053 0 0 1 1.372-1.595Z",
    "data-name": "Path 324",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.992 63.18a2.543 2.543 0 0 1-1.031 1.974 4.544 4.544 0 0 1-2.68.385 8.466 8.466 0 0 1 1.763-2.284 1.76 1.76 0 0 1 1.948-.075Z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M81.992 63.18a2.543 2.543 0 0 1-1.031 1.974 4.544 4.544 0 0 1-2.68.385 8.466 8.466 0 0 1 1.763-2.284 1.76 1.76 0 0 1 1.948-.075Z",
    "data-name": "Path 326",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.262 68.996a1.919 1.919 0 0 1-1.932-.607 6.4 6.4 0 0 1-1.031-2.85 6.97 6.97 0 0 1 2.4 1.322 2.434 2.434 0 0 1 .563 2.135Z",
    "data-name": "Path 327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M81.262 68.996a1.919 1.919 0 0 1-1.932-.607 6.4 6.4 0 0 1-1.031-2.85 6.97 6.97 0 0 1 2.4 1.322 2.434 2.434 0 0 1 .563 2.135Z",
    "data-name": "Path 328",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.838 75.049a2.439 2.439 0 0 1-1.058-1.951 6.386 6.386 0 0 1 .932-2.9 9.208 9.208 0 0 1 .973 2.834 2.3 2.3 0 0 1-.847 2.017Z",
    "data-name": "Path 329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M36.838 75.049a2.439 2.439 0 0 1-1.058-1.951 6.386 6.386 0 0 1 .932-2.9 9.208 9.208 0 0 1 .973 2.834 2.3 2.3 0 0 1-.847 2.017Z",
    "data-name": "Path 330",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.672 71.632a2.375 2.375 0 0 1 1.361-1.686 4.52 4.52 0 0 1 2.68.26 7.677 7.677 0 0 1-2.128 1.83 1.753 1.753 0 0 1-1.913-.404Z",
    "data-name": "Path 331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M32.672 71.632a2.375 2.375 0 0 1 1.361-1.686 4.52 4.52 0 0 1 2.68.26 7.677 7.677 0 0 1-2.128 1.83 1.753 1.753 0 0 1-1.913-.404Z",
    "data-name": "Path 332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.24 63.863a2.544 2.544 0 0 1-1.031 1.972 4.573 4.573 0 0 1-2.68.387 8.334 8.334 0 0 1 1.751-2.3 1.742 1.742 0 0 1 1.96-.059Z",
    "data-name": "Path 333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M42.24 63.863a2.544 2.544 0 0 1-1.031 1.972 4.573 4.573 0 0 1-2.68.387 8.334 8.334 0 0 1 1.751-2.3 1.742 1.742 0 0 1 1.96-.059Z",
    "data-name": "Path 334",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.511 69.677a1.916 1.916 0 0 1-1.934-.607 6.4 6.4 0 0 1-1.031-2.848 7.01 7.01 0 0 1 2.4 1.32 2.426 2.426 0 0 1 .565 2.135Z",
    "data-name": "Path 335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M41.511 69.677a1.916 1.916 0 0 1-1.934-.607 6.4 6.4 0 0 1-1.031-2.848 7.01 7.01 0 0 1 2.4 1.32 2.426 2.426 0 0 1 .565 2.135Z",
    "data-name": "Path 336",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.678 72.01a2.537 2.537 0 0 1-1.031 1.972 4.574 4.574 0 0 1-2.68.387 8.336 8.336 0 0 1 1.751-2.3 1.742 1.742 0 0 1 1.96-.059Z",
    "data-name": "Path 337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M62.678 72.01a2.537 2.537 0 0 1-1.031 1.972 4.574 4.574 0 0 1-2.68.387 8.336 8.336 0 0 1 1.751-2.3 1.742 1.742 0 0 1 1.96-.059Z",
    "data-name": "Path 338",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.949 77.824a1.923 1.923 0 0 1-1.934-.607 6.362 6.362 0 0 1-1.031-2.848 6.991 6.991 0 0 1 2.4 1.32 2.438 2.438 0 0 1 .565 2.135Z",
    "data-name": "Path 339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M61.949 77.824a1.923 1.923 0 0 1-1.934-.607 6.362 6.362 0 0 1-1.031-2.848 6.991 6.991 0 0 1 2.4 1.32 2.438 2.438 0 0 1 .565 2.135Z",
    "data-name": "Path 340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.095 74.703a2.316 2.316 0 0 1 1.46-1.575 4.556 4.556 0 0 1 2.662.472 7.382 7.382 0 0 1-2.231 1.653 1.8 1.8 0 0 1-1.891-.55Z",
    "data-name": "Path 341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M52.095 74.703a2.316 2.316 0 0 1 1.46-1.575 4.556 4.556 0 0 1 2.662.472 7.382 7.382 0 0 1-2.231 1.653 1.8 1.8 0 0 1-1.891-.55Z",
    "data-name": "Path 342",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.192 69.339a2.063 2.063 0 0 1 1.715 1.181 6.686 6.686 0 0 1 .313 3.07 7.962 7.962 0 0 1-1.99-2.024 2.48 2.48 0 0 1-.038-2.227Z",
    "data-name": "Path 343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54.192 69.339a2.063 2.063 0 0 1 1.715 1.181 6.686 6.686 0 0 1 .313 3.07 7.962 7.962 0 0 1-1.99-2.024 2.48 2.48 0 0 1-.038-2.227Z",
    "data-name": "Path 344",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.965 67.507a2.318 2.318 0 0 1 1.458-1.578 4.569 4.569 0 0 1 2.664.472 7.372 7.372 0 0 1-2.233 1.653 1.8 1.8 0 0 1-1.889-.547Z",
    "data-name": "Path 345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M55.965 67.507a2.318 2.318 0 0 1 1.458-1.578 4.569 4.569 0 0 1 2.664.472 7.372 7.372 0 0 1-2.233 1.653 1.8 1.8 0 0 1-1.889-.547Z",
    "data-name": "Path 346",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.058 62.143a2.065 2.065 0 0 1 1.713 1.181 6.728 6.728 0 0 1 .315 3.07 7.979 7.979 0 0 1-1.99-2.022 2.486 2.486 0 0 1-.038-2.229Z",
    "data-name": "Path 347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M58.058 62.143a2.065 2.065 0 0 1 1.713 1.181 6.728 6.728 0 0 1 .315 3.07 7.979 7.979 0 0 1-1.99-2.022 2.486 2.486 0 0 1-.038-2.229Z",
    "data-name": "Path 348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.522 79.176a2.537 2.537 0 0 1-1.031 1.972 4.574 4.574 0 0 1-2.681.387 8.338 8.338 0 0 1 1.751-2.3 1.742 1.742 0 0 1 1.961-.059Z",
    "data-name": "Path 349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M48.522 79.176a2.537 2.537 0 0 1-1.031 1.972 4.574 4.574 0 0 1-2.681.387 8.338 8.338 0 0 1 1.751-2.3 1.742 1.742 0 0 1 1.961-.059Z",
    "data-name": "Path 350",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.792 84.982a1.923 1.923 0 0 1-1.934-.607 6.362 6.362 0 0 1-1.031-2.848 6.991 6.991 0 0 1 2.4 1.32 2.438 2.438 0 0 1 .565 2.135Z",
    "data-name": "Path 351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M47.792 84.982a1.923 1.923 0 0 1-1.934-.607 6.362 6.362 0 0 1-1.031-2.848 6.991 6.991 0 0 1 2.4 1.32 2.438 2.438 0 0 1 .565 2.135Z",
    "data-name": "Path 352",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.332 90.251a1.887 1.887 0 0 1 2 .1 6 6 0 0 1 1.567 2.513 6.635 6.635 0 0 1-2.6-.673 2.326 2.326 0 0 1-.967-1.94Z",
    "data-name": "Path 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M33.332 90.251a1.887 1.887 0 0 1 2 .1 6 6 0 0 1 1.567 2.513 6.635 6.635 0 0 1-2.6-.673 2.326 2.326 0 0 1-.967-1.94Z",
    "data-name": "Path 354",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.149 88.225a2.668 2.668 0 0 1 .452 2.239 5.741 5.741 0 0 1-1.7 2.4 9.679 9.679 0 0 1-.124-3.046 2.046 2.046 0 0 1 1.372-1.593Z",
    "data-name": "Path 355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M38.149 88.225a2.668 2.668 0 0 1 .452 2.239 5.741 5.741 0 0 1-1.7 2.4 9.679 9.679 0 0 1-.124-3.046 2.046 2.046 0 0 1 1.372-1.593Z",
    "data-name": "Path 356",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M46.166 72.815a9.372 9.372 0 0 0-.887 2.874 4.941 4.941 0 0 0 2.359-1.488 2.734 2.734 0 0 0 .317-2.269 1.8 1.8 0 0 0-1.789.883Zm1.767 3.089a2.219 2.219 0 0 1 1.219 1.743 1.9 1.9 0 0 1-1.992.253 5.677 5.677 0 0 1-1.88-2.21 6.5 6.5 0 0 1 2.653.214Z",
    "data-name": "Path 357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M41.248 74.425a6.531 6.531 0 0 0 2.65-.279 5.23 5.23 0 0 0-2.167-1.833 1.956 1.956 0 0 0-1.93.616 2.093 2.093 0 0 0 1.447 1.496Zm1.711-3.141a2.281 2.281 0 0 1 .872-2 2.446 2.446 0 0 1 1.031 1.967 6.4 6.4 0 0 1-.967 2.881 9.147 9.147 0 0 1-.935-2.847Z",
    "data-name": "Path 358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M53.089 63.074a8.07 8.07 0 0 0 1.823 2.222 6.721 6.721 0 0 0-.07-3.084 2.128 2.128 0 0 0-1.612-1.365 2.472 2.472 0 0 0-.141 2.227Zm3.208-.38a1.735 1.735 0 0 1 1.911-.439 2.654 2.654 0 0 1-.72 2.144 4.652 4.652 0 0 1-2.577.9 8.845 8.845 0 0 1 1.386-2.605Z",
    "data-name": "Path 359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.592 70.085a8.112 8.112 0 0 0 1.823 2.222 6.73 6.73 0 0 0-.07-3.087 2.116 2.116 0 0 0-1.612-1.363 2.472 2.472 0 0 0-.141 2.228Zm3.208-.38a1.735 1.735 0 0 1 1.911-.439 2.65 2.65 0 0 1-.72 2.142 4.663 4.663 0 0 1-2.577.9 8.844 8.844 0 0 1 1.384-2.603Z",
    "data-name": "Path 360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M74.836 63.591a9.373 9.373 0 0 0-.887 2.874 4.953 4.953 0 0 0 2.361-1.488 2.72 2.72 0 0 0 .317-2.267 1.8 1.8 0 0 0-1.791.881Zm1.767 3.089a2.219 2.219 0 0 1 1.219 1.743 1.9 1.9 0 0 1-1.992.253 5.657 5.657 0 0 1-1.88-2.21 6.5 6.5 0 0 1 2.653.214Z",
    "data-name": "Path 361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M41.289 82.174a9.687 9.687 0 0 0-.035-3.049 5.674 5.674 0 0 0-1.765 2.331 2.679 2.679 0 0 0 .386 2.253 2.019 2.019 0 0 0 1.414-1.535Zm-2.6-2.2a1.952 1.952 0 0 1-1.67-1.152 2.081 2.081 0 0 1 1.794-1.027 4.925 4.925 0 0 1 2.431 1.33 6.744 6.744 0 0 1-2.551.85Z",
    "data-name": "Path 362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M70.689 65.931a7.053 7.053 0 0 0 2.443-1.209 4.746 4.746 0 0 0-2.559-.971 2.181 2.181 0 0 0-1.667 1.28 1.873 1.873 0 0 0 1.783.9Zm.775-3.585a2.462 2.462 0 0 1 .289-2.208 2.168 2.168 0 0 1 1.515 1.5 6.632 6.632 0 0 1-.136 3.07 8.22 8.22 0 0 1-1.667-2.359Z",
    "data-name": "Path 363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M92.47 87.027a6.508 6.508 0 0 0-2.662-.026 5.527 5.527 0 0 0 2 2.073 1.921 1.921 0 0 0 1.975-.394 2.169 2.169 0 0 0-1.313-1.653Zm-1.975 2.914a2.226 2.226 0 0 1-1.043 1.889 2.533 2.533 0 0 1-.858-2.076 6.188 6.188 0 0 1 1.214-2.756 9.531 9.531 0 0 1 .69 2.943Z",
    "data-name": "Path 364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M31.291 60.456a9.472 9.472 0 0 0 .716 2.935 6.207 6.207 0 0 0 1.186-2.77 2.526 2.526 0 0 0-.876-2.066 2.217 2.217 0 0 0-1.026 1.901Zm3 1.367a1.8 1.8 0 0 1 1.872.626 2.29 2.29 0 0 1-1.505 1.516 4.6 4.6 0 0 1-2.647-.574 7.357 7.357 0 0 1 2.276-1.567Z",
    "data-name": "Path 365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.798 96.672a1.355 1.355 0 0 1 1.052.817 4.239 4.239 0 0 1 .115 1.953 5.219 5.219 0 0 1-1.2-1.353 1.58 1.58 0 0 1 .033-1.417Z",
    "data-name": "Path 366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M85.798 96.672a1.355 1.355 0 0 1 1.052.817 4.239 4.239 0 0 1 .115 1.953 5.219 5.219 0 0 1-1.2-1.353 1.58 1.58 0 0 1 .033-1.417Z",
    "data-name": "Path 367",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.79 101.4a1.353 1.353 0 0 1 1.054.815 4.27 4.27 0 0 1 .115 1.953 5.249 5.249 0 0 1-1.206-1.353 1.577 1.577 0 0 1 .037-1.415Z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50.79 101.4a1.353 1.353 0 0 1 1.054.815 4.27 4.27 0 0 1 .115 1.953 5.249 5.249 0 0 1-1.206-1.353 1.577 1.577 0 0 1 .037-1.415Z",
    "data-name": "Path 369",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.546 120.536a1.355 1.355 0 0 1 1.052.817 4.24 4.24 0 0 1 .115 1.953 5.219 5.219 0 0 1-1.2-1.353 1.6 1.6 0 0 1 .033-1.417Z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M91.546 120.536a1.355 1.355 0 0 1 1.052.817 4.24 4.24 0 0 1 .115 1.953 5.219 5.219 0 0 1-1.2-1.353 1.6 1.6 0 0 1 .033-1.417Z",
    "data-name": "Path 371",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.893 80.493a1.194 1.194 0 0 1 1.27.061 3.854 3.854 0 0 1 .994 1.592 4.224 4.224 0 0 1-1.649-.427 1.447 1.447 0 0 1-.615-1.226Z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M48.893 80.493a1.194 1.194 0 0 1 1.27.061 3.854 3.854 0 0 1 .994 1.592 4.224 4.224 0 0 1-1.649-.427 1.447 1.447 0 0 1-.615-1.226Z",
    "data-name": "Path 373",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M255.764 143.072h-1.97l.295-57.308h1.381Z",
    "data-name": "Path 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M256.318 85.486h-3.2l-.4-5.392h4.006Z",
    "data-name": "Path 25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.961 85.486h-2.49l-.311-5.392h3.112Z",
    "data-name": "Path 26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M252.4 79.598h4.658v.898H252.4z",
    "data-name": "Rectangle 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M252.765 84.9h3.924v1.109h-3.924z",
    "data-name": "Rectangle 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M253.028 78.998h3.348v.599h-3.348z",
    "data-name": "Rectangle 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M254.339 78.105h.575v.898h-.575z",
    "data-name": "Rectangle 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M253.082 139.643h3.473v4.827h-3.473z",
    "data-name": "Rectangle 9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M72.379 15.135s.143-2.761-.994-4.314-2.843-.406-4.4-.813.354-2.6-2.133-4.231a2.992 2.992 0 0 0-4.822 1.874c-.417 1.791-.64 2.441-2.06 1.7a1.827 1.827 0 0 0-2.771 1.627c0 1.383.5 2.441-1.137 2.2s-3.127.244-3.411.977 1.421.894-.853.894-3.409.489-3.552.9-2.06.489-3.125.65-1.28.408-1.28.408h33.383a1.309 1.309 0 0 0-.994-1.3c-1.072-.336-.784.078-1.851-.572Z",
    "data-name": "Path 1052",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M222.355 15.227a8.61 8.61 0 0 0-.819-4.1c-.937-1.476-2.343-.386-3.629-.773s.292-2.474-1.757-4.023-3.629.079-3.973 1.781-.527 2.32-1.7 1.616-2.283.232-2.283 1.547.41 2.32-.937 2.088-2.576.232-2.81.929 1.171.85-.7.85-2.809.464-2.926.852-1.7.464-2.575.618-1.054.388-1.054.388h27.507a1.262 1.262 0 0 0-.819-1.238c-.88-.312-.646.082-1.525-.535Z",
    "data-name": "Path 2128",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f1",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.514 12.173s.173-3.363-1.208-5.243-3.456-.491-5.353-.987.429-3.156-2.59-5.144-5.357.1-5.873 2.277-.787 2.966-2.5 2.074a2.226 2.226 0 0 0-3.369 1.979c0 1.682.6 2.966-1.382 2.673s-3.8.293-4.145 1.186 1.728 1.086-1.035 1.086-4.145.6-4.33 1.087-2.507.6-3.8.793-1.555.5-1.555.5h40.6a1.593 1.593 0 0 0-1.212-1.582c-1.3-.397-.954.09-2.248-.699Z",
    "data-name": "Path 959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.514 12.173s.173-3.363-1.208-5.243-3.456-.491-5.353-.987.429-3.156-2.59-5.144-5.357.1-5.873 2.277-.787 2.966-2.5 2.074a2.226 2.226 0 0 0-3.369 1.979c0 1.682.6 2.966-1.382 2.673s-3.8.293-4.145 1.186 1.728 1.086-1.035 1.086-4.145.6-4.33 1.087-2.507.6-3.8.793-1.555.5-1.555.5h40.6a1.593 1.593 0 0 0-1.212-1.582c-1.3-.397-.954.09-2.248-.699Z",
    "data-name": "Path 960",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m313.254 143.038 2.081-1.268 2.081 1.268 2.081-1.268 2.078 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.084 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.081 1.268 2.081-1.268 2.084 1.268",
    "data-name": "Path 236",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m292.452 143.038 2.078-1.268 2.081 1.268 2.081-1.268 2.081 1.268 2.081-1.268",
    "data-name": "Path 62424",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M180 4.163h126.327v174.414H180z",
    "data-name": "Rectangle 9416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.03 39.179 4.522 4.879",
    "data-name": "Path 71993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.695 64.127 2.638 2.848",
    "data-name": "Path 71994"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m271.748 18.194 12.807 13.837",
    "data-name": "Line 1624"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m188.226 40.585 12.807 13.837",
    "data-name": "Line 1726"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m276.603 26.734 12.279 13.251",
    "data-name": "Line 1626"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m201.044 49.121 12.279 13.251",
    "data-name": "Line 1727"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M176.351.5h132.973v182.152H176.351z",
    "data-name": "Rectangle 9436"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57379"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    d: "M241.699 4.164h2.928v174.414h-2.928z",
    "data-name": "Rectangle 9437"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57473",
    transform: "translate(-106.636 -361.745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.324,
    cy: 13.002,
    fill: "#627680",
    stroke: "#707070",
    "data-name": "Ellipse 1418",
    opacity: 0.14,
    rx: 113.324,
    ry: 13.002,
    transform: "translate(130.875 595.468)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57406"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 57349"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    d: "M263.893 514.803h37.6v1.762h-37.6z",
    "data-name": "Rectangle 9448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3dade",
    d: "m287.977 481.835-8.216 34.73h28.247l8.234-33.888Z",
    "data-name": "Path 70408"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m212.298 556.813 11.224 42.715a.544.544 0 0 0 .575.261c.258-.029.444-.19.431-.373l-6.537-43.533Z",
    "data-name": "Path 70584",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M221.492 546.664s3.376 2.338 8.367 16.788c1.663 4.8 11.02 30.706 11.512 32.482s1.477 3.937 2.953 3.937 6.89-6.89 6.231-7.707-3.77-4.1-3.77-4.1-1.86-20.966-2.19-26.872 1.014-13.018-2.1-17.777-16.9.162-16.9.162Z",
    "data-name": "Path 70553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M248.3 588.084a2.2 2.2 0 0 0-1.152 2.136 9.361 9.361 0 0 0 1.644 3.445s-3.12 2.461-4.759 2.623-3.445.492-3.445.984 1.314 1.314 2.131 3.115a40.022 40.022 0 0 0 3.12 5.251c.492.655.817 1.147 2.623.655s5.743-4.1 7.875-5.576 8.529-2.461 9.681-3.283 4.754-6.068 3.115-7.053-2.131.162-4.1.655-7.712-.162-10.828-.817-4.1-.822-4.1-.822Z",
    "data-name": "Path 70554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M245.554 605.266c.108.157.2.285.266.374.492.655.817 1.147 2.623.655s5.743-4.1 7.875-5.576 8.529-2.461 9.681-3.283 4.754-6.068 3.115-7.053a2.757 2.757 0 0 0-.743-.325c.03.108.059.207.089.325.492 1.969-1.152 3.937-2.628 5.414s-6.4 1.147-11.812 3.937a53.012 53.012 0 0 0-8.466 5.532Z",
    "data-name": "Path 70555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M248.894 586.666c-.354-4.316-4.162-23.363-4.281-25.455-.33-5.906 1.014-13.018-2.1-17.777s-16.9.162-16.9.162l-4.119 3.066s3.376 2.338 8.367 16.788c.635 1.836 5.895 21.759 7.859 27.236Z",
    "data-name": "Path 70556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M237.364 462.515a9.479 9.479 0 0 1 .6 3.568c-.148 1.639-1.639 2.382-1.787 1.939a10.653 10.653 0 0 1-.148-2.234v-.6a7.609 7.609 0 0 1-1.339 1.639 2.076 2.076 0 0 1-2.087.743c-.448 0-.6-1.477.153-2.53s3.122-3.421 4.608-2.525Z",
    "data-name": "Path 70557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M240.79 466.383c-1.476-.9-3.721 2.234-7.146 1.476-.438-.094-.6-.743.148-2.229s3.125-2.682 4.316-3.573 2.087-1.639 2.087-2.682-2.682.6-3.445 1.191a24.165 24.165 0 0 1-2.805 1.5l-.645.034c-1.324.084-3.366.32-4.139.984-1.014.881-1.595 3.908-1.836 5.074a93.663 93.663 0 0 0-1.59 2.367c-1.043 1.634-22.029 16.97-22.029 16.97l1.476 13.1 23.816-27.07a6.51 6.51 0 0 1 2.234-1.191 39.626 39.626 0 0 0 5.807-2.087 44.572 44.572 0 0 0 4.169-2.53c1.039-.645.389-.852-.418-1.334Z",
    "data-name": "Path 70558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M215.758 478.569c-5.847 4.429-12.033 8.952-12.033 8.952l1.477 13.1 14.642-16.635Z",
    "data-name": "Path 70559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M208.435 528.115a138.19 138.19 0 0 1 25.755 1.969c15.257 2.461 20.966 5.084 20.508 8.037-1.86 11.979-29.83 51.416-29.83 51.416l.492 5.576s-.984 1.314-4.429 1.476-7.712-4.754-7.712-4.754a25.456 25.456 0 0 0 5.33-8.741c1.476-4.754 13.347-35.46 13.347-35.46a93.134 93.134 0 0 1-32.812.33c-17.226-3.116 9.351-19.849 9.351-19.849Z",
    "data-name": "Path 70560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M234.19 530.086a138.19 138.19 0 0 0-25.755-1.969s-26.577 16.733-9.351 19.849a93.134 93.134 0 0 0 32.812-.33s-11.818 27.11-15.752 37.45l11.571 4.429c8.278-12.52 25.857-44.142 26.984-51.391.458-2.957-5.252-5.58-20.509-8.038Z",
    "data-name": "Path 70561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M224.868 589.536a2.717 2.717 0 0 0-1.477 1.477 21.958 21.958 0 0 0-.822 2.3 30.048 30.048 0 0 1-5.246-1.644 29.251 29.251 0 0 1-3.612-1.969s-1.477.167-1.477 1.152a12.793 12.793 0 0 1-.817 4.429c-.423 1.053-1.324 3.4-1.91 4.922a1.339 1.339 0 0 0 .96 1.782c2.6.576 8.076 1.841 12.762 3.283a34.748 34.748 0 0 0 14.273.822c.822-.162 4.1-2.136 2.623-3.445s-10.173-4.759-11.974-7.058a29.343 29.343 0 0 1-3.283-6.051Z",
    "data-name": "Path 70562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M239.466 602.199c0 1.629-.837 3.248-3.445 3.248a36.279 36.279 0 0 1-13.78-2.953 86.209 86.209 0 0 0-12.171-3.76c-.2.527-.4 1.038-.566 1.476a1.339 1.339 0 0 0 .96 1.782c2.6.576 8.076 1.841 12.762 3.283a34.751 34.751 0 0 0 14.273.822c.822-.162 4.1-2.136 2.623-3.445a4.543 4.543 0 0 0-.656-.453Z",
    "data-name": "Path 70563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M175.293 489.889s-1.787 14.145-1.634 16.822 2.082 25.75 2.53 30.814 2.53 9.523 6.25 10.419 13.4 2.229 17.565 1.191 8.632-10.419 10.119-13.992 2.535-5.808 2.087-6.551a17.518 17.518 0 0 0-2.382-2.382s-3.721-27.069-4.616-34.087-.443-7.589-3.721-10.271-20.242-4.902-26.198 8.037Z",
    "data-name": "Path 70564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M199.114 539.257c-.536.408-1.1.8-1.668 1.161",
    "data-name": "Path 70565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M208.927 527.293a41.2 41.2 0 0 1-8.391 10.8",
    "data-name": "Path 70566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M206.629 527.622a66.871 66.871 0 0 1-10.168 7.707",
    "data-name": "Path 70567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M210.719 445.393a29.359 29.359 0 0 1 1.939 5.36c.443 2.234.6 4.316 1.634 4.764s2.953.6 2.682 1.787-2.234 3.125-2.234 3.125.448 7.146.3 8.485-8.037 1.339-8.48 1.339-4.922 10.572-4.922 10.572l-12.5-6.255 2.382-7.737s-3.868-7.446-4.169-10.719 7.309-9.228 11.615-10.567 11.753-.154 11.753-.154Z",
    "data-name": "Path 70568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m206.555 470.252-3.972-1.132 1.486 5.812Z",
    "data-name": "Path 70569"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M212.195 453.814c.2.842.1 1.585-.217 1.659s-.743-.541-.945-1.378-.1-1.585.217-1.659.743.541.945 1.378Z",
    "data-name": "Path 70570"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M209.68 461.767s1.787 1.344 3.421.748",
    "data-name": "Path 70571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M209.976 442.568s2.087 3.721.6 6.1-5.059 3.42-6.994 5.655-2.953 6.1-3.721 6.4-2.953-4.169-4.321-3.873-3.568 3.445-1.634 6.7a5.655 5.655 0 0 0 5.36 2.83s-5.36 2.83-6.4 2.83-4.169-1.787-5.655-3.445-6.826-6.526-7.151-10.542 5.059-9.08 5.059-9.08-6.4-.448-4.759-2.83 7.441-3.868 7.441-3.868-1.043-3.721.448-4.469 10.567 2.254 10.567 2.254-2.53-3.273 1.043-3.445 9.673 4.314 10.117 8.783Z",
    "data-name": "Path 70572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m198.13 458.731 18.992-7.678",
    "data-name": "Line 1698"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M212.171 449.975a3.352 3.352 0 0 1 2.953 6.009",
    "data-name": "Path 70573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M205.212 484.967s-.148-4.316-1.339-5.507-9.971-6.1-13.992-7.141-8.185.443-10.867 1.339-4.464 3.435-5.522 8.952-1.191 8.928 1.043 9.228 5.36-6.4 12.353-7.742 13.4-.148 14.888.6a5.794 5.794 0 0 0 3.436.271Z",
    "data-name": "Path 70574"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M182.608 480.42c-1.344.492-2.249.846-2.249.846",
    "data-name": "Path 70575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M205.212 484.967s-9.351-5.207-12.8-6.25c-1.787-.541-5 .172-7.653.984",
    "data-name": "Path 70576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M249.412 509.181s-.492 3.1-1.058 3.445-.532-2.874-.532-2.874a11.024 11.024 0 0 1-1.147 2.3c-.438.443-.177-1.9-.177-1.9l.492-2.21Z",
    "data-name": "Path 70577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m243.113 506.13 4.567.074s1.206.172 1.378.861a21.131 21.131 0 0 0 .861 2.239l-7.067-2.067Z",
    "data-name": "Path 70578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M244.746 507.568s6.4-.861 6.551-.345c.128.389.62 3.893.728 5.025a.182.182 0 0 1-.325.123l-1.782-3.081-4.828.345s-1.377-1.202-.344-2.067Z",
    "data-name": "Path 70579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M191.855 488.275s-3.967 2.928-2.589 10.168 11.029 27.069 11.891 28.771 4.651 1.895 6.373 1.378 32.4-12.747 32.4-12.747 3.273-.866 3.79-1.555 3.796-4.306 3.796-4.306 5.168.689 6.374.344-1.206-.689-2.412-1.033c-.93-.266-6.059-2.269-8.367-3.174a1.8 1.8 0 0 0-1.969.418c-1.614 1.654-5.054 5.163-5.709 5.684-.861.689-25.154 4.828-25.154 4.828s-5.689-26.709-7.929-28.949-6.2-1.723-6.2-1.723",
    "data-name": "Path 70580"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M223.899 522.214c8.047-3.189 16.035-6.369 16.035-6.369s3.273-.866 3.79-1.555 3.79-4.306 3.79-4.306 5.173.689 6.4.345-1.206-.689-2.411-1.034c-.93-.266-6.059-2.269-8.367-3.174a1.8 1.8 0 0 0-1.969.418c-1.614 1.654-5.054 5.163-5.709 5.684-.448.359-7.235 1.649-13.648 2.805Z",
    "data-name": "Path 70581"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.99961,
    d: "m188.01 557.201-14.752 44.88a.615.615 0 0 1-.623.25c-.272-.033-.457-.194-.433-.38l9.859-45.778Z",
    "data-name": "Path 70598",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m203.871 556.773 12.138 54.793a.574.574 0 0 0 .614.319c.286-.024.5-.2.5-.414l-6.934-55.587Z",
    "data-name": "Path 70585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.99979,
    d: "m179.96 557.919-16.91 54.665a.57.57 0 0 1-.637.266c-.282-.05-.48-.243-.462-.457l11.82-55.909Z",
    "data-name": "Path 70599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M202.569 546.832s-14.135-3.576-18.156-13.911-5.006-37.072-9.6-39.375-11.72 5.094-12.3 21.748.847 36.432 4.558 40.526c3.283 3.608 7.437 4.5 26.794 4.82 17.29.3 24.938-1.268 27.335-3.5s5.2-9.173 2.043-9.173-16.653-.003-20.674-1.135Z",
    "data-name": "Path 70586"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57394"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M248.701 520.939h167.876v4.84H248.701z",
    "data-name": "Rectangle 9414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M244.2 516.565h176.992v4.374H244.2z",
    "data-name": "Rectangle 9415"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57407"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57323"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M262.771 615.471h-3.208l-1.61-89.692h6.428Z",
    "data-name": "Path 70417"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M406.093 615.471h-3.219l-1.61-89.691h6.439Z",
    "data-name": "Path 70418"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    "data-name": "Group 57475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.696 182.732h62.3M313.557 178.617H375",
    "data-name": "Path 71987",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57480"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M367.426 232.099h-49.094c-.019 0-.034-.059-.034-.132s.015-.132.034-.132h49.094c.019 0 .034.059.034.132s-.015.132-.034.132Z",
    "data-name": "Path 70113",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m331.845 223.109 21.424 21.57a.446.446 0 0 1-.157.11.552.552 0 0 1-.189.082l-21.422-21.57a.447.447 0 0 1 .157-.111.551.551 0 0 1 .187-.081Z",
    "data-name": "Path 71896",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-5",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M5.483 224.731h45.085c.017 0 .031-.043.031-.1s-.014-.1-.031-.1H5.483c-.017 0-.031.043-.031.1s.01.1.031.1Z",
    "data-name": "Path 70113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-5",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m25.978 236.35 19.551-18.231c.007-.007-.016-.044-.055-.086s-.074-.067-.081-.06L25.84 236.203c-.007.007.017.044.055.086s.075.067.082.06Z",
    "data-name": "Path 70113"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessWelcomeBannerMobileOffice);
export default __webpack_public_path__ + "static/media/business-welcome-banner-mobile-office.96d95649a71d0353e402183cc66a2870.svg";
export { ForwardRef as ReactComponent };